import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { HistorialSolicitudesPermisos, HistorialSolicitudesPermisosbyAnio, HorariolaboralPersona, HorariolaboralRegimen, InfanteRegistrado, InformacionHijos, JornadalaboralPersona, LicenciasComisiones, NuevoHorarioCRN, Provincias, SolicitudLicencias, SolicitudLicenciasPost, SolicitudPermisos, SolicitudPermisosPost, SolicitudReintegroVacaciones, SolicitudReplanificacionVacaciones, SolicitudVacaciones, SubTipoPermisos, TabSolicitudActiva, TipoCalamidadDomestica, TipoCertificado, TipoNacimiento, TipoSolicitudPermisos, TipoSubtipoLicencia, InformacionConyugueData, HorariosCambioPRN } from "./TypesSolicitudesPermisos"
import classnames from 'classnames';
import { Button, Form, FormGroup, Label, Input, Card, CardBody, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { PruebaSolucion2, SumarDiasFecha, SumarMesesFecha, overlaps_dates, AgregarHoraAFecha, toHoursAndMinutes, CompareRangeBetweenDatesAlmuerzo, obtener_rango_fechas_horas_no_weekend, GetNPreviousLaboralDay, GetDateObjectFromIsoFormat, GetPreviousLaboralDay, function_calcular_dias, formatDateToString, differenceInDays, obtener_rango_fechas_with_weekend, overlaps_dates_with_weekend, ObtenerFechaLaboralDeSuma, GetDateObjectFromDate, ObtenerFechaFormatoLocal, isWeekend, function_calcular_dias_ordinarios, differenceInBusinessDays, ObtenerFechaFromIsoFormat, function_calcular_dias_feriados, function_calcular_dias_ordinarios_feriados, NewdifferenceInBusinessDays } from 'functions/DatesFunctions';
import AlertNew from 'components/Varios/AlertNew';
import { isWeekday, isFeriadoFilter, isFeriado, } from 'functions/CalendarFunctions';
import { ScrollToTop } from 'functions/LayoutFunctionst';
import { FileInfoUrl, ResponseRequest } from 'components/Types/GeneralTypes';
import { AnularSolicitudPermisos, ObtenerHijosPersona, ObtenerInformacionHorarioLaboral, ObtenerInformacionJornadaLaboral, ObtenerProvincias, SolicitarLicenciasFormulario, SolicitarPermisosAtencionMedicaEdicion, SolicitarPermisosFormulario, SolicitarPermisosLicenciasCreacion } from './FunctionSolicitudPermisos';
import { formatoFecha } from './../../../Admin/Inicio-Admin/Dashboard_Individual_Admin';
import { GetDocumentVistaPrevia } from 'helpers/files'
import { authenticationService } from "services/authentication.service"
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import add from 'date-fns/add'

import differenceInMinutes from 'date-fns/differenceInMinutes'

import { alertService } from 'components/Varios/alert_service';
import SelectItem2 from '../../../Varios/SelectNew';
import Datepicker2 from '../../../Varios/DatepickerNew';
import InputFileUpload2 from '../../../Varios/InputFileUploadNew';

import Swal from 'sweetalert2'

import ExitoSVG from "assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "assets/icons/Permisos/Error.svg"
import AnuncioSVG from "assets/icons/Permisos/Anuncio.svg"
import WarningSVG from "assets/icons/Permisos/Informativa R.svg"
import RecesoSVG from "assets/icons/Permisos/Inicio RECESO.svg"
import Informativa from "assets/icons/Permisos/Informativa N.svg"
import TableSolicitudesPermisosIngresados from './TablaSolicitudesPermisosIngresados';
import { UserData } from '../../../Sidebar/Sidebar_Principal';
import ModalVistaPreviaDocumentos from '../../../Varios/Modals/ModalVistaPreviaDocumentos';
import TableSolicitudesLicenciasIngresadas from './TablaSolicitudesLicenciasIngresadas';
import { EmpleadoHorario, HistorialSolicitudes, NuevoHorario, SolicitudCambioHorarioIngresada, SolicitudPost } from '../../Solicitud Cambio Horario/TypesCambioHorarioPRN';
import { AnularSolicitudCambioHorario, ConfirmarFormulario, SolicitarCambioHorarioCreacion, SolicitarFormulario } from '../../Solicitud Cambio Horario/FunctionSolCambioHorarioPRN';
import AlertNewAction, { TiposAlerta } from '../../../Varios/AlertNewAction';

import ReactDOMServer from 'react-dom/server';
import InputFileUpload3 from 'components/Varios/InputFileUploadNewEditar';
import ModalCambiarHorarioCRN from 'components/Varios/Modals/ModalCambiarHorarioCRN';
import ModalRegistrarInfante from 'components/Varios/Modals/ModalRegistrarInfante';
import DatepickerModal from 'components/Varios/DatePickerModal';
import { boolean } from 'yargs';
import { buscarPersona } from '../../../ContactosEmergencia';
import configData from "config.json";
import Datepicker from '../../../Varios/Datepicker';
import 'assets/scss/SolicitudesPermisos.scss'

import ComunicadoLicEnfermedad from 'assets/img/ComunicadoLicEnfermedad.jpeg'

const API_URL = configData.SERVER_URL

type PropsCardSolicitudes = {
    tiposSolicitudPermisos: TipoSolicitudPermisos[],
    tiposSolicitudLicencias: TipoSolicitudPermisos[],
    solicitudesPermisos: SolicitudPermisos[],
    solicitudesLicencias: SolicitudLicencias[],
    permisosIngresados: SolicitudPermisos[],
    licenciasIngresadas: SolicitudLicencias[],
    permisosCRN: SolicitudPermisos[],
    diasPendientes: number,
    anio: number,
    feriados: Date[],
    onInsertSolicitud: () => Promise<void>,
    esSubrogante: boolean,
    historial: HistorialSolicitudesPermisos[],
    acuerdoMediosElectronicos: boolean,
    horaEntrada: string,
    horaSalida: string,
    horaInicioAlmuerzo: string,
    horaFinAlmuerzo: string
    tiempoAlmuerzo: string,
    esAprobador: boolean,
    solicitudesVacaciones: SolicitudVacaciones[],
    licenciasComisiones: LicenciasComisiones[],
    empHorario: EmpleadoHorario[],
    historialSolicitudesCH: HistorialSolicitudes[],
    solicitudesIngresadasCH: SolicitudCambioHorarioIngresada[],
    horaEntradaRegimen: string,
    horaSalidaRegimen: string,
    subtipoPermisos: SubTipoPermisos[],
    historialbyAnio: HistorialSolicitudesPermisosbyAnio[],
    horarioLaboralRegimen: HorariolaboralRegimen,
    horarioLaboralPersona: HorariolaboralPersona[],
    jornadaLaboralPersona: JornadalaboralPersona[],
    tieneHorarioPermiso: boolean,
    vacacionesIngresadas: SolicitudPermisos[],
    estadoCivil: string,
    tieneInfanteRegistrado: boolean,
    identificacionConyuge: string,
    tipoEventoMatrimonio: string,
    modalidadLicenciaMatrimonio: string,
    tipoIdentificacion: string,
    Conyuge: string,
    idRegimenLaboralS: number,
    listadoHorarios: HorariosCambioPRN[],
    licenciaMaternidad: SolicitudLicencias[],
    fechaFinContrato: string,
}

type stateCardSolicitudes = {
    // solicitudesIngresadas: SolicitudVacaciones[],
    solicitudesReintegro: SolicitudReintegroVacaciones[],
    fechaEvento: Date | string | null,
    fechaDesde: Date | string | null,
    fechaHasta: Date | string | null,
    // fechasEscogidas: Date[],
    loadingCreacion: boolean
}

type stateModalFormulario = {
    url: string,
    loadingFormulario: boolean,
    tituloModal: string,
    content: HTMLElement | undefined
    solicitudNueva?: SolicitudPermisosPost | SolicitudLicenciasPost
}
type stateModal = {
    showModal: boolean,
    solicitud?: SolicitudPermisos,
    content: HTMLElement | undefined

}

type stateModalConfirmacion = {
    showModal: boolean,
    solicitud?: SolicitudPermisosPost | SolicitudLicenciasPost,
    content: HTMLElement | undefined
    tituloModal: string | null,
}

type FechaHora = {
    fecha: Date,
    horaInicio: string,
    horaFin: string
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type stateModalFormularioCH = {
    url: string,
    loadingFormulario: boolean,
    tituloModal: string,
    content: HTMLElement | undefined | React.ReactNode
    solicitudNueva?: SolicitudPost | undefined
}

type stateModalConfirmacionCH = {
    showModal: boolean,
    solicitud?: SolicitudPost,
    content: HTMLElement | undefined
    tituloModal: string | null,
}

type stateModalCH = {
    showModal: boolean,
    solicitud?: SolicitudCambioHorarioIngresada,
    content: HTMLElement | undefined

}

type InformacionConyugue = {
    conyugue?: InformacionConyugueData
}

export default function CardSolicitudesPermisosLicencias(props: PropsCardSolicitudes) {
    const defaultStateModal: stateModal = {
        solicitud: undefined,
        showModal: false,
        content: undefined
    }

    const defaultStateModalConfirmacion: stateModalConfirmacion = {
        solicitud: undefined,
        showModal: false,
        content: undefined,
        tituloModal: 'Solicitud de Permiso de Atención Médica',
    }

    const defaultStateModalFormulario: stateModalFormulario = {
        url: "",
        loadingFormulario: false,
        tituloModal: 'Solicitud de Permiso de Atención Médica',
        content: undefined,
        solicitudNueva: undefined
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {

        loading: false,
        url: ""
    }

    const defaultStateModalFormularioCH: stateModalFormularioCH = {
        url: "",
        loadingFormulario: false,
        tituloModal: 'Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido',
        content: undefined,
        solicitudNueva: undefined
    }

    const defaultStateModalConfirmacionCH: stateModalConfirmacionCH = {
        solicitud: undefined,
        showModal: false,
        content: undefined,
        tituloModal: 'Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido',
    }

    const defaultStateModalCH: stateModalCH = {
        solicitud: undefined,
        showModal: false,
        content: undefined
    }

    const defaultStateInformacionConyugue: InformacionConyugueData = {
        apellidos: "",
        nombres: "",
        nombrecompleto: "",
        numeroidentificacion: "",
        tipoidentificacion: "CED",
        estadocivil: "",
        nombreconyugue: "",
    }


    /*const RANGO_INICIO_ALMUERZO = props.horarioLaboralPersona && props.horarioLaboralPersona[0] ? props.horarioLaboralPersona[0].horaInicioReceso : null;
    const RANGO_FIN_ALMUERZO = props.horarioLaboralPersona && props.horarioLaboralPersona[0] ? props.horarioLaboralPersona[0].horaFinReceso : null;
    
    const RANGO_INICIO_ALMUERZO_REGIMEN = props.horarioLaboralRegimen ? props.horarioLaboralRegimen.horaInicioReceso : null;
    const RANGO_FIN_ALMUERZO_REGIMEN = props.horarioLaboralRegimen ? props.horarioLaboralRegimen.horaFinReceso : null;
    const TIEMPO_ALMUERZO = props.tiempoAlmuerzo || 0;
    
    const HORAS_TRABAJO_POR_DIA = 8;
    
    const HORA_INICIO_PERMITIDA = props.horarioLaboralPersona && props.horarioLaboralPersona[0] ? props.horarioLaboralPersona[0].horaEntrada : null;
    const HORA_FIN_PERMITIDA = props.horarioLaboralPersona && props.horarioLaboralPersona[0] ? props.horarioLaboralPersona[0].horaSalida : null;
    const HORA_INICIO_PERMITIDA_REGIMEN = props.horarioLaboralRegimen ? props.horarioLaboralRegimen.horaEntrada : null;
    const HORA_FIN_PERMITIDA_REGIMEN = props.horarioLaboralRegimen ? props.horarioLaboralRegimen.horaSalida : null;*/
    const HORAS_TRABAJO_POR_DIA = 8;
    const MENSAJE_ADVERTENCIA_USO_MEDIOS_ELECTRONICOS: string = "La solicitud no puede ser envíada por este medio porque no ha firmado el acuerdo de medios electrónicos. Por lo tanto, luego de dar click en aceptar, debe imprimir la presente solicitud, hacerla firmar físicamente por el directivo de su unidad y entregarla en la Unidad de Talento Humano";
    const MENSAJE_ERROR_LIMITES_HORARIO_LABORAL: string = "Las horas de permiso deben estar dentro del rango de su horario de trabajo";



    const [tabActiva, settabActiva] = useState<TabSolicitudActiva>(TabSolicitudActiva.LICENCIAS)

    const [RANGO_INICIO_ALMUERZO, setRangoInicioAlmuerzo] = useState("");
    const [RANGO_FIN_ALMUERZO, setRangoFinAlmuerzo] = useState("");
    const [RANGO_INICIO_ALMUERZO_REGIMEN, setRangoInicioAlmuerzoRegimen] = useState("");
    const [RANGO_FIN_ALMUERZO_REGIMEN, setRangoFinAlmuerzoRegimen] = useState("");
    const [TIEMPO_ALMUERZO, setTiempoAlmuerzo] = useState("");
    const [HORA_INICIO_PERMITIDA, setHoraInicioPermitida] = useState("");
    const [HORA_FIN_PERMITIDA, setHoraFinPermitida] = useState("");
    const [HORA_INICIO_PERMITIDA_REGIMEN, setHoraInicioPermitidaRegimen] = useState("");
    const [HORA_FIN_PERMITIDA_REGIMEN, setHoraFinPermitidaRegimen] = useState("");
    const [Jornadalaboral, setJornadaLaboral] = useState(0);

    const [tiposPermisos, setTiposPermisos] = useState<TipoSolicitudPermisos[]>(props.tiposSolicitudPermisos)
    const [tiposLicencias, setTiposLicencias] = useState<TipoSolicitudPermisos[]>(props.tiposSolicitudLicencias)
    const [empHorario, setEmpHorario] = useState<EmpleadoHorario[]>(props.empHorario)
    const [tipoPermisoSeleccionado, setTipoPermisoSeleccionado] = useState<number>(0);
    const [tipoLicenciaSeleccionado, setTipoLicenciaSeleccionado] = useState<number>(0);
    const [informacionHijos, setInformacionHijos] = useState<Array<InformacionHijos>>([]);
    const [tiposCalamidadDomestica, setTiposCalamidadDomestica] = useState<Array<TipoSubtipoLicencia>>([]);
    const [tiposNacMaternidad, setTiposNacMaternidad] = useState<Array<TipoSubtipoLicencia>>([]);
    const [tiposNacPaternidad, setTiposNacPaternidad] = useState<Array<TipoSubtipoLicencia>>([]);
    const [tiposCertificados, setTiposCertificados] = useState<Array<TipoSubtipoLicencia>>([]);
    const [tiposCertificadosEG, setTiposCertificadosEG] = useState<Array<TipoSubtipoLicencia>>([]);
    const [informacionConyugue, setInformacionConyugue] = useState<InformacionConyugueData>(defaultStateInformacionConyugue);
    const [tipoCalamidadSeleccionado, setTipoCalamidadSeleccionado] = useState<number>(0);
    const [hijoSeleccionado, setHijoSeleccionado] = useState<number>(0);
    const [tipoNacMaternidadSeleccionado, setTipoNacMaternidadSeleccionado] = useState<number>(0);
    const [tipoNacPaternidadSeleccionado, setTipoNacPaternidadSeleccionado] = useState<number>(0);
    const [tipoCertificadoSeleccionado, setTipoCertificadoSeleccionado] = useState<number>(0);
    const [tipoCertificadoEGSeleccionado, setTipoCertificadoEGSeleccionado] = useState<number>(0);
    const [provincias, setProvincias] = useState<Array<Provincias>>([]);
    const [provinciaSeleccionado, setProvinciaSeleccionado] = useState<number>(0);

    const [fechasEscogidas, setfechasEscogidas] = useState<Date[]>([])
    const [fechaPermisoHora, setfechaPermisoHora] = useState<Date | null>()
    const [fechaPermisoHoraEditar, setfechaPermisoHoraEditar] = useState<Date | null>()

    const [habilitarIngresoHoras, sethabilitarIngresoHoras] = useState<boolean>(false)
    const [horaDesde, setHoraDesde] = useState<string>("")
    const [horaHasta, setHoraHasta] = useState<string>("")
    const [horaDesdeCH, setHoraDesdeCH] = useState<string>("")
    const [horaHastaCH, setHoraHastaCH] = useState<string>("")
    const [horaDesdeNuevo, setHoraDesdeNuevo] = useState<string>("")
    const [horaHastaNuevo, setHoraHastaNuevo] = useState<string>("")
    const [observacionPermiso, setObservacionPermiso] = useState<string>("")
    const [cedulaConyugue, setCedulaConyugue] = useState<string>("")
    const [certMedico, setCertMedico] = useState<Array<FileInfoUrl>>([])
    const [certProgCita, setCertProgCita] = useState<Array<FileInfoUrl>>([])
    const [errorHoras, seterrorHoras] = useState<string>("")
    const [errorDias, seterrorDias] = useState<string>("")
    const [horasSolicitadas, setHorasSolicitdas] = useState<string | undefined>(undefined)
    const [horasSolicitadasCH, setHorasSolicitdaCH] = useState<string | undefined>(undefined)
    const [diasSolicitados, setDiasSolicitados] = useState<number>(0)
    const [fraccionHoraDia, setfraccionHoraDia] = useState<number | undefined>(undefined)

    const [fechaDesdeAnterior, setfechaDesdeAnterior] = useState<string | null>(null)
    const [fechaHastaAnterior, setfechaHastaAnterior] = useState<string | null>(null)

    const [fechaDesdeNueva, setfechaDesdeNueva] = useState<Date | null>(null)
    const [fechaEventoEditar, setfechaEventoEditar] = useState<string | Date | null>(null)
    const [fechaInicioEditar, setfechaInicioEditar] = useState <string | Date | null>(null)
    const [fechaFinEditar, setfechaFinEditar] = useState<string | Date | null>(null)
    const [diasSolicitadosEditar, setDiasSolicitadosEditar] = useState<number>(0)
    const [tipoAlumbramiento, setTipoAlumbramiento] = useState<string>("")
    const [motivoRechazo, setMotivoRechazo] = useState<string>("")

    const [mensajePermisoNot, setmensajePermisoNot] = useState<string>("")
    const [mensajeLicenciaNot, setmensajeLicenciaNot] = useState<string>("")
    const [mensajePermisoDev, setmensajePermisoDev] = useState<string>("")
    const [mensajeLicenciaDev, setmensajeLicenciaDev] = useState<string>("")
    const [mensajeError, setmensajeError] = useState<string>("")
    const [mensajeErrorMat, setmensajeErrorMat] = useState<string>("")
    const [mensajeErrorLicencia, setmensajeErrorLicencia] = useState<string>("")
    const [mensajeErrorCRN, setmensajeErrorCRN] = useState<string>("")
    const [mensajeLicenciaComision, setmensajeLicenciaComision] = useState<string>("")
    const [mensajePermisoMedico, setmensajePermisoMedico] = useState<string>("")
    const [mensajeTiempoPermiso, setmensajeTiempoPermiso] = useState<string>("")
    const [mensajeTiempoLicMaternidad, setmensajeTiempoLicMaternidad] = useState<string>("")
    const [mensajeInformacionHijo, setmensajeInformacionHijo] = useState<string>("")
    const [mensajeMarcacionAlmuerzo, setmensajeMarcacionAlmuerzo] = useState<string>("")
    const [mensajeAdvertencia, setMensajeAdvertencia] = useState("");

    const [horarioAlmuerzo, sethorarioAlmuerzo] = useState<boolean>(false)
    const [incluyeHoraAlmuerzo, setincluyeHoraAlmuerzo] = useState<boolean | null>(null)
    const [descontandoTiempoAlmuerzo, setdescontadoTiempoAlmuerzo] = useState<boolean>(false)

    const [stateModalFormulario, setstateModalFormulario] = useState<stateModalFormulario>(defaultStateModalFormulario)
    const [stateModal, setstateModal] = useState<stateModal>(defaultStateModal);
    const [stateModalCH, setstateModalCH] = useState<stateModalCH>(defaultStateModalCH);
    const [stateModalConfirmacion, setstateModalConfirmacion] = useState<stateModalConfirmacion>(defaultStateModalConfirmacion);
    const [stateModalConfirmacionCH, setstateModalConfirmacionCH] = useState<stateModalConfirmacionCH>(defaultStateModalConfirmacionCH);
    const [stateModalEditar, setstateModalEditar] = useState<stateModal>(defaultStateModal);
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)
    const [stateModalFormularioCH, setstateModalFormularioCH] = useState<stateModalFormularioCH>(defaultStateModalFormularioCH)

    const [modalOpenCH, setModalOpenCH] = useState(false);
    const [modalOpenRI, setModalOpenRI] = useState(false);
    const [nuevoHorario, setNuevoHorario] = useState<NuevoHorarioCRN | undefined>(undefined);
    const [infantesRegistrado, setInfantesRegistrado] = useState<InfanteRegistrado[]>([]);

    const [tipoCita, setTipoCita] = useState("");

    const [tipoMatrimonio, setTipoMatrimonio] = useState("");
    const [tipoEventoMatrimonio, setTipoEventoMatrimonio] = useState("");
    const [fechaEventoMenor, setFechaEventoMenor] = useState<boolean>(false);
    const [tipoIdentificacion, setTipoIdentificacion] = useState<string>("CED");
    const [nombreCompletoConyuge, setNombreCompletoConyuge] = useState<string>("")

    const maxLength = 140;

    const defaultState: stateCardSolicitudes = {
        solicitudesReintegro: [],
        fechaEvento: null,
        fechaDesde: null,
        fechaHasta: null,
        loadingCreacion: false
    }

    const [stateCard, setstateCard] = useState<stateCardSolicitudes>(defaultState)
    const datosUsuario = authenticationService.currentUserValue.token;

    useEffect(() => {
        setTiposPermisos(props.tiposSolicitudLicencias);
    }, [props.tiposSolicitudLicencias])

    useEffect(() => {
        setTiposPermisos(props.tiposSolicitudPermisos);
    }, [props.tiposSolicitudPermisos])




    useEffect(() => {
        if (props.horarioLaboralRegimen) {
            setRangoInicioAlmuerzoRegimen(props.horarioLaboralRegimen.horaInicioReceso);
            setRangoFinAlmuerzoRegimen(props.horarioLaboralRegimen.horaFinReceso);
            setHoraInicioPermitidaRegimen(props.horarioLaboralRegimen.horaEntrada);
            setHoraFinPermitidaRegimen(props.horarioLaboralRegimen.horaSalida);
        }
    }, [props.horarioLaboralRegimen]);

    useEffect(() => {
        if (props.jornadaLaboralPersona && props.jornadaLaboralPersona[0]) {
            setJornadaLaboral(props.jornadaLaboralPersona[0].estadojornada);
        }
    }, [props.jornadaLaboralPersona]);


    useEffect(() => {
        setTiempoAlmuerzo(props.tiempoAlmuerzo);
    }, [props.tiempoAlmuerzo]);

    useEffect(() => {
        if (fechaPermisoHora !== null) {
            sethabilitarIngresoHoras(true)
        }
        else {
            setHoraDesde("")
            setHoraHasta("")
            setfraccionHoraDia(undefined)
            setHorasSolicitdas(undefined)
            sethabilitarIngresoHoras(false)

        }
    }, [fechaPermisoHora])

    const handleRadioClick = (value: boolean) => {
        setincluyeHoraAlmuerzo(value);
    };

    const handleTipoPermisoChange = (selectedOption: any) => {
        if (selectedOption === 46 && licenciasTipo3[0] == null) {
            setMensajeAdvertencia("Usted no puede solicitar un cambio de horario, porque no tiene ingresada información sobre su licencia por maternidad. Por favor, acercarse a las oficinas de Talento Humano para registrar la información faltante.")
            showAlertWarning("<p>Usted no puede solicitar un cambio de horario, porque no tiene ingresada información sobre su licencia por maternidad.</p>" +
                "<p><b>Por favor, acercarse a las oficinas de Talento Humano para registrar la información faltante.</b></p>", WarningSVG, true);
        } else if (selectedOption === 46 && permisosCuidadoRN[0]?.estadoPermiso === "J") {
            setMensajeAdvertencia("Usted no puede solicitar un cambio de horario, porque ya tiene ingresada una solicitud que se encuentra pendiente de aprobación.")
            showAlertWarning("<p>Usted no puede solicitar un cambio de horario, porque ya tiene ingresada una solicitud que se encuentra pendiente de aprobación.</p>", WarningSVG, true);
        } else {
            setTipoPermisoSeleccionado(selectedOption);
        } 
    };
    const handleTipoLicenciaChange = (selectedOption: any) => {
        if (selectedOption === 11) {
            showImage(ComunicadoLicEnfermedad, true);
            setTipoLicenciaSeleccionado(selectedOption);
        }
        else {
            setTipoLicenciaSeleccionado(selectedOption);
        }        
    };

    const handleTipoCitaChange = (event) => {
        setTipoCita(event.target.value);
        limpiarFechasCardYModal()
    };

    const handleTipoMatrimonioChange = (event) => {
        setTipoMatrimonio(event.target.value);
        limpiarFechasCardYModal()
    };

    const handleTipoIdentificacionChange = (event) => {
        setTipoIdentificacion(event.target.value);
        limpiarFechasCardYModal()
    };
    //const handleNuevoTipoMatrimonioChange = (event) => {
    //    setNuevoTipoMatrimonio(event.target.value);
    //};

    const handleNuevoTipoAlumbramientoChange = (event) => {
        setTipoAlumbramiento(event.target.value);
        if (event.target.value == "NACIMIENTO 1 HIJO, POR PARTO NATURAL O CESÁREA") {
            setDiasSolicitadosEditar(84);
        } else if (event.target.value == "NACIMIENTO MÚLTIPLE") {
            setDiasSolicitadosEditar(94);
        } else if (event.target.value == "NACIMIENTO DE 1 HIJO POR PARTO NATURAL") {
            setDiasSolicitadosEditar(15);
        } else if (event.target.value == "NACIMIENTO MÚLTIPLE O CESÁREA") {
            setDiasSolicitadosEditar(20);
        } else if (event.target.value == "NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL") {
            setDiasSolicitadosEditar(23);
        } else if (event.target.value == "NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA") {
            setDiasSolicitadosEditar(25);
        } else if (event.target.value == "NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO") {
            setDiasSolicitadosEditar(28);
        } else if (event.target.value == "ADOPCIÓN") {
            setDiasSolicitadosEditar(30);
        }
    };

    const handleMotivoRechazoChange = (event) => {
        setMotivoRechazo(event.target.value);
    };

    const handleTipoEventoMatrimonioChange = (event) => {
        setTipoEventoMatrimonio(event.target.value);
        //limpiarFechasCardYModal()
    };

    const handleTipoCalamidadChange = (selectedOption: any) => {
        setstateCard(defaultState);
        setMensajeAdvertencia("");
        setTipoCalamidadSeleccionado(selectedOption);
    };

    const handleHijoChange = (selectedOption: any) => {
        setHijoSeleccionado(selectedOption);
    };

    const handleProvinciaChange = (selectedOption: any) => {
        setProvinciaSeleccionado(selectedOption);
    };

    const handleTipoNacMaternidadChange = (selectedOption: any) => {
        setTipoNacMaternidadSeleccionado(selectedOption);
    };

    const handleTipoNacPaternidadChange = (selectedOption: any) => {
        setTipoNacPaternidadSeleccionado(selectedOption);
    };

    const handleTipoCertificadoChange = (selectedOption: any) => {
        setTipoCertificadoSeleccionado(selectedOption);
    };

    const handleTipoCertificadoEGChange = (selectedOption: any) => {
        setTipoCertificadoEGSeleccionado(selectedOption);
    };

    const handleFileUpload = (tipoEvidencia, uploadFile) => {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo: FileInfoUrl = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, url: src, nombreFile: uploadFile.name };
        setCertMedico([fileInfo]);
    };

    const handleFileUploadProgCita = (tipoEvidencia, uploadFile) => {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo: FileInfoUrl = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, url: src, nombreFile: uploadFile.name };
        setCertProgCita([fileInfo]);
    };

    const handleObservacionChange = (event) => {
        const valor = event.target.value.toUpperCase();
        if (valor.length <= maxLength) {
            setObservacionPermiso(valor);
        }
    };

    const handleConyugeChange = (event) => {
        const valor = event.target.value.toUpperCase();
        if (valor.length <= maxLength) {
            setNombreCompletoConyuge(valor);
        }

    };

    const handlePasaporteConyugeChange = (event) => {
        const valor = event.target.value.toUpperCase();
        if (valor.length <= maxLength) {
            setCedulaConyugue(valor);
        }

    };

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            html: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    async function showAlertWarning(message, imageSrc, isError) {
        Swal.fire({
            html: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isError ? "Error" : "Warning",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    async function showImage(imageSrc, isError) {
        Swal.fire({
            imageUrl: `${imageSrc}`,
            imageHeight: 600,
            imageAlt: isError ? "Error" : "Warning",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
            width: '800px',  // Aumenta el ancho del contenedor
            //padding: '3em',  // Aumenta el padding interno                        
        });
    }

    const ToogleTab = useCallback(
        (tabDeseada: TabSolicitudActiva, subTab: boolean) => {

            if (tabDeseada !== tabActiva) {
                if (!subTab) {
                    settabActiva(tabDeseada);
                }
            }
        }
        , [tabActiva])


    const TabNavegacion = useCallback(
        (nombre: string, tipodeTab: TabSolicitudActiva, subTab: boolean, estilosClassName?: string) => {

            var mensajeToolTip = "";

            if (!subTab) {
                switch (tipodeTab) {
                    case TabSolicitudActiva.PERMISOS:
                        mensajeToolTip = "Solicitud de permisos: Permiso para atención médica (citas), Permiso para matriculación de hijos o relacionados"
                        break;
                    case TabSolicitudActiva.LICENCIAS:
                        mensajeToolTip = "Solicitud de licencias con remuneración: Licencia por maternidad, Licencia por paternidad, Licencia por enfermedad física o psicológica, Licencia por enfermedad catastrófica o grave, Licencia por calamidad doméstica, Licencia por matrimonio"
                        break;

                    default:
                        break;
                }
            }

            return (
                <NavLink
                    className={classnames({ active: tabActiva === tipodeTab }) + " " + estilosClassName ?? ""}
                    onClick={() => { ToogleTab(tipodeTab, subTab) }}
                    data-toggle="tooltip"
                    data-placement="top"
                    title={mensajeToolTip}
                >
                    {nombre}
                </NavLink>
            )
        }, [tabActiva])

    useEffect(() => {
        const obtenerDatos = async () => {
            if (tipoLicenciaSeleccionado === 17) {
                setTiposCalamidadDomestica(props.subtipoPermisos.filter(p => p.idtipopermiso == tipoLicenciaSeleccionado));
            } else if (tipoLicenciaSeleccionado == 3) {
                setTiposNacMaternidad(props.subtipoPermisos.filter(p => p.idtipopermiso == tipoLicenciaSeleccionado));
            } else if (tipoLicenciaSeleccionado == 12) {
                setTiposNacPaternidad(props.subtipoPermisos.filter(p => p.idtipopermiso == tipoLicenciaSeleccionado));
            } else if (tipoLicenciaSeleccionado == 11) {
                setTiposCertificados(props.subtipoPermisos.filter(p => p.idtipopermiso == tipoLicenciaSeleccionado));
            } else if (tipoLicenciaSeleccionado == 16) {
                setTiposCertificadosEG(props.subtipoPermisos.filter(p => p.idtipopermiso == tipoLicenciaSeleccionado));
            }
        };
        obtenerDatos();
    }, [tipoLicenciaSeleccionado]);


    useEffect(() => {
        const obtenerDatos = async () => {
            if (tipoPermisoSeleccionado === 29) {
                const informacionHijos = await ObtenerHijosPersona();
                setInformacionHijos(informacionHijos.dataResponse);
            }
        };
        obtenerDatos();
    }, [tipoPermisoSeleccionado]);


    useEffect(() => {
        const obtenerDatos = async () => {
            if (tipoCalamidadSeleccionado == 16) {
                const provincias = await ObtenerProvincias();
                setProvincias(provincias.dataResponse);
            }
        };
        obtenerDatos();
    }, [tipoCalamidadSeleccionado]);

    const GetDiferenciaLicenciaSeleccion = useCallback(
        () => {
            const { fechaDesde, fechaHasta } = stateCard;

            const feriados = props.feriados.map((val, ind) => {
                return new Date(val)
            })

            if (fechaDesde && typeof (fechaDesde) !== "string" && fechaHasta && typeof (fechaHasta) !== "string") {
                return function_calcular_dias_feriados(fechaDesde, fechaHasta, feriados)
            }
            else {
                return 0;
            }

        }, [stateCard.fechaDesde, stateCard.fechaHasta, props.feriados])

    const GetDiferenciaLicenciaSeleccionOrdinarios = useCallback(
        () => {
            const { fechaDesde, fechaHasta } = stateCard;

            const feriados = props.feriados.map((val, ind) => {
                return new Date(val)
            })

            if (fechaDesde && typeof (fechaDesde) !== "string" && fechaHasta && typeof (fechaHasta) !== "string") {
                return function_calcular_dias_ordinarios_feriados(fechaDesde, fechaHasta, feriados)
            }
            else {
                return 0;
            }

        }, [stateCard.fechaDesde, stateCard.fechaHasta, props.feriados])

    useEffect(() => {
        if (tipoLicenciaSeleccionado !== 0) {
            var dias = GetDiferenciaLicenciaSeleccion();
            if (dias != undefined && (tipoLicenciaSeleccionado == 17 || tipoLicenciaSeleccionado == 25)) {
                dias = GetDiferenciaLicenciaSeleccionOrdinarios();
                setDiasSolicitados(dias);
            } else {                
                setDiasSolicitados(dias);
            }
        }
        if (tipoLicenciaSeleccionado == 17 && tipoCalamidadSeleccionado != 0 && tipoCalamidadSeleccionado == 24 && diasSolicitados > 8) {
            seterrorDias("Usted se está sobrepasando los días máximo de la licencia.")
        } else if (tipoLicenciaSeleccionado == 17 && tipoCalamidadSeleccionado != 0 && tipoCalamidadSeleccionado == 25 && diasSolicitados > 3) {
            seterrorDias("Usted se está sobrepasando los días máximo de la licencia.")
        } else if (tipoLicenciaSeleccionado == 17 && tipoCalamidadSeleccionado != 0 && tipoCalamidadSeleccionado == 22 && diasSolicitados > 3) {
            seterrorDias("Usted se está sobrepasando los días máximo de la licencia.")
        } else if (tipoLicenciaSeleccionado == 17 && tipoCalamidadSeleccionado != 0 && tipoCalamidadSeleccionado == 23 && diasSolicitados > 2) {
            seterrorDias("Usted se está sobrepasando los días máximo de la licencia.")
        } else if (tipoLicenciaSeleccionado == 17 && tipoCalamidadSeleccionado != 0 && tipoCalamidadSeleccionado == 26 && diasSolicitados > 8) {
            seterrorDias("Usted se está sobrepasando los días máximo de la licencia.")
        } else if (tipoLicenciaSeleccionado == 17 && tipoCalamidadSeleccionado != 0 && tipoCalamidadSeleccionado == 27 && diasSolicitados > 2) {
            seterrorDias("Usted se está sobrepasando los días máximo de la licencia.")
        } else if (tipoLicenciaSeleccionado == 11 && tipoCertificadoSeleccionado != 0 && tipoCertificadoSeleccionado == 8 && diasSolicitados > 3) {
            seterrorDias("Usted se está sobrepasando los días máximo de la licencia.")
        } else if (tipoLicenciaSeleccionado == 11 && tipoCertificadoSeleccionado != 0 && tipoCertificadoSeleccionado == 9 && diasSolicitados > 3) {
            seterrorDias("Usted se está sobrepasando los días máximo de la licencia.")
        } else if (tipoLicenciaSeleccionado == 11 && tipoCertificadoSeleccionado != 0 && tipoCertificadoSeleccionado == 10 && diasSolicitados > 92) {
            seterrorDias("Usted se está sobrepasando los días máximo de la licencia.")
        } else {
            seterrorDias("")
        }

    }, [tipoLicenciaSeleccionado, tipoCalamidadSeleccionado, GetDiferenciaLicenciaSeleccion, diasSolicitados, provinciaSeleccionado, tipoNacMaternidadSeleccionado, tipoNacPaternidadSeleccionado, tipoCertificadoSeleccionado])

    useEffect(() => {
        // Convertir horasSolicitadas a número
        var horasSolicitadasNumero = 0;
        if (horasSolicitadas !== undefined) {
            // Dividir el string en "h" para obtener las horas y los minutos
            const partes = horasSolicitadas.split("h");
            if (partes.length === 2) {
                const horas = parseInt(partes[0], 10);
                const minutos = parseInt(partes[1], 10) || 0; // Si no hay minutos, se asume 0
                horasSolicitadasNumero = horas * 60 + minutos;
            }
        }

        // Verificar si tipoPermisoSeleccionado es 29 y horasSolicitadas es mayor que 2
        if (tipoPermisoSeleccionado === 29 && horasSolicitadasNumero > 120) {
            seterrorHoras("Usted está sobrepasando las horas máximas permitidas para este tipo de permiso.");
        } else if ((tipoLicenciaSeleccionado === 36 || tipoLicenciaSeleccionado === 37) && horasSolicitadasNumero > 120) {
            seterrorHoras("Usted está sobrepasando las horas máximas permitidas para este tipo de licencia.");
        } else {
            seterrorHoras("");
        }
    }, [tipoPermisoSeleccionado, horasSolicitadas, tipoLicenciaSeleccionado]);


    useEffect(() => {
        const tienePermisoEnMismoDia = props.permisosIngresados.some(val => {
            const fechaDesde: Date | undefined = GetDateObjectFromIsoFormat(val.fechaDesde);

            if (fechaDesde && val.tipoPermiso === 29 && fechaPermisoHora) {
                const fechaDesdeTimestamp = fechaDesde.getTime();
                const fechaPermisoHoraTimestamp = fechaPermisoHora.getTime();

                return hijoSeleccionado === val.idDependiente && fechaDesdeTimestamp === fechaPermisoHoraTimestamp;
            }

            return false;
        });

        const tienePermisoEnMismoDiaHistorial = props.historial.some(mes => {
            return Array.isArray(mes.value) && mes.value.some(val => {
                const fechaDesde = new Date(val.fechaInicio);

                if (fechaDesde && val.idDependiente !== null && fechaPermisoHora) {
                    const fechaDesdeTimestamp = fechaDesde.getTime();
                    const fechaPermisoHoraTimestamp = fechaPermisoHora.getTime();

                    return hijoSeleccionado === val.idDependiente && fechaDesdeTimestamp === fechaPermisoHoraTimestamp;
                }

                return false;
            });
        });

        if (tienePermisoEnMismoDia || tienePermisoEnMismoDiaHistorial) {
            setmensajeErrorMat("No puede ingresar este tipo de permiso por el mismo hijo/a en el mismo día");
            showAlertWarning("No puede ingresar este tipo de permiso por el mismo hijo/a en el mismo día", WarningSVG, true);
        } else {
            setmensajeErrorMat("");
        }
    }, [props.permisosIngresados, hijoSeleccionado, fechaPermisoHora, props.historial]);


    useEffect(() => {
        let mensaje = "";

        const obtenerMensaje = (permiso) => {
            const duracion = permiso.tipoduracion === 'V' ? "hasta " : "";
            if (permiso.diasmax) {
                return `Usted puede tomar ${duracion}${permiso.diasmax} días de licencia.`;
            } else if (permiso.horasmax) {
                return `Usted puede tomar ${duracion}${permiso.horasmax} horas de licencia.`;
            } else if (permiso.mesesmax) {
                return `Usted puede tomar ${duracion}${permiso.mesesmax} meses de licencia.`;
            }
            return "";
        };

        if (tipoLicenciaSeleccionado === 17 && tipoCalamidadSeleccionado !== 0) {
            const permiso = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoCalamidadSeleccionado);
            if (permiso && permiso.idprnsubtipopermisos === 16) {
                mensaje = obtenerMensaje(permiso) + " Si debe de trasladarse a otra provincia se le añadirá un día más.";
            } else if (permiso) {
                mensaje = obtenerMensaje(permiso);
            }
        } else if (tipoLicenciaSeleccionado === 3 && tipoNacMaternidadSeleccionado !== 0) {
            const permiso = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoNacMaternidadSeleccionado);
            if (permiso) {
                mensaje = obtenerMensaje(permiso);
            }
        } else if (tipoLicenciaSeleccionado === 12 && tipoNacPaternidadSeleccionado !== 0) {
            const permiso = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoNacPaternidadSeleccionado);
            if (permiso) {
                mensaje = obtenerMensaje(permiso);
            }
        } else if (tipoLicenciaSeleccionado === 11 && tipoCertificadoSeleccionado !== 0) {
            const permiso = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoCertificadoSeleccionado);
            if (permiso) {
                mensaje = obtenerMensaje(permiso);
            }
        } else if (tipoLicenciaSeleccionado === 16 && tipoCertificadoEGSeleccionado !== 0) {
            const permiso = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoCertificadoEGSeleccionado);
            if (permiso) {
                mensaje = obtenerMensaje(permiso);
            }

        } else if (tipoLicenciaSeleccionado === 25) {
            const permiso = props.tiposSolicitudLicencias.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado);
            if (permiso) {
                mensaje = "<p>Usted puede solicitar tres días hábiles continuos, antes o después de la celebración del matrimonio/unión de hecho.</p>" +
                    "<p><b>Una vez concedida esta licencia se deberá justificar con el documento habilitante ante la DTH en máximo 3 días después de su reintegro al puesto.</b></p>";

            }

        }

        if (mensaje && mensaje !== mensajeTiempoPermiso) {
            Swal.fire({
                html: mensaje, // Cambiado de "text" a "html" para soportar formato HTML
                imageUrl: `${AnuncioSVG}`,
                imageHeight: 100, // Ajusta el tamaño según sea necesario
                imageAlt: "Anuncio",
                confirmButtonText: "Entendido",
                confirmButtonColor: "#243165",
                didClose: () => {
                    // Elimina el mensajeTiempoPermiso aquí
                    setmensajeTiempoPermiso("");
                }
            });
            setmensajeTiempoPermiso(mensaje);

        }
    }, [tipoLicenciaSeleccionado, tipoCalamidadSeleccionado, tipoNacMaternidadSeleccionado, tipoNacPaternidadSeleccionado, tipoCertificadoSeleccionado, props.subtipoPermisos, tipoCertificadoEGSeleccionado]);

    useEffect(() => {
        if (tipoLicenciaSeleccionado == 3 && stateCard.fechaHasta != null) {
            const fecha1 = SumarDiasFecha(stateCard.fechaHasta, 1);
            const fecha2 = SumarDiasFecha(stateCard.fechaHasta, 456);
            setmensajeTiempoLicMaternidad("Usted gozará del período para el cuidado del recién nacido desde el " + formatDateToString(fecha1) + " hasta el " + formatDateToString(fecha2) + ", en el horario laboral asignado automáticamente de 08:00 a 14:30." + " Si desea cambiar el horario para el cuidado del recién nacido, deberá presentar una solicitud por escrito a la DTH indicando el horario al que se acogerá, previo a su incorporación a la institución.");
        } else {
            setmensajeTiempoLicMaternidad("")
        }

    }, [tipoLicenciaSeleccionado, stateCard.fechaHasta])

    useEffect(() => {

        var fechasPermisosMedicos: FechaHora[] = [];
        var pidioPermisoEnFechaEscogida = false;
        var horaInicioPermisoMedico: string[] = [];
        var horaFinPermisoMedico: string[] = [];
        var fechaPermisoCoincideFechaEscogida: FechaHora[] = [];

        sethorarioAlmuerzo(false)

        if (fechaPermisoHora !== null && fechaPermisoHora !== undefined && (props.solicitudesVacaciones.length > 0 || props.solicitudesPermisos.length > 0 || props.permisosIngresados.length > 0 || props.licenciasIngresadas.length > 0)) {

            props.solicitudesVacaciones.map((val, ind) => {
                if (val.permiso === true) {
                    fechasPermisosMedicos = [...fechasPermisosMedicos, ...obtener_rango_fechas_horas_no_weekend(val.fechaInicio, val.fechaFin, val.horadesde, val.horahasta)]
                }

            })

            props.solicitudesPermisos.map((val, ind) => {
                const fechaDesde: Date | undefined = GetDateObjectFromIsoFormat(val.fechaDesde);
                const fechaHasta: Date | undefined = GetDateObjectFromIsoFormat(val.fechaHasta);
                if (fechaDesde !== undefined && fechaHasta !== undefined && val.horaDesde !== null && val.horaHasta !== null) {
                    fechasPermisosMedicos = [...fechasPermisosMedicos, ...obtener_rango_fechas_horas_no_weekend(fechaDesde, fechaHasta, val.horaDesde, val.horaHasta)]
                }

            })
            props.permisosIngresados.map((val, ind) => {
                const fechaDesde: Date | undefined = GetDateObjectFromIsoFormat(val.fechaDesde);
                const fechaHasta: Date | undefined = GetDateObjectFromIsoFormat(val.fechaHasta);
                if (fechaDesde !== undefined && fechaHasta !== undefined && val.horaDesde !== null && val.horaHasta !== null) {
                    fechasPermisosMedicos = [...fechasPermisosMedicos, ...obtener_rango_fechas_horas_no_weekend(fechaDesde, fechaHasta, val.horaDesde, val.horaHasta)]
                }
            })

            props.historial.map((mes, ind) => {
                mes.value.map((val, ind) => {
                    const fechaDesde: Date | undefined = GetDateObjectFromIsoFormat(val.fechaInicio);
                    const fechaHasta: Date | undefined = GetDateObjectFromIsoFormat(val.fechafin);
                    if (fechaDesde !== undefined && fechaHasta !== undefined && val.horaInicio !== null && val.horaFin !== null && val.diasSolicitados !== null) {
                        fechasPermisosMedicos = [...fechasPermisosMedicos, ...obtener_rango_fechas_horas_no_weekend(fechaDesde, fechaHasta, val.horaInicio, val.horaFin)]

                    }
                })
            })

            const fechaEscogida = new Date(fechaPermisoHora);

            fechaPermisoCoincideFechaEscogida = fechasPermisosMedicos.filter((v) => v.fecha.getTime() === fechaEscogida.getTime());

            pidioPermisoEnFechaEscogida = fechaPermisoCoincideFechaEscogida.length > 0;

            for (let index = 0; index < fechaPermisoCoincideFechaEscogida.length; index++) {
                const fechaPermisoMedico = fechaPermisoCoincideFechaEscogida[index];
                horaInicioPermisoMedico.push(fechaPermisoMedico.horaInicio);
                horaFinPermisoMedico.push(fechaPermisoMedico.horaFin);
            }

            if (pidioPermisoEnFechaEscogida/* && tipoLicenciaSeleccionado !== 25*/) {

                var mensajeHorarios: string = "";

                for (let index = 0; index < fechaPermisoCoincideFechaEscogida.length; index++) {
                    const fechaPermisoMedico = fechaPermisoCoincideFechaEscogida[index];
                    mensajeHorarios += `${fechaPermisoMedico.horaInicio} - ${fechaPermisoMedico.horaFin}`
                    if (index != fechaPermisoCoincideFechaEscogida.length - 1) {
                        mensajeHorarios += "; "
                    }
                }

                if (mensajeHorarios !== mensajePermisoMedico) {
                    setmensajePermisoMedico(`Ha escogido una fecha en la que tiene permiso o licencia en el siguiente horario: ${mensajeHorarios}`);
                }


            } else if (!pidioPermisoEnFechaEscogida) {
                setmensajePermisoMedico("")
            }
        }

        if (fechaPermisoHora !== null && fechaPermisoHora !== undefined && (horaDesde !== undefined && horaDesde !== "") && (horaHasta === undefined || (horaHasta !== undefined && horaHasta === ""))) {
            const fechaEscogida = new Date(fechaPermisoHora);
            const [hora_inicio_permitida, minuto_inicio_permitido] = HORA_INICIO_PERMITIDA.split(":");
            const [hora_fin_permitida, minuto_fin_permitido] = HORA_FIN_PERMITIDA.split(":");
            const horaMinima = add(fechaEscogida, { hours: +hora_inicio_permitida, minutes: +minuto_inicio_permitido });
            const horaMaxima = add(fechaEscogida, { hours: +hora_fin_permitida, minutes: +minuto_fin_permitido - 1 });


            const [hora_desde_seleccionada, minuto_desde] = horaDesde.split(":");
            const [hora_hasta_seleccionada, minuto_hasta] = horaHasta.split(":");

            const horaDesdeSeleccionada = add(fechaEscogida, { hours: +hora_desde_seleccionada, minutes: +minuto_desde });
            const horaHastaSeleccionada = add(fechaEscogida, { hours: +hora_hasta_seleccionada, minutes: +minuto_hasta });

            var horaInterfiereConPermisoMedico = false;

            if (pidioPermisoEnFechaEscogida) {

                for (let index = 0; index < horaInicioPermisoMedico.length; index++) {

                    const [hora_inicio_permisoMedico, minuto_inicio_permisoMedico] = horaInicioPermisoMedico[index].split(":");
                    const [hora_fin_permisoMedico, minuto_fin_permisoMedico] = horaFinPermisoMedico[index].split(":");

                    const horaDesdePermisoMedico = add(fechaEscogida, { hours: +hora_inicio_permisoMedico, minutes: +minuto_inicio_permisoMedico });
                    const horaHastaPermisoMedico = add(fechaEscogida, { hours: +hora_fin_permisoMedico, minutes: +minuto_fin_permisoMedico });

                    const horaDesdeInterfierePermisoMedico = horaDesdeSeleccionada.getTime() >= horaDesdePermisoMedico.getTime() && horaDesdeSeleccionada.getTime() < horaHastaPermisoMedico.getTime();
                    const horaHastaInterfierePermisoMedico = horaHastaSeleccionada.getTime() <= horaHastaPermisoMedico.getTime() && horaHastaSeleccionada.getTime() > horaDesdePermisoMedico.getTime();

                    horaInterfiereConPermisoMedico = horaDesdeInterfierePermisoMedico || horaHastaInterfierePermisoMedico;

                    if (horaInterfiereConPermisoMedico) {
                        index = horaInicioPermisoMedico.length;
                    }
                }

            }
            if (horaInterfiereConPermisoMedico) {
                seterrorHoras("La hora escogida interfiere con un permiso ingresado")
            }
            else if (horaDesdeSeleccionada.getTime() < horaMinima.getTime() || horaDesdeSeleccionada.getTime() > horaMaxima.getTime()) {
                seterrorHoras(MENSAJE_ERROR_LIMITES_HORARIO_LABORAL);
            }
            else if (horaDesdeSeleccionada.getTime() == horaHastaSeleccionada.getTime()) {
                seterrorHoras("La hora desde del permiso debe ser diferente de la hora hasta");
            }
            else {
                seterrorHoras("")
                setHorasSolicitdas(undefined);
                setfraccionHoraDia(undefined);
            }
        } else if (fechaPermisoHora !== null && fechaPermisoHora !== undefined && (horaDesde !== undefined && horaDesde !== "") && (horaHasta !== undefined && horaHasta !== "")) {

            const fechaEscogida = new Date(fechaPermisoHora);
            const [hora_inicio_permitida, minuto_inicio_permitido] = HORA_INICIO_PERMITIDA.split(":");
            const [hora_fin_permitida, minuto_fin_permitido] = HORA_FIN_PERMITIDA.split(":");

            const [hora_desde_seleccionada, minuto_desde] = horaDesde.split(":");
            const [hora_hasta_seleccionada, minuto_hasta] = horaHasta.split(":");


            const [hora_entrada, minuto_entrada] = HORA_INICIO_PERMITIDA.split(":");
            const [hora_salida, minuto_salida] = HORA_FIN_PERMITIDA.split(":");


            const [hora_inicio_almuerzo, minuto_inicio_almuerzo] = RANGO_INICIO_ALMUERZO.split(":");
            const [hora_fin_almuerzo, minuto_fin_almuerzo] = RANGO_FIN_ALMUERZO.split(":");

            const horaMinima = add(fechaEscogida, { hours: +hora_inicio_permitida, minutes: +minuto_inicio_permitido });
            const horaMaxima = add(fechaEscogida, { hours: +hora_fin_permitida, minutes: +minuto_fin_permitido });


            const tiempoAlmuerzo = TIEMPO_ALMUERZO.split(':');
            const tiempoAlmuerzoMinutos = (+tiempoAlmuerzo[0]) * 60 + (+tiempoAlmuerzo[1]);

            const horaMaximaSinAlmuerzo = add(fechaEscogida, { hours: +hora_fin_permitida, minutes: +minuto_fin_permitido - tiempoAlmuerzoMinutos });


            const horaDesdeSeleccionada = add(fechaEscogida, { hours: +hora_desde_seleccionada, minutes: +minuto_desde });
            const horaHastaSeleccionada = add(fechaEscogida, { hours: +hora_hasta_seleccionada, minutes: +minuto_hasta });


            const horaEntradaDelDia = add(fechaEscogida, { hours: +hora_entrada, minutes: +minuto_entrada })
            const horaSalidaDelDia = add(fechaEscogida, { hours: +hora_salida, minutes: +minuto_salida })

            const diferenciaHorasHorarioLaboral = (+differenceInMinutes(horaSalidaDelDia, horaEntradaDelDia)) / 60;

            var horaInterfiereConPermisoMedico = false;

            if (pidioPermisoEnFechaEscogida) {

                for (let index = 0; index < horaInicioPermisoMedico.length; index++) {

                    const [hora_inicio_permisoMedico, minuto_inicio_permisoMedico] = horaInicioPermisoMedico[index].split(":");
                    const [hora_fin_permisoMedico, minuto_fin_permisoMedico] = horaFinPermisoMedico[index].split(":");


                    const horaDesdePermisoMedico = add(fechaEscogida, { hours: +hora_inicio_permisoMedico, minutes: +minuto_inicio_permisoMedico });
                    const horaHastaPermisoMedico = add(fechaEscogida, { hours: +hora_fin_permisoMedico, minutes: +minuto_fin_permisoMedico });


                    const horaDesdeInterfierePermisoMedico = horaDesdePermisoMedico.getTime() <= horaDesdeSeleccionada.getTime() && horaDesdeSeleccionada.getTime() < horaHastaPermisoMedico.getTime();
                    const horaHastaInterfierePermisoMedico = horaDesdePermisoMedico.getTime() < horaHastaSeleccionada.getTime() && horaHastaSeleccionada.getTime() <= horaHastaPermisoMedico.getTime();

                    horaInterfiereConPermisoMedico = horaDesdeInterfierePermisoMedico || horaHastaInterfierePermisoMedico;

                    if (horaInterfiereConPermisoMedico) {
                        index = horaInicioPermisoMedico.length;
                    }

                }
            }
            if (horaHastaSeleccionada.getTime() < horaDesdeSeleccionada.getTime()) {
                seterrorHoras("La hora de fin no puede ser menor a la hora de inicio del permiso");
            }
            else if (horaInterfiereConPermisoMedico) {
                seterrorHoras("La hora escogida interfiere con un permiso existente")
            }

            else if (horaHastaSeleccionada.getTime() == horaDesdeSeleccionada.getTime()) {
                seterrorHoras("La hora de fin no puede ser igual a la hora de inicio del permiso");
            }
            else if (!(tipoPermisoSeleccionado === 29 || tipoLicenciaSeleccionado === 36 || tipoLicenciaSeleccionado === 37) && horaDesdeSeleccionada.getTime() === horaMinima.getTime() && (horaHastaSeleccionada.getTime() === horaMaxima.getTime() || horaHastaSeleccionada.getTime() === horaMaximaSinAlmuerzo.getTime()) && diferenciaHorasHorarioLaboral >= HORAS_TRABAJO_POR_DIA) {
                setfraccionHoraDia(1);
                setHorasSolicitdas(HORAS_TRABAJO_POR_DIA + "h00m");
                seterrorHoras("")
            } else {

                if (horaHastaSeleccionada.getTime() < horaDesdeSeleccionada.getTime()) {
                    seterrorHoras(MENSAJE_ERROR_LIMITES_HORARIO_LABORAL);

                }
                else if (horaDesdeSeleccionada.getTime() < horaMinima.getTime()) {
                    seterrorHoras(MENSAJE_ERROR_LIMITES_HORARIO_LABORAL);
                }
                else if (horaHastaSeleccionada.getTime() > horaMaxima.getTime()) {
                    seterrorHoras(MENSAJE_ERROR_LIMITES_HORARIO_LABORAL);
                }

                else {
                    //seterrorHoras("")
                    var valorRestarEnMinutos = 0;
                    const horaInicioAlmuerzo = add(fechaEscogida, { hours: +hora_inicio_almuerzo, minutes: +minuto_inicio_almuerzo })
                    const horaFinAlmuerzo = add(fechaEscogida, { hours: +hora_fin_almuerzo, minutes: +minuto_fin_almuerzo })

                    const horamaximaInicioAlmuerzo = add(horaFinAlmuerzo, { minutes: -tiempoAlmuerzoMinutos })
                    const horamaximaFinalizaAlmuerzo = add(horaInicioAlmuerzo, { minutes: +tiempoAlmuerzoMinutos })

                    const diferenciaMinutos = +differenceInMinutes(horaHastaSeleccionada, horaDesdeSeleccionada);

                    const solicitaPermisoEnHorarioAlmuerzo = CompareRangeBetweenDatesAlmuerzo(horaInicioAlmuerzo, horaFinAlmuerzo, horaDesdeSeleccionada, horaHastaSeleccionada) && diferenciaMinutos > tiempoAlmuerzoMinutos

                    const descuentaTiempoAlmuerzo = solicitaPermisoEnHorarioAlmuerzo && horaDesdeSeleccionada.getTime() <= horamaximaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() > horamaximaInicioAlmuerzo.getTime()// horaDesdeSeleccionada.getTime() <= horamaximaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() >= horamaximaFinalizaAlmuerzo.getTime();

                    const PreguntarIncluyeAlmuerzo1 = horaDesdeSeleccionada.getTime() >= horaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() <= horaFinAlmuerzo.getTime()

                    const PreguntarIncluyeAlmuerzo2 = horaDesdeSeleccionada.getTime() < horaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() >= horamaximaFinalizaAlmuerzo.getTime() && horaHastaSeleccionada.getTime() <= horamaximaInicioAlmuerzo.getTime();

                    const PreguntarIncluyeAlmuerzo3 = horaDesdeSeleccionada.getTime() >= horaInicioAlmuerzo.getTime() && horaDesdeSeleccionada.getTime() <= horamaximaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() > horamaximaInicioAlmuerzo.getTime()

                    const PermisoIncluyeTodaLaHoraAlmuerzo = (horaDesdeSeleccionada.getTime() <= horaInicioAlmuerzo.getTime() && horaFinAlmuerzo.getTime() <= horaHastaSeleccionada.getTime()) || (horaDesdeSeleccionada.getTime() <= horaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() === horaSalidaDelDia.getTime())

                    const PreguntarIncluyeAlmuerzo = (PreguntarIncluyeAlmuerzo1 || PreguntarIncluyeAlmuerzo2 || PreguntarIncluyeAlmuerzo3) && diferenciaMinutos > tiempoAlmuerzoMinutos && !PermisoIncluyeTodaLaHoraAlmuerzo

                    sethorarioAlmuerzo(PreguntarIncluyeAlmuerzo)

                    if (!PreguntarIncluyeAlmuerzo && !descuentaTiempoAlmuerzo) {
                        setmensajeMarcacionAlmuerzo("")
                        setdescontadoTiempoAlmuerzo(false)
                        setincluyeHoraAlmuerzo(false)
                    }
                    else {
                        if (!PreguntarIncluyeAlmuerzo)
                            setmensajeMarcacionAlmuerzo("")

                        if (incluyeHoraAlmuerzo || (!PreguntarIncluyeAlmuerzo && descuentaTiempoAlmuerzo)) {
                            valorRestarEnMinutos = tiempoAlmuerzoMinutos;
                            setdescontadoTiempoAlmuerzo(true)
                        }
                        else {
                            setdescontadoTiempoAlmuerzo(false)
                            //setincluyeHoraAlmuerzo(false)
                        }
                    }
                    const diferenciaHoras = (+differenceInMinutes(horaHastaSeleccionada, horaDesdeSeleccionada) - valorRestarEnMinutos) / 60;

                    const diferencia = toHoursAndMinutes(diferenciaMinutos - valorRestarEnMinutos);
                    setHorasSolicitdas(diferencia);
                }
            }

        }
    }, [fechaPermisoHora, horaDesde, horaHasta, mensajeMarcacionAlmuerzo, horarioAlmuerzo, incluyeHoraAlmuerzo, descontandoTiempoAlmuerzo])

    useEffect(() => {

        var fechasPermisosMedicos: FechaHora[] = [];
        var pidioPermisoEnFechaEscogida = false;
        var horaInicioPermisoMedico: string[] = [];
        var horaFinPermisoMedico: string[] = [];
        var fechaPermisoCoincideFechaEscogida: FechaHora[] = [];

        if (stateCard.fechaDesde !== null && stateCard.fechaDesde !== undefined && (props.solicitudesVacaciones.length > 0 || props.solicitudesPermisos.length > 0 || props.permisosIngresados.length > 0 || props.licenciasIngresadas.length > 0)) {

            props.solicitudesVacaciones.map((val, ind) => {
                if (val.permiso === true) {
                    fechasPermisosMedicos = [...fechasPermisosMedicos, ...obtener_rango_fechas_horas_no_weekend(val.fechaInicio, val.fechaFin, val.horadesde, val.horahasta)]
                }

            })

            props.solicitudesPermisos.map((val, ind) => {
                const fechaDesde: Date | undefined = GetDateObjectFromIsoFormat(val.fechaDesde);
                const fechaHasta: Date | undefined = GetDateObjectFromIsoFormat(val.fechaHasta);
                if (fechaDesde !== undefined && fechaHasta !== undefined && val.horaDesde !== null && val.horaHasta !== null) {
                    fechasPermisosMedicos = [...fechasPermisosMedicos, ...obtener_rango_fechas_horas_no_weekend(fechaDesde, fechaHasta, val.horaDesde, val.horaHasta)]
                }

            })
            props.permisosIngresados.map((val, ind) => {
                const fechaDesde: Date | undefined = GetDateObjectFromIsoFormat(val.fechaDesde);
                const fechaHasta: Date | undefined = GetDateObjectFromIsoFormat(val.fechaHasta);
                if (fechaDesde !== undefined && fechaHasta !== undefined && val.horaDesde !== null && val.horaHasta !== null) {
                    fechasPermisosMedicos = [...fechasPermisosMedicos, ...obtener_rango_fechas_horas_no_weekend(fechaDesde, fechaHasta, val.horaDesde, val.horaHasta)]
                }
            })

            props.licenciasIngresadas.map((val, ind) => {
                const fechaDesde: Date | undefined = GetDateObjectFromIsoFormat(val.fechaDesde);
                const fechaHasta: Date | undefined = GetDateObjectFromIsoFormat(val.fechaHasta);
                if (fechaDesde !== undefined && fechaHasta !== undefined && val.horaDesde !== null && val.horaHasta !== null) {
                    fechasPermisosMedicos = [...fechasPermisosMedicos, ...obtener_rango_fechas_horas_no_weekend(fechaDesde, fechaHasta, val.horaDesde, val.horaHasta)]

                }
            })

            props.historial.map((mes, ind) => {
                mes.value.map((val, ind) => {
                    const fechaDesde: Date | undefined = GetDateObjectFromIsoFormat(val.fechaInicio);
                    const fechaHasta: Date | undefined = GetDateObjectFromIsoFormat(val.fechafin);
                    if (fechaDesde !== undefined && fechaHasta !== undefined && val.horaInicio !== null && val.horaFin !== null && val.diasSolicitados !== null) {
                        fechasPermisosMedicos = [...fechasPermisosMedicos, ...obtener_rango_fechas_horas_no_weekend(fechaDesde, fechaHasta, val.horaInicio, val.horaFin)]

                    }
                })
            })

            const fechaEscogida = new Date(stateCard.fechaDesde);

            fechaPermisoCoincideFechaEscogida = fechasPermisosMedicos.filter((v) => v.fecha.getTime() === fechaEscogida.getTime());

            pidioPermisoEnFechaEscogida = fechaPermisoCoincideFechaEscogida.length > 0;

            for (let index = 0; index < fechaPermisoCoincideFechaEscogida.length; index++) {
                const fechaPermisoMedico = fechaPermisoCoincideFechaEscogida[index];
                horaInicioPermisoMedico.push(fechaPermisoMedico.horaInicio);
                horaFinPermisoMedico.push(fechaPermisoMedico.horaFin);
            }

            if (pidioPermisoEnFechaEscogida) {

                var mensajeHorarios: string = "";

                for (let index = 0; index < fechaPermisoCoincideFechaEscogida.length; index++) {
                    const fechaPermisoMedico = fechaPermisoCoincideFechaEscogida[index];
                    mensajeHorarios += `${fechaPermisoMedico.horaInicio} - ${fechaPermisoMedico.horaFin}`
                    if (index != fechaPermisoCoincideFechaEscogida.length - 1) {
                        mensajeHorarios += "; "
                    }
                }

                if (mensajeHorarios !== mensajePermisoMedico) {
                    setmensajePermisoMedico(`Ha escogido una fecha en la que tiene permiso o licencia en el siguiente horario: ${mensajeHorarios}`);
                }


            } else if (!pidioPermisoEnFechaEscogida) {
                setmensajePermisoMedico("")
            }
        }
    }, [stateCard.fechaDesde])

    /*useEffect(() => {
        let errorEncontrado = false; // Variable para rastrear si se ha encontrado un error


        props.solicitudesVacaciones.forEach((val) => {
            const fechaInicioLicencia = val.fechaInicio ? new Date(val.fechaInicio) : null;
            const fechaFinLicencia = val.fechaFin ? new Date(val.fechaFin) : null;

            if (stateCard.fechaDesde && stateCard.fechaHasta && tipoLicenciaSeleccionado !== 3) {
                const fechaEscogidaInicio = new Date(stateCard.fechaDesde);
                const fechaEscogidaFin = new Date(stateCard.fechaHasta);
                
                if (fechaEscogidaInicio && fechaEscogidaFin && fechaInicioLicencia && fechaFinLicencia && val.horadesde === "") {
                    if (fechaEscogidaInicio <= fechaFinLicencia && fechaEscogidaFin >= fechaInicioLicencia) {
                        setmensajeError("Existe un permiso/licencia previamente ingresado, dentro del rango de fechas u horas de esta solicitud");
                        errorEncontrado = true; // Se ha encontrado un error
                        showAlertWarning("Existe un permiso/licencia previamente ingresado, dentro del rango de fechas u horas de esta solicitud", WarningSVG, true);
                        return;
                    } else {
                        setmensajeError("");
                    }
                }
            }
        });

        props.licenciasIngresadas.forEach((val) => {
            const fechaInicioLicencia = val.fechaDesde ? new Date(val.fechaDesde) : null;
            const fechaFinLicencia = val.fechaHasta ? new Date(val.fechaHasta) : null;

            if (stateCard.fechaDesde && stateCard.fechaHasta && tipoLicenciaSeleccionado !== 3) {
                const fechaEscogidaInicio = new Date(stateCard.fechaDesde);
                const fechaEscogidaFin = new Date(stateCard.fechaHasta);

                if (fechaEscogidaInicio && fechaEscogidaFin && fechaInicioLicencia && fechaFinLicencia) {
                    if (fechaEscogidaInicio <= fechaFinLicencia && fechaEscogidaFin >= fechaInicioLicencia) {
                        setmensajeError("Existe un permiso/licencia previamente ingresado, dentro del rango de fechas u horas de esta solicitud");
                        errorEncontrado = true; // Se ha encontrado un error
                        showAlertWarning("Existe un permiso/licencia previamente ingresado, dentro del rango de fechas u horas de esta solicitud", WarningSVG, true);
                        return;
                    } else {
                        setmensajeError("");
                    }
                }
            }
        });

        // Si no se encontró ningún error, limpia el mensaje
        if (!errorEncontrado) {
            setmensajeError("");
        }
    }, [stateCard.fechaDesde, stateCard.fechaHasta, tipoLicenciaSeleccionado, props.permisosIngresados, props.solicitudesVacaciones, props.licenciasIngresadas]);*/

    useEffect(() => {
        let errorEncontrado = false; // Variable para rastrear si se ha encontrado un error
        let mensajeAdvertenciaTemp = "";
        const verificarTraslape = (fechaInicio, fechaFin) => {
            if (stateCard.fechaDesde && stateCard.fechaHasta) {
                const fechaEscogidaInicio = new Date(stateCard.fechaDesde);
                const fechaEscogidaFin = new Date(stateCard.fechaHasta);
                if (fechaEscogidaInicio <= fechaFin && fechaEscogidaFin >= fechaInicio) {
                    errorEncontrado = true; // Se ha encontrado un error

                    return true;
                } else {
                    return false;
                }
            }
        };

        if (stateCard.fechaDesde && stateCard.fechaHasta && tipoLicenciaSeleccionado) {
            /*props.solicitudesVacaciones.forEach((val) => {
                const fechaInicioVacaciones = val.fechaInicio ? new Date(val.fechaInicio) : null;
                const fechaFinVacaciones = val.fechaFin ? new Date(val.fechaFin) : null;
    
                if (tipoLicenciaSeleccionado !== 3) {
                    mensajeAdvertencia = "Existe un permiso/licencia previamente ingresado, dentro del rango de fechas u horas de esta solicitud";
    
                    if (fechaInicioVacaciones && fechaFinVacaciones && val.horadesde === "") {
                        verificarTraslape(fechaInicioVacaciones, fechaFinVacaciones, mensajeAdvertencia);
                    }
                }
            });
    
            props.licenciasIngresadas.forEach((val) => {
                const fechaInicioLicencia = val.fechaDesde ? new Date(val.fechaDesde) : null;
                const fechaFinLicencia = val.fechaHasta ? new Date(val.fechaHasta) : null;
    
                if (tipoLicenciaSeleccionado !== 3) {
                    mensajeAdvertencia = "Existe un permiso/licencia previamente ingresado, dentro del rango de fechas u horas de esta solicitud";
    
                    if (fechaInicioLicencia && fechaFinLicencia) {
                        verificarTraslape(fechaInicioLicencia, fechaFinLicencia, mensajeAdvertencia);
                    }
                }
            });*/

            // Condición 1
            if (tipoLicenciaSeleccionado === 11 || tipoLicenciaSeleccionado === 16) {
                props.solicitudesVacaciones.forEach((val) => {
                    const fechaInicioVacaciones = val.fechaInicio ? new Date(val.fechaInicio) : null;
                    const fechaFinVacaciones = val.fechaFin ? new Date(val.fechaFin) : null;

                    if (fechaInicioVacaciones && fechaFinVacaciones) {
                        if (verificarTraslape(fechaInicioVacaciones, fechaFinVacaciones)) {
                            mensajeAdvertenciaTemp = "Existe(n) solicitud(es) de vacaciones(s) previamente ingresada(s) y/o aprobada(s), dentro del rango de fechas u horas de la solicitud que desea ingresar. Dado que el período de su solicitud de licencia por enfermedad considera el período de sus vacaciones, será anulada su solicitud de vacaciones.";
                            showAlertWarning(mensajeAdvertenciaTemp, WarningSVG, true);
                        }
                        /*
                          verificarTraslape(fechaInicioVacaciones, fechaFinVacaciones, mensajeAdvertenciaTemp);
                          console.log(verificarTraslape(fechaInicioVacaciones, fechaFinVacaciones, mensajeAdvertenciaTemp));*/
                    }
                });
            }

            if (tipoLicenciaSeleccionado === 17) {
                props.solicitudesVacaciones.forEach((val) => {
                    const fechaInicioVacaciones = val.fechaInicio ? new Date(val.fechaInicio) : null;
                    const fechaFinVacaciones = val.fechaFin ? new Date(val.fechaFin) : null;

                    if (fechaInicioVacaciones && fechaFinVacaciones) {
                        if (verificarTraslape(fechaInicioVacaciones, fechaFinVacaciones)) {
                            mensajeAdvertenciaTemp = "Existe(n) solicitud(es) de vacaciones(s) previamente ingresada(s) y/o aprobada(s), dentro del rango de fechas u horas de la solicitud que desea ingresar. Dado que el período de su solicitud de licencia por calamidad doméstica considera el período de sus vacaciones, será anulada su solicitud de vacaciones.";
                            showAlertWarning(mensajeAdvertenciaTemp, WarningSVG, true);
                        }
                        /*
                          verificarTraslape(fechaInicioVacaciones, fechaFinVacaciones, mensajeAdvertenciaTemp);
                          console.log(verificarTraslape(fechaInicioVacaciones, fechaFinVacaciones, mensajeAdvertenciaTemp));*/
                    }
                });
            }

            // Condición 2
            if (tipoLicenciaSeleccionado === 3 || tipoLicenciaSeleccionado === 12) {
                props.solicitudesVacaciones.forEach((val) => {
                    const fechaInicioVacaciones = val.fechaInicio ? new Date(val.fechaInicio) : null;
                    const fechaFinVacaciones = val.fechaFin ? new Date(val.fechaFin) : null;

                    if (fechaInicioVacaciones && fechaFinVacaciones) {
                        if (verificarTraslape(fechaInicioVacaciones, fechaFinVacaciones)) {
                            mensajeAdvertenciaTemp = "Existe(n) solicitud(es) de vacaciones(s) previamente ingresada(s) y/o aprobada(s), dentro del rango de fechas u horas de la solicitud que desea ingresar. Dado que el período de su solicitud de licencia por maternidad/paternidad, se encuentra dentro de sus vacaciones, se finalizará las vacaciones vigente un día antes del inicio de la nueva solicitud.";
                            showAlertWarning(mensajeAdvertenciaTemp, WarningSVG, true);
                        }
                        /*mensajeAdvertenciaTemp = "Existe(n) solicitud(es) de vacaciones(s) previamente ingresada(s) y/o aprobada(s), dentro del rango de fechas u horas de la solicitud que desea ingresar. Dado que el período de su solicitud de licencia por maternidad/paternidad, se encuentra dentro de sus vacaciones, se finalizará las vacaciones vigente un día antes del inicio de la nueva solicitud.";
                          verificarTraslape(fechaInicioVacaciones, fechaFinVacaciones, mensajeAdvertenciaTemp);*/
                    } else {
                        mensajeAdvertenciaTemp = ""
                    }
                });                

                props.licenciasIngresadas.forEach((val) => {
                    const fechaInicioLicencia = val.fechaDesde ? new Date(val.fechaDesde) : null;
                    const fechaFinLicencia = val.fechaHasta ? new Date(val.fechaHasta) : null;

                    if (fechaInicioLicencia && fechaFinLicencia) {
                        if (verificarTraslape(fechaInicioLicencia, fechaFinLicencia)) {
                            mensajeAdvertenciaTemp = "Existe(n) solicitud(es) de licencia(s) previamente ingresada(s) y/o aprobada(s), dentro del rango de fechas u horas de la solicitud que desea ingresar. Dado que el período de su solicitud de licencia, se encuentra dentro de su licencia ingresada con anterioridad, se finalizará la licencia vigente un día antes del inicio de la nueva solicitud.";
                            showAlertWarning(mensajeAdvertenciaTemp, WarningSVG, true);
                        }
                        /*mensajeAdvertenciaTemp = "Existe(n) solicitud(es) de permiso(s)/licencia(s) previamente ingresada(s) y/o aprobada(s), dentro del rango de fechas u horas de la solicitud que desea ingresar. Dado que el período de su solicitud de licencia por maternidad/paternidad, se encuentra dentro de su licencia, se finalizará la licencia vigente un día antes del inicio de la nueva solicitud.";
                          verificarTraslape(fechaInicioLicencia, fechaFinLicencia, mensajeAdvertenciaTemp);*/
                    } else {
                        mensajeAdvertenciaTemp = ""
                    }
                });

            }

            // Condición 3
            if (tipoLicenciaSeleccionado === 25) {
                props.solicitudesVacaciones.forEach((val) => {
                    const fechaInicioVacaciones = val.fechaInicio ? new Date(val.fechaInicio) : null;
                    const fechaFinVacaciones = val.fechaFin ? new Date(val.fechaFin) : null;

                    if (fechaInicioVacaciones && fechaFinVacaciones) {
                        if (verificarTraslape(fechaInicioVacaciones, fechaFinVacaciones)) {
                            mensajeAdvertenciaTemp = "Existe(n) solicitud(es) de vacaciones(s) previamente ingresada(s) y/o aprobada(s), dentro del rango de fechas u horas de la solicitud que desea ingresar.";
                            showAlertWarning(mensajeAdvertenciaTemp, WarningSVG, true);
                            setMensajeAdvertencia(mensajeAdvertenciaTemp);
                        }
                    } else {
                        mensajeAdvertenciaTemp = ""
                    }
                });

                props.licenciasIngresadas.forEach((val) => {
                    const fechaInicioLicencia = val.fechaDesde ? new Date(val.fechaDesde) : null;
                    const fechaFinLicencia = val.fechaHasta ? new Date(val.fechaHasta) : null;

                    if (fechaInicioLicencia && fechaFinLicencia) {
                        if (verificarTraslape(fechaInicioLicencia, fechaFinLicencia)) {
                            mensajeAdvertenciaTemp = "Existe(n) solicitud(es) de licencia(s) previamente ingresada(s) y/o aprobada(s), dentro del rango de fechas u horas de la solicitud que desea ingresar.";
                            showAlertWarning(mensajeAdvertenciaTemp, WarningSVG, true);
                            setMensajeAdvertencia(mensajeAdvertenciaTemp);
                        }
                    } else {
                        mensajeAdvertenciaTemp = ""
                    }
                });

            }

            if (tipoLicenciaSeleccionado === 11 || tipoLicenciaSeleccionado === 12 || tipoLicenciaSeleccionado === 16 || tipoLicenciaSeleccionado === 3) {
                props.permisosIngresados.forEach((val) => {
                    const fechaInicioPermiso = val.fechaDesde ? new Date(val.fechaDesde) : null;
                    const fechaFinPermiso = val.fechaHasta ? new Date(val.fechaHasta) : null;

                    if (fechaInicioPermiso && fechaFinPermiso && val.estadoPermiso === 'F') {
                        if (verificarTraslape(fechaInicioPermiso, fechaFinPermiso)) {
                            mensajeAdvertenciaTemp = "Existe(n) solicitud(es) de cita(s) médica(s) programada(s) ingresada(s), dentro del rango de fechas u horas de la solicitud que desea ingresar. Dado que el período de su solicitud de licencia, se encuentra dentro o considera el rango de fechas de sus citas médicas, estás serán anuladas.";
                            showAlertWarning(mensajeAdvertenciaTemp, WarningSVG, true);
                        }
                        /*mensajeAdvertenciaTemp = "Existe(n) solicitud(es) de cita(s) médica(s) programada(s) ingresada(s), dentro del rango de fechas u horas de la solicitud que desea ingresar. Dado que el período de su solicitud de licencia, se encuentra dentro o considera el rango de fechas de sus citas médicas, estás serán canceladas.";
                        verificarTraslape(fechaInicioPermiso, fechaFinPermiso, mensajeAdvertenciaTemp);*/

                    } else {
                        mensajeAdvertenciaTemp = ""
                    }

                });
            }
        }

        if (mensajeAdvertenciaTemp !== "") {
            setMensajeAdvertencia(mensajeAdvertenciaTemp)
        }

    }, [stateCard.fechaDesde, stateCard.fechaHasta, tipoLicenciaSeleccionado, props.solicitudesVacaciones, props.licenciasIngresadas]);


    useEffect(() => {
        var nuevasFechasEscogidas: Date[] = []

        if (props.permisosIngresados.length > 0) {
            props.permisosIngresados.map((val, ind) => {
                var fechaDesdeDate = new Date();
                var fechaHastaDate = new Date();
                if (val.fechaDesde != null && val.fechaHasta != null) {
                    fechaDesdeDate = new Date(val.fechaDesde);
                    fechaHastaDate = new Date(val.fechaHasta);
                }
                if (!isNaN(fechaDesdeDate.getTime()) && !isNaN(fechaHastaDate.getTime())) {
                    var rangoFechasExcluir = [...obtener_rango_fechas_with_weekend(fechaDesdeDate, fechaHastaDate)];
                    nuevasFechasEscogidas = [...nuevasFechasEscogidas, ...rangoFechasExcluir];
                }

            })
        }
        if (props.licenciasIngresadas.length > 0) {

            props.licenciasIngresadas.map((val, ind) => {
                var fechaDesdeDate = new Date();
                var fechaHastaDate = new Date();
                if (val.fechaDesde != null && val.fechaHasta != null) {
                    fechaDesdeDate = new Date(val.fechaDesde);
                    fechaHastaDate = new Date(val.fechaHasta);
                }
                // Verificar si las fechas son válidas
                if (!isNaN(fechaDesdeDate.getTime()) && !isNaN(fechaHastaDate.getTime())) {
                    var rangoFechasExcluir = [...obtener_rango_fechas_with_weekend(fechaDesdeDate, fechaHastaDate)];
                    nuevasFechasEscogidas = [...nuevasFechasEscogidas, ...rangoFechasExcluir];
                }

            })

        }
        setfechasEscogidas(nuevasFechasEscogidas)
        setstateModal(defaultStateModal);
        setstateModalFormulario(defaultStateModalFormulario)
    }, [props.licenciasIngresadas, props.permisosIngresados])



    useEffect(() => {
        if (tipoLicenciaSeleccionado === 3) {
            if (props.permisosCRN.length > 0) {
                const mensaje = ` Usted tiene un permiso para cuidado del recién nacido. Comuniquese con la Dirección de Talento Humano para dar por terminado el mismo, antes del ingreso de su licencia por maternidad`;
                setmensajeErrorCRN(mensaje);
            }
        } else {
            setmensajeErrorCRN("");
        }

    }, [tipoLicenciaSeleccionado, props.permisosCRN]);

    const obtenerFechaActual = () => {
        const fecha = new Date(); // Obtener la fecha y hora actual
        fecha.setHours(0, 0, 0, 0); // Establecer la hora a medianoche
        return fecha;
    };

    const hoy = obtenerFechaActual();
    const estaEntreFechas = (fechaInicio, fechaFin) => {
        const inicio = new Date(fechaInicio);
        const fin = new Date(fechaFin);
        return inicio <= hoy && hoy <= fin;
    };

    useEffect(() => {

        if (props.licenciasComisiones.length > 0) {
            props.licenciasComisiones.map(licencia => {
                setmensajeLicenciaComision(`Usted tiene una ${licencia.nombrelicencia} en curso`)
            })
        } else if (props.solicitudesVacaciones.length > 0) {
            props.solicitudesVacaciones.forEach((val) => {
                if (((val.estado === 1 || val.estado === 12) && (val.permiso === false || (val.permiso === true && val.horadesde === "" && val.horahasta === ""))) && estaEntreFechas(val.fechaInicio, val.fechaFin)) {
                    setmensajeLicenciaComision(`Usted tiene una solicitud de vacaciones ingresada desde el ${formatDateToString(val.fechaInicio)} hasta el ${formatDateToString(val.fechaFin)}`);
                }
                if (((val.estado === 2 || val.estado === 3) && (val.permiso === false || (val.permiso === true && val.horadesde === "" && val.horahasta === ""))) && estaEntreFechas(val.fechaInicio, val.fechaFin)) {
                    setmensajeLicenciaComision(`Usted tiene una solicitud de vacaciones aprobada desde el ${formatDateToString(val.fechaInicio)} hasta el ${formatDateToString(val.fechaFin)}`);
                }
            });
        }
    }, [tipoLicenciaSeleccionado, props.licenciasComisiones, props.solicitudesVacaciones])

    useEffect(() => {
        if (props.licenciasIngresadas.length > 0) {
            props.licenciasIngresadas.forEach((val) => {
                if (estaEntreFechas(val.fechaDesde, val.fechaHasta) && val.estadoPermiso !== "A") {
                    setmensajeErrorLicencia(`Usted tiene una licencia ingresada desde el ${formatDateToString(val.fechaDesde)} hasta el ${formatDateToString(val.fechaHasta)}`);
                }
            });
        }
    }, [tipoLicenciaSeleccionado, props.licenciasIngresadas])

    useEffect(() => {
        if (props.permisosIngresados.length > 0) {
            props.permisosIngresados.forEach((val) => {
                if (val.estadoPermiso == "F") {
                    setmensajePermisoNot(`Usted ha notificado un permiso para atención médica. Para completar la solicitud deberá registrar el certificado de asistencia a la cita médica hasta 3 días después de su cita`);
                }
            });
        }
    }, [props.permisosIngresados])

    useEffect(() => {
        if (props.licenciasIngresadas.length > 0) {
            props.licenciasIngresadas.forEach((val) => {
                if (val.estadoPermiso == "F" && val.tipoPermiso == 25) {
                    setmensajeLicenciaNot(`Usted ha notificado una licencia por matrimonio/unión de hecho. Para completar la solicitud deberá registrar el Acta emitida por el Registro Civil como evidencia del evento hasta 3 días después de su reíntegro`);
                } else if (val.estadoPermiso == "F") {                    
                    setmensajeLicenciaNot(`Usted ha notificado una licencia por calamidad doméstica. Para completar la solicitud deberá registrar la evidencia de la calamidad hasta 3 días después de su reíntegro`);
                }
            });
        }
    }, [props.licenciasIngresadas])

    useEffect(() => {
        if (props.permisosIngresados.length > 0) {
            props.permisosIngresados.forEach((val) => {
                if (val.estadoPermiso == "E") {
                    setmensajePermisoDev(`Usted tiene un permiso rechazado parcialmente. Tiene hasta 2 días para realizar las acciones pertinentes`);
                }
            });
        }
    }, [props.permisosIngresados])

    useEffect(() => {
        if (props.licenciasIngresadas.length > 0) {
            props.licenciasIngresadas.forEach((val) => {
                if ((val.estadoPermiso == "E") && (val.tipoPermiso == 3)) {
                    setmensajeLicenciaDev(`Usted tiene una licencia rechazada parcialmente`);
                } else if (val.estadoPermiso == "E") {
                    setmensajeLicenciaDev(`Usted tiene una licencia rechazada parcialmente. Tiene hasta 2 días para realizar las acciones pertinentes`);
                }
            });
        }
    }, [props.licenciasIngresadas])

    useEffect(() => {
        async function checkAndShowAlert() {
            if (tipoPermisoSeleccionado === 46 && empHorario.length === 0 && props.idRegimenLaboralS != 8) {
                await showAlertWarning(
                    "Usted no tiene un permiso de cuidado del recién nacido en curso",
                    AnuncioSVG,
                    false
                );
            }
            else if (tipoPermisoSeleccionado === 46 && props.tieneInfanteRegistrado == false) {
                // Mostrar alert y luego abrir modal si el usuario confirma
                const result = await Swal.fire({
                    title: 'Registro requerido',
                    html: '<div style="color: #000000;">Para continuar con la confirmación o cambio de horario, debe registrar al recién nacido.</div>',
                    imageHeight: 100,
                    imageUrl: Informativa,
                    width: '500px',
                    confirmButtonText: 'ENTENDIDO',
                    confirmButtonColor: '#243165',
                    showCancelButton: false // Opcional: si quieres forzar el registro
                });

                if (result.isConfirmed) {
                    toggleModalRegistrarInfante(); // Abre el modal
                }
            }
            else if (tipoPermisoSeleccionado === 46 && empHorario.length !== 0) {
                setfechaDesdeAnterior(empHorario[0].fechaVigDesde);
                setfechaHastaAnterior(empHorario[0].fechaVigHasta);
            }
        }

        checkAndShowAlert();

        return () => {
        };
    }, [tipoPermisoSeleccionado, empHorario, props.tieneInfanteRegistrado, props.idRegimenLaboralS]);


    const DatePickerFechaHora = useCallback((permiso: boolean) => {

        const fechaActual = new Date();
        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })

        const fechaslicencias = props.licenciasIngresadas.map(licencia => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (licencia.fechaDesde != null && licencia.fechaHasta != null) {
                const fechaInicio = new Date(licencia.fechaDesde);
                const fechaFin = new Date(licencia.fechaHasta);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }


        }).flat();

        const fechasHistorial = props.historial.flatMap((mes) => {
            return mes.value.flatMap((val) => {
                if (val.horasSolicitadas === null && val.diasSolicitados !== null && val.fechaInicio !== null && val.fechafin !== null) {
                    const fechaInicio = new Date(val.fechaInicio);
                    const fechaFin = new Date(val.fechafin);
                    const rangoFechasLicencia: Date[] = []; // Explicitly declaring the type of the array
                    let currentDate = new Date(fechaInicio.getTime()); // Use a new variable to manipulate dates

                    while (currentDate <= fechaFin) {
                        rangoFechasLicencia.push(new Date(currentDate)); // Correctly create a new Date object
                        currentDate.setDate(currentDate.getDate() + 1); // Increment the date
                    }
                    return rangoFechasLicencia;
                }
                return []; // Return an empty array for consistency
            });
        });

        const fechasVacaciones = props.solicitudesVacaciones.map(vac => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (vac.fechaInicio != null && vac.fechaFin != null && vac.horadesde == "" && vac.horahasta == "") {
                const fechaInicio = new Date(vac.fechaInicio);
                const fechaFin = new Date(vac.fechaFin);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }


        }).flat();

        const fechasComisiones = props.licenciasComisiones.map(vac => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (vac.fechainicio != null && vac.fechafin != null) {
                const fechaInicio = new Date(vac.fechainicio);
                const fechaFin = new Date(vac.fechafin);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }


        }).flat();
        var excludeDates = [...feriados, ...fechaslicencias, ...fechasVacaciones, ...fechasComisiones, ...fechasHistorial];
        var fechaminima = GetNPreviousLaboralDay(fechaActual, feriados, 3);
        var fechaMaxima = fechaActual
        if (tipoPermisoSeleccionado === 29) {
            const permiso = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoPermisoSeleccionado);
            const diasAnticipacion = permiso ? permiso.diasanticipacion : 1;
            fechaminima = GetPreviousLaboralDay(fechaActual, feriados)
            //fechaMaxima = SumarDiasFecha(fechaActual, diasAnticipacion)
            fechaMaxima = ObtenerFechaLaboralDeSuma(fechaActual, 1, feriados)
            excludeDates = [...feriados, ...fechaslicencias, ...fechasVacaciones, ...fechasComisiones, ...fechasHistorial];
        } else if (tipoPermisoSeleccionado === 5) {
            const permiso = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoPermisoSeleccionado);
            const diasAnticipacion = permiso ? permiso.diasanticipacion : 1;
            if (tipoCita === "programada") {
                fechaminima = fechaActual
                fechaMaxima = ObtenerFechaLaboralDeSuma(fechaActual, 187, feriados)
            } else {
                fechaminima = GetNPreviousLaboralDay(fechaActual, feriados, 3);
                fechaMaxima = fechaActual

            }
        }
        return (
            <Datepicker2
                value={fechaPermisoHora}
                disabled={!permiso}
                name="fechahasta"
                id="fechahasta"
                onChange={(e) => setfechaPermisoHora(e)}
                min={fechaminima}
                max={fechaMaxima}
                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, props.feriados)}
                showDisabledMonthNavigation={true}
                excludeDates={excludeDates}
                dayClassName={(date: Date) => isFeriado(date, props.feriados)}
            />
        )
    }, [fechaPermisoHora, fechasEscogidas, props.feriados, props.anio, props.licenciasIngresadas, tipoPermisoSeleccionado, tipoCita])

    const DatePickerFechaHoraEditar = ({ FechaInicial, onFechaInicialChange, TipoPermiso }) => {
        const [fechaInicial, setFechaInicial] = useState(FechaInicial || "");

        useEffect(() => {
            setFechaInicial(FechaInicial || "");
        }, [FechaInicial]);

        const handleChange = (e) => {
            const newHoraHasta = e;
            setFechaInicial(newHoraHasta);
            onFechaInicialChange(e); // Actualizar el estado en el componente padre

        };

        const fechaActual = new Date();

        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })

        const fechaslicencias = props.licenciasIngresadas.map(licencia => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (licencia.fechaDesde != null && licencia.fechaHasta != null) {
                const fechaInicio = new Date(licencia.fechaDesde);
                const fechaFin = new Date(licencia.fechaHasta);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }


        }).flat();

        const fechasHistorial = props.historial.flatMap((mes) => {
            return mes.value.flatMap((val) => {
                if (val.horasSolicitadas === null && val.diasSolicitados !== null && val.fechaInicio !== null && val.fechafin !== null) {
                    const fechaInicio = new Date(val.fechaInicio);
                    const fechaFin = new Date(val.fechafin);
                    const rangoFechasLicencia: Date[] = []; // Explicitly declaring the type of the array
                    let currentDate = new Date(fechaInicio.getTime()); // Use a new variable to manipulate dates

                    while (currentDate <= fechaFin) {
                        rangoFechasLicencia.push(new Date(currentDate)); // Correctly create a new Date object
                        currentDate.setDate(currentDate.getDate() + 1); // Increment the date
                    }
                    return rangoFechasLicencia;
                }
                return []; // Return an empty array for consistency
            });
        });

        const fechasVacaciones = props.solicitudesVacaciones.map(vac => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (vac.fechaInicio != null && vac.fechaFin != null && vac.horadesde == "" && vac.horahasta == "") {
                const fechaInicio = new Date(vac.fechaInicio);
                const fechaFin = new Date(vac.fechaFin);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }


        }).flat();

        const fechasComisiones = props.licenciasComisiones.map(vac => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (vac.fechainicio != null && vac.fechafin != null) {
                const fechaInicio = new Date(vac.fechainicio);
                const fechaFin = new Date(vac.fechafin);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }


        }).flat();

        var excludeDates = [...feriados, ...fechaslicencias, ...fechasVacaciones, ...fechasComisiones, ...fechasHistorial];
        var fechaminima = fechaActual
        if (TipoPermiso == 11) {
            fechaminima = ObtenerFechaLaboralDeSuma(FechaInicial, -3, feriados)
        }
        var fechaMaxima = ObtenerFechaLaboralDeSuma(fechaActual, 187, feriados)

        return (
            TipoPermiso == 11 ?
            <DatepickerModal
                value={fechaInicial}
                name="fechahasta"
                id="fechahasta"
                onChange={handleChange}
                min={fechaminima}
                max={fechaMaxima}
                filter={(date: Date) => isFeriadoFilter(date, props.feriados)}
                showDisabledMonthNavigation={true}
                excludeDates={excludeDates}
                dayClassName={(date: Date) => isFeriado(date, props.feriados)}
            />
                :
            <DatepickerModal
                value={fechaInicial}
                name="fechahasta"
                id="fechahasta"
                onChange={handleChange}
                min={fechaminima}
                max={fechaMaxima}
                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, props.feriados)}
                showDisabledMonthNavigation={true}
                excludeDates={excludeDates}
                dayClassName={(date: Date) => isFeriado(date, props.feriados)}
            />
        );
    };    

    const DatePickerEditarFechaEvento = useCallback(({fechaEventoOriginal, tipoAlumbramiento, fechaSolicitud}) => {
        var fechaMinima = new Date();
        var fechaMaxima = new Date();         

        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })

        var excludeDates = [fechaEventoOriginal];

        if (tipoAlumbramiento == "NACIMIENTO 1 HIJO, POR PARTO NATURAL O CESÁREA" ||
            tipoAlumbramiento == "NACIMIENTO MÚLTIPLE" || tipoAlumbramiento == "NACIMIENTO DE 1 HIJO POR PARTO NATURAL" ||
            tipoAlumbramiento == "NACIMIENTO MÚLTIPLE O CESÁREA" || tipoAlumbramiento == "NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL" ||
            tipoAlumbramiento == "NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA" ||
            tipoAlumbramiento == "NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO" || tipoAlumbramiento == "ADOPCIÓN") {
            fechaMinima = SumarDiasFecha(fechaSolicitud, -3);
            fechaMaxima = fechaSolicitud;
        } else if (tipoAlumbramiento == "matriculacion") {
            fechaMinima = GetPreviousLaboralDay(fechaSolicitud, feriados)
            fechaMaxima = ObtenerFechaLaboralDeSuma(fechaSolicitud, 1, feriados);
            excludeDates = [...feriados, fechaEventoOriginal];
        } else if (tipoAlumbramiento == "matrimonio") {
            fechaMinima = new Date(fechaSolicitud.getFullYear(), fechaSolicitud.getMonth() - 1, 1); // Primer día del mes anterior
            fechaMaxima = new Date(fechaSolicitud.getFullYear() + 1, fechaSolicitud.getMonth() + 1, 0); // Último día del mes actual
            excludeDates = [...feriados, fechaEventoOriginal];
        } else if (tipoAlumbramiento == "I") {
            fechaMinima = new Date(fechaSolicitud.getFullYear(), fechaSolicitud.getMonth() - 1, 1);
            fechaMaxima = new Date(fechaSolicitud.getFullYear(), fechaSolicitud.getMonth() + 3, 0);
            excludeDates = [...feriados, fechaEventoOriginal];
        }
        else {
            fechaMinima = new Date(fechaSolicitud.getFullYear(), fechaSolicitud.getMonth(), 1);
            fechaMaxima = new Date(fechaSolicitud.getFullYear(), fechaSolicitud.getMonth() + 1, 0);
        }        

        const handleChangeEventoMaternidad = (e) => {
            let fechaEvento = e;
    		setfechaEventoEditar(fechaEvento)
        	var fechaInicio = new Date();
            var diferencia = 0;

            if (tipoAlumbramiento == "NACIMIENTO 1 HIJO, POR PARTO NATURAL O CESÁREA" ||
                tipoAlumbramiento == "NACIMIENTO MÚLTIPLE" || tipoAlumbramiento == "NACIMIENTO DE 1 HIJO POR PARTO NATURAL" ||
                tipoAlumbramiento == "NACIMIENTO MÚLTIPLE O CESÁREA" || tipoAlumbramiento == "NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL" ||
                tipoAlumbramiento == "NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA" ||
                tipoAlumbramiento == "NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO" || tipoAlumbramiento == "ADOPCIÓN")
            {
                fechaInicio = fechaEvento;
                setfechaInicioEditar(fechaInicio)

                if (tipoAlumbramiento == "NACIMIENTO 1 HIJO, POR PARTO NATURAL O CESÁREA") {
                    diferencia = 84;
                    setDiasSolicitadosEditar(diferencia)
                } else if (tipoAlumbramiento == "NACIMIENTO MÚLTIPLE") {
                    diferencia = 94;
                    setDiasSolicitadosEditar(diferencia)
                } else if (tipoAlumbramiento == "NACIMIENTO DE 1 HIJO POR PARTO NATURAL") {
                    diferencia = 15;
                    setDiasSolicitadosEditar(diferencia)
                } else if (tipoAlumbramiento == "NACIMIENTO MÚLTIPLE O CESÁREA") {
                    diferencia = 20;
                    setDiasSolicitadosEditar(diferencia)
                } else if (tipoAlumbramiento == "NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL") {
                    diferencia = 23;
                    setDiasSolicitadosEditar(diferencia)
                } else if (tipoAlumbramiento == "NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA") {
                    diferencia = 25;
                    setDiasSolicitadosEditar(diferencia)
                } else if (tipoAlumbramiento == "NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO") {
                    diferencia = 28;
                    setDiasSolicitadosEditar(diferencia)
                } else if (tipoAlumbramiento == "ADOPCIÓN") {
                    diferencia = 30;
                    setDiasSolicitadosEditar(diferencia)
                }
            }
        }

        return (
            <DatepickerModal
                value={fechaEventoEditar}
                name="fechahasta"
                id="fechahasta"
                onChange={handleChangeEventoMaternidad}
                min={fechaMinima}
                max={fechaMaxima}
                excludeDates={excludeDates}
                showDisableMonthNavigation={true}
                filter={(date: Date) =>
                    tipoAlumbramiento === "matriculacion"
                        ? isWeekday(date)  // Solo días de semana para matriculación
                        : true             // Todos los días para otros tipos
                }
            />
        )
    }, [fechaEventoEditar, fechaInicioEditar, fechaFinEditar, diasSolicitadosEditar, tipoAlumbramiento, stateModalEditar])

    useEffect(() => {
        async function fetchHorarioLaboral() {
            const formattedDate = fechaPermisoHora?.toISOString().split('T')[0]; // Format date as 'yyyy-mm-dd'
            if (formattedDate) {
                const response = await ObtenerInformacionHorarioLaboral(formattedDate);
                if (response.status === 200) {
                    const info = response.dataResponse;
                    if (info.length > 0) {
                        setRangoInicioAlmuerzo(info[0].horainicioreceso);
                        setRangoFinAlmuerzo(info[0].horafinreceso);
                        setHoraInicioPermitida(info[0].horaentrada);
                        setHoraFinPermitida(info[0].horasalida);
                    }
                }
            }
        }
        fetchHorarioLaboral();
    }, [fechaPermisoHora]);

    function parseFecha(fecha) {
        // Si la fecha es null o undefined, devolvemos null
        if (fecha === null || fecha === undefined) {
            return null;
        }

        // Si la fecha es un string, intentamos convertirla a un objeto Date
        if (typeof fecha === "string" && fecha.trim() !== "") {
            const parsedDate = new Date(fecha);
            // Verificamos si la conversión fue exitosa
            if (!isNaN(parsedDate.getTime())) {
                return parsedDate;
            } else {
                console.error("Fecha inválida: ", fecha);
                return null;
            }
        }

        // Si ya es un objeto Date, simplemente devolvemos la fecha
        if (fecha instanceof Date && !isNaN(fecha.getTime())) {
            return fecha;
        }

        return null;  // En caso de que el valor no sea válido
    }

    function OnChangeHoraDesde(e: any) {
        setHoraDesde(e.target.value);
    }

    function OnChangeHoraHasta(e: any) {
        setHoraHasta(e.target.value);
    }

    function OnChangeHoraDesdeNuevo(e: any) {
        setHoraDesdeNuevo(e);
    }

    function OnChangeHoraHastaNuevo(e: any) {
        setHoraHastaNuevo(e);
    }

    function OnChangeFechaPermisoNuevo(e: any) {
        setfechaPermisoHoraEditar(e);
    }

    function OnChangeFechaEventoNuevo(e: any) {
        setfechaEventoEditar(e);
    }

    function OnChangeFechaInicioNuevo(e: any) {
        setfechaInicioEditar(e);
    }

    function OnChangeFechaFinNuevo(e: any) {
        setfechaFinEditar(e);
    }

    const DatePickerLicenciaEvento = useCallback((permiso: boolean) => {
        const fechaActual = new Date();
        const fechaFinContrato = GetDateObjectFromIsoFormat(props.fechaFinContrato);

        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })

        let fechaMinima = ObtenerFechaLaboralDeSuma(fechaActual, -3, feriados);

        const fechaslicencias = props.licenciasIngresadas.map(licencia => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (licencia.fechaDesde != null && licencia.fechaHasta != null) {
                const fechaInicio = new Date(licencia.fechaDesde);
                const fechaFin = new Date(licencia.fechaHasta);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }
        }).flat();

        const fechasVacaciones = props.solicitudesVacaciones.map(vac => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (vac.fechaInicio != null && vac.fechaFin != null && vac.horadesde == "" && vac.horahasta == "") {
                const fechaInicio = new Date(vac.fechaInicio);
                const fechaFin = new Date(vac.fechaFin);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }


        }).flat();

        const fechasComisiones = props.licenciasComisiones.map(vac => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (vac.fechainicio != null && vac.fechafin != null) {
                const fechaInicio = new Date(vac.fechainicio);
                const fechaFin = new Date(vac.fechafin);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }


        }).flat();

        const fechasHistorial = props.historial.flatMap((mes) => {
            return mes.value.flatMap((val) => {
                if (val.horasSolicitadas === null && val.diasSolicitados !== null && val.fechaInicio !== null && val.fechafin !== null) {
                    const fechaInicio = new Date(val.fechaInicio);
                    const fechaFin = new Date(val.fechafin);
                    const rangoFechasLicencia: Date[] = []; // Explicitly declaring the type of the array
                    let currentDate = new Date(fechaInicio.getTime()); // Use a new variable to manipulate dates

                    while (currentDate <= fechaFin) {
                        rangoFechasLicencia.push(new Date(currentDate)); // Correctly create a new Date object
                        currentDate.setDate(currentDate.getDate() + 1); // Increment the date
                    }
                    return rangoFechasLicencia;
                }
                return []; // Return an empty array for consistency
            });
        });

        let excludeDates: (Date | undefined)[] = [];

        let fechaMaxima = SumarDiasFecha(fechaActual, 0)

        if (tipoLicenciaSeleccionado === 17) {
            fechaMinima = SumarDiasFecha(fechaActual, -11);
        }
        if (tipoLicenciaSeleccionado === 17) {
            const subtipoSeleccionado = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoCalamidadSeleccionado);
            if (subtipoSeleccionado) {
                // Ajusta la fecha mínima según el subtipo
                if (subtipoSeleccionado.diasmax) {
                    fechaMinima = SumarDiasFecha(fechaActual, -3 - subtipoSeleccionado.diasmax);
                } else {
                    fechaMinima = SumarDiasFecha(fechaActual, -11);
                }
            }
            excludeDates = [...fechaslicencias];
            //excludeDates = [...fechasHistorial, ...fechaslicencias, ...fechasVacaciones, ...fechasComisiones, ...feriados];
        } else if (tipoLicenciaSeleccionado === 36) {
            fechaMinima = SumarDiasFecha(fechaActual, 1);
            fechaMaxima = SumarDiasFecha(fechaActual, 90);
            excludeDates = [...fechasHistorial, ...fechaslicencias, ...fechasVacaciones, ...fechasComisiones, ...feriados];
        } else if (tipoLicenciaSeleccionado === 37) {
            fechaMinima = SumarDiasFecha(fechaActual, 1);
            fechaMaxima = SumarDiasFecha(fechaActual, 180);
            excludeDates = [...fechasHistorial, ...fechaslicencias, ...fechasVacaciones, ...fechasComisiones, ...feriados];
        } else if (tipoLicenciaSeleccionado === 11) {
            excludeDates = [...fechaslicencias];
        } else if (tipoLicenciaSeleccionado === 16) {
            excludeDates = [...fechaslicencias];
        } else if (tipoLicenciaSeleccionado === 25) {
            fechaMinima = new Date(fechaActual.getFullYear(), fechaActual.getMonth() - 1, 1); // Primer día del mes anterior
            if (tipoMatrimonio == "A" && fechaFinContrato != undefined) {
                fechaMaxima = fechaFinContrato;
            } else if (tipoMatrimonio == "D" && fechaFinContrato != undefined) {
                fechaMaxima = ObtenerFechaLaboralDeSuma(fechaFinContrato, -3, feriados); //3 días antes de finalizar el contrato
            } else {
                fechaMaxima = new Date(fechaActual.getFullYear() + 1, fechaActual.getMonth() + 1, 0); // Último día del mes actual
            }            
            /*excludeDates = [...fechasHistorial, ...fechaslicencias, ...fechasVacaciones, ...fechasComisiones, ...feriados];*/
        }

        const handleChangeFechaEvento = async (e) => {
            setMensajeAdvertencia("");

            const year = e.getFullYear();
            const month = String(e.getMonth() + 1).padStart(2, '0');
            const day = String(e.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            const response = await ObtenerInformacionJornadaLaboral(formattedDate);

            let fechaD = e;

            const permisoCalamidad = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado);
            const permisoEnfermedad = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado);
            const permisoMaternidad = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoNacMaternidadSeleccionado);
            const permisoPaternidad = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoNacPaternidadSeleccionado);
            const permisoRehabilitacionEFP = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado);
            const permisoRehabilitacionEGC = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado);
            const permisoMatrimonio = props.tiposSolicitudLicencias.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado);

            if (permisoCalamidad && tipoLicenciaSeleccionado === 17) {
                if (response.status === 200) {
                    const info = response.dataResponse;
                    if (info[0]) {
                        if (isWeekend(e) || info[0].estadojornada === 5) {
                            fechaD = ObtenerFechaLaboralDeSuma(e, 1, feriados);
                        }
                    } else if (isWeekend(e)) {
                        fechaD = ObtenerFechaLaboralDeSuma(e, 1, feriados);
                    }
                }
                setstateCard({ ...stateCard, fechaEvento: e, fechaDesde: fechaD, fechaHasta: null });

            } else if (permisoMaternidad && permisoMaternidad.diasmax && tipoLicenciaSeleccionado === 3) {
                const nuevaFechaHasta = SumarDiasFecha(e, permisoMaternidad.diasmax - 1);
                setstateCard({ ...stateCard, fechaEvento: e, fechaDesde: fechaD, fechaHasta: nuevaFechaHasta });
            } else if (permisoPaternidad && permisoPaternidad.diasmax && tipoLicenciaSeleccionado === 12) {
                const nuevaFechaHasta = SumarDiasFecha(e, permisoPaternidad.diasmax - 1);
                setstateCard({ ...stateCard, fechaEvento: e, fechaDesde: fechaD, fechaHasta: nuevaFechaHasta });
            } else if (permisoEnfermedad && tipoLicenciaSeleccionado === 11) {
                if (response.status === 200) {
                    const info = response.dataResponse;
                    if (info[0]) {
                        if (info[0].estadojornada === 5) {
                            fechaD = SumarDiasFecha(e, 1);
                        }
                    }
                }
                excludeDates.push(...feriados);
                setstateCard({ ...stateCard, fechaEvento: e, fechaDesde: fechaD, fechaHasta: null });
            } else if (permisoEnfermedad && tipoLicenciaSeleccionado === 16) {
                if (response.status === 200) {
                    const info = response.dataResponse;
                    if (info[0]) {
                        if (info[0].estadojornada === 5) {
                            fechaD = SumarDiasFecha(e, 1);
                        }
                    }
                }
                setstateCard({ ...stateCard, fechaEvento: e, fechaDesde: fechaD, fechaHasta: null });
            }
            else if (permisoRehabilitacionEFP && tipoLicenciaSeleccionado === 36) {
                setfechaPermisoHora(e)
                setstateCard({ ...stateCard, fechaEvento: e, fechaDesde: e, fechaHasta: null });
            } else if (permisoRehabilitacionEGC && tipoLicenciaSeleccionado === 37) {
                setfechaPermisoHora(e)
                setstateCard({ ...stateCard, fechaEvento: e, fechaDesde: e, fechaHasta: null });
            } else if (permisoMatrimonio && permisoMatrimonio.diasmax && tipoLicenciaSeleccionado === 25) {                
                if (e < fechaActual) {
                    setFechaEventoMenor(true);
                } else {
                    setFechaEventoMenor(false);
                }
                setstateCard({ ...stateCard, fechaEvento: e});
            }
        };

        return (
            <Datepicker2
                value={stateCard.fechaEvento}
                disabled={!permiso}
                name="fechadesde"
                id="fechadesde"
                onChange={handleChangeFechaEvento}
                min={fechaMinima}
                max={fechaMaxima}
                showDisabledMonthNavigation={true}
                excludeDates={excludeDates}
            />
        )



    }, [stateCard, Jornadalaboral, fechasEscogidas, props.feriados, tipoLicenciaSeleccionado, tipoCalamidadSeleccionado, props.licenciasIngresadas, tipoNacMaternidadSeleccionado, tipoNacPaternidadSeleccionado, props.subtipoPermisos, tipoMatrimonio, props.fechaFinContrato]);
    
    useEffect(() => {
        if (!stateCard.fechaEvento && !stateCard.fechaDesde) return;        

        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })

        const fechaEvento = stateCard.fechaEvento;
        var fechaActual = new Date();
        let fechaMaxima = SumarDiasFecha(fechaActual, 3);
        let fechaMinima = SumarDiasFecha(fechaActual, -3);        

        if (tipoLicenciaSeleccionado == 17) {
            const subtipoSeleccionado = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoCalamidadSeleccionado);
            if (subtipoSeleccionado) {
                if (subtipoSeleccionado.diasmax && fechaEvento) {
                    fechaMaxima = ObtenerFechaLaboralDeSuma(fechaEvento, subtipoSeleccionado?.diasmax + 3, feriados);
                    fechaMinima = ObtenerFechaLaboralDeSuma(fechaEvento, subtipoSeleccionado?.diasmax, feriados);
                }
            }

            if (fechaActual >= fechaMaxima) {
                setMensajeAdvertencia("Usted no puede reportar una solicitud de licencia por calamidad domestica tres dias despues de su reintegro")
                showAlertWarning("Usted no puede reportar una solicitud de licencia por calamidad domestica tres dias despues de su reintegro", WarningSVG, true);
            }
        }

    }, [stateCard.fechaEvento, props.subtipoPermisos, tipoLicenciaSeleccionado, tipoCalamidadSeleccionado, props.feriados])

    useEffect(() => {
        if (!stateCard.fechaEvento && !stateCard.fechaDesde) return;

        let permisoSeleccionado;

        if (tipoLicenciaSeleccionado === 3) {
            permisoSeleccionado = props.subtipoPermisos.find(sp =>
                sp.idtipopermiso === tipoLicenciaSeleccionado &&
                sp.idprnsubtipopermisos === tipoNacMaternidadSeleccionado);
        } else if (tipoLicenciaSeleccionado === 12) {
            permisoSeleccionado = props.subtipoPermisos.find(sp =>
                sp.idtipopermiso === tipoLicenciaSeleccionado &&
                sp.idprnsubtipopermisos === tipoNacPaternidadSeleccionado);
        }

        let fecha = stateCard.fechaEvento
        if (stateCard.fechaDesde) {
            fecha = stateCard.fechaDesde
        }
        if (permisoSeleccionado && permisoSeleccionado.diasmax && fecha) {
            const nuevaFechaHasta = SumarDiasFecha(fecha, permisoSeleccionado.diasmax - 1);
            setstateCard({ ...stateCard, fechaHasta: nuevaFechaHasta });
        }
    }, [tipoNacMaternidadSeleccionado, stateCard.fechaDesde, stateCard.fechaEvento, tipoNacPaternidadSeleccionado, props.subtipoPermisos]);

    useEffect(() => {
        setfechaPermisoHora(null)
        setHoraDesde("")
        setHoraHasta("")
        setHorasSolicitdas("")
        setObservacionPermiso("")
    }, [tipoPermisoSeleccionado])

    useEffect(() => {
        setstateCard(defaultState)
        setDiasSolicitados(0)
        setfechaPermisoHora(null)
        setHoraDesde("")
        setHoraHasta("")
        setHorasSolicitdas("")
        setObservacionPermiso("")
    }, [tipoLicenciaSeleccionado])


    const DatePickerMatrimonioDesde = useCallback((permiso:boolean) => {        

        const fechaActual = new Date();
        const fechaMatrimonio = stateCard.fechaEvento;
        const fechaFinContrato = GetDateObjectFromIsoFormat(props.fechaFinContrato);
        let fechaMinima = SumarDiasFecha(fechaActual, -3);
        let fechaMaxima = SumarDiasFecha(fechaActual, 0)
        let excludeDates: (Date | undefined)[] = [];        

        const feriados = props.feriados.map((val, ind) => {
            return new Date(val);
        })

        const fechaslicencias = props.licenciasIngresadas.map(licencia => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (licencia.fechaDesde != null && licencia.fechaHasta != null) {
                const fechaInicio = new Date(licencia.fechaDesde);
                const fechaFin = new Date(licencia.fechaHasta);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }
        }).flat();

        const fechasVacaciones = props.solicitudesVacaciones.map(vac => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (vac.fechaInicio != null && vac.fechaFin != null && vac.horadesde == "" && vac.horahasta == "") {
                const fechaInicio = new Date(vac.fechaInicio);
                const fechaFin = new Date(vac.fechaFin);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }
        }).flat();

        const fechasComisiones = props.licenciasComisiones.map(vac => {
            // Convertir la fecha de inicio y fin de la licencia en un rango de fechas
            if (vac.fechainicio != null && vac.fechafin != null) {
                const fechaInicio = new Date(vac.fechainicio);
                const fechaFin = new Date(vac.fechafin);
                const rangoFechasLicencia = Array<Date>();
                for (let fecha = fechaInicio; fecha <= fechaFin; fecha.setDate(fecha.getDate() + 1)) {
                    rangoFechasLicencia.push(new Date(fecha));
                }
                return rangoFechasLicencia;
            }
        }).flat();

        const fechasHistorial = props.historial.flatMap((mes) => {
            return mes.value.flatMap((val) => {
                if (val.horasSolicitadas === null && val.diasSolicitados !== null && val.fechaInicio !== null && val.fechafin !== null) {
                    const fechaInicio = new Date(val.fechaInicio);
                    const fechaFin = new Date(val.fechafin);
                    const rangoFechasLicencia: Date[] = []; // Explicitly declaring the type of the array
                    let currentDate = new Date(fechaInicio.getTime()); // Use a new variable to manipulate dates

                    while (currentDate <= fechaFin) {
                        rangoFechasLicencia.push(new Date(currentDate)); // Correctly create a new Date object
                        currentDate.setDate(currentDate.getDate() + 1); // Increment the date
                    }
                    return rangoFechasLicencia;
                }
                return []; // Return an empty array for consistency
            });
        });

        if (fechaMatrimonio != null && tipoLicenciaSeleccionado === 25) {
            if (tipoMatrimonio == "A") {
                excludeDates = [...fechasHistorial, ...fechaslicencias, ...fechasVacaciones, ...fechasComisiones, ...feriados];
                fechaMinima = new Date(fechaActual.getFullYear(), fechaActual.getMonth() - 1, 1); // Primer día del mes actual
                if (fechaFinContrato != undefined) {
                    fechaMaxima = ObtenerFechaLaboralDeSuma(fechaFinContrato, -2, feriados); //2 días antes de finalizar el contrato
                } else {
                    fechaMaxima = ObtenerFechaLaboralDeSuma(fechaMatrimonio, -1, feriados);
                }                
            } else {
                excludeDates = [...fechasHistorial, ...fechaslicencias, ...fechasVacaciones, ...fechasComisiones, ...feriados];
                fechaMinima = ObtenerFechaLaboralDeSuma(fechaMatrimonio, 0, feriados);
                if (fechaFinContrato != undefined) {
                    fechaMaxima = ObtenerFechaLaboralDeSuma(fechaFinContrato, -3, feriados); //3 días antes de finalizar el contrato
                } else {
                    fechaMaxima = new Date(fechaActual.getFullYear() + 1, fechaActual.getMonth() + 1, 0); // Último día del mes actual
                }                
            }
        }

        const handleChangeMatrimonioDesde = async (e) => {                       
            setMensajeAdvertencia("")
            let fechaD = e;
            let nuevaFechaHasta = SumarDiasFecha(fechaD, 3);
            const permisoMatrimonio = props.tiposSolicitudLicencias.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado);

            if (permisoMatrimonio && permisoMatrimonio.diasmax && tipoLicenciaSeleccionado === 25) {
                setfechaDesdeNueva(e)
                nuevaFechaHasta = ObtenerFechaLaboralDeSuma(e, 2, feriados)

                setstateCard({ ...stateCard, fechaDesde: e, fechaHasta: nuevaFechaHasta })
            }
        };

        return (
            <Datepicker2
                value={fechaDesdeNueva}
                disabled={!permiso}
                name="matrimoniodesde"
                id="matrimoniodesde"
                onChange={handleChangeMatrimonioDesde}
                min={fechaMinima}
                max={fechaMaxima}
                showDisabledMonthNavigation={true}
                excludeDates={excludeDates}
                filter={(date: Date) => isWeekday(date)}
            />
        )

    }, [stateCard.fechaEvento, props.feriados, props.licenciasIngresadas, props.solicitudesVacaciones, props.licenciasComisiones, props.historial, tipoMatrimonio, props.tiposSolicitudLicencias, fechaDesdeNueva]) 

    const DatePickerLicenciaFin = useCallback((permiso: boolean) => {
        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })
        const fechaActual = new Date();
        let fechaminima = stateCard.fechaDesde ?? SumarDiasFecha(fechaActual, -7)

        const fechaCon3Meses = SumarMesesFecha(fechaActual, 3);
        const fechaUltimoDiaAnio = new Date(props.anio, 11, 31);

        let fechaMaxima = fechaCon3Meses

        let permisoSeleccionado;

        if (tipoLicenciaSeleccionado == 11) {
            permisoSeleccionado = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoCertificadoSeleccionado);
            if (permisoSeleccionado && permisoSeleccionado.diasmax) {
                fechaMaxima = SumarDiasFecha(fechaminima, permisoSeleccionado.diasmax - 1)
            }
        } else if (tipoLicenciaSeleccionado == 16) {
            permisoSeleccionado = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoCertificadoEGSeleccionado);
            if (permisoSeleccionado && permisoSeleccionado.mesesmax) {
                fechaMaxima = SumarMesesFecha(fechaminima, permisoSeleccionado.mesesmax)
            }
        } else if (tipoLicenciaSeleccionado == 36 || tipoLicenciaSeleccionado == 37) {
            permisoSeleccionado = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado);
            if (permisoSeleccionado && permisoSeleccionado.diasmax) {
                fechaMaxima = SumarDiasFecha(fechaminima, permisoSeleccionado.diasmax - 1)
            }
        } 

        return (
            <Datepicker2
                value={stateCard.fechaHasta}
                disabled={!permiso}
                name="fechahasta"
                id="fechahasta"
                onChange={(e) => setstateCard({ ...stateCard, fechaHasta: e })}
                min={fechaminima}
                max={fechaMaxima}
                showDisabledMonthNavigation={true}
            />
        )        
    }, [stateCard.fechaHasta, stateCard.fechaDesde, fechasEscogidas, props.feriados, props.anio, tipoLicenciaSeleccionado, props.licenciasIngresadas, tipoCalamidadSeleccionado, tipoCertificadoSeleccionado])

    const DatePickerCalamidadFin = useCallback((permiso: boolean) => {

        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })

        const fechaActual = new Date();
        let fechaminima = stateCard.fechaDesde ?? SumarDiasFecha(fechaActual, -7)

        const fechaCon3Meses = SumarMesesFecha(fechaActual, 3);
        const fechaUltimoDiaAnio = new Date(props.anio, 11, 31);

        let fechaMaxima = fechaCon3Meses

        let permisoSeleccionado;

        let excludeDates: (Date | undefined)[] = [];
        if (tipoLicenciaSeleccionado == 17) {
            permisoSeleccionado = props.subtipoPermisos.find(sp => sp.idtipopermiso === tipoLicenciaSeleccionado && sp.idprnsubtipopermisos === tipoCalamidadSeleccionado);
            fechaminima = stateCard.fechaDesde ?? SumarDiasFecha(new Date(), -1)
            if (permisoSeleccionado && permisoSeleccionado.diasmax) {
                excludeDates = [...feriados];
                fechaMaxima = ObtenerFechaLaboralDeSuma(fechaminima, permisoSeleccionado.diasmax - 1, feriados)
            }
        }

        return (
            <Datepicker2
                value={stateCard.fechaHasta}
                disabled={!permiso}
                name="fechahasta"
                id="fechahasta"
                onChange={(e) => setstateCard({ ...stateCard, fechaHasta: e })}
                min={fechaminima}
                max={fechaMaxima}
                excludeDates={excludeDates}
                showDisabledMonthNavigation={true}
                filter={(date: Date) => isWeekday(date)}
            />
        )
    }, [stateCard.fechaHasta, stateCard.fechaDesde, fechasEscogidas, props.feriados, props.anio, tipoLicenciaSeleccionado, props.licenciasIngresadas, tipoCalamidadSeleccionado, tipoCertificadoSeleccionado])

    const inputHoraDesde = useCallback(
        () => {
            const handleBlur = () => {

                if (errorHoras !== "") {
                    Swal.fire({
                        text: errorHoras,
                        imageUrl: `${WarningSVG}`,
                        imageHeight: 100, // Ajusta el tamaño según sea necesario
                        imageAlt: "Anuncio",
                        confirmButtonText: "Entendido",
                        confirmButtonColor: "#243165",
                    });
                }
            };
            return (
                <Input disabled={!habilitarIngresoHoras} type="time" className="inputTime" value={horaDesde} onChange={(e) => OnChangeHoraDesde(e)} onBlur={handleBlur} style={{ padding: "5px 1px" }} />
            )
        },
        [horaDesde, habilitarIngresoHoras, errorHoras]
    )

    useEffect(() => {

        if ((horaDesdeCH !== undefined && horaDesdeCH !== "" && horaDesdeCH !== null) && (horaHastaCH !== undefined && horaHastaCH !== "" && horaHastaCH !== null)) {

            const fecha = new Date();
            const fechaEscogida = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());

            const horaDesdeAnterior = props.horaEntrada;
            const horaHastaAnterior = props.horaSalida;

            const [hora_entrada, minuto_entrada] = horaDesdeCH.split(":");
            const [hora_salida, minuto_salida] = horaHastaCH.split(":");

            const [hora_entrada_permitida, minuto_entrada_permitida] = props.horaEntradaRegimen.split(":");
            const [hora_salida_permitida, minuto_salida_permitida] = props.horaSalidaRegimen.split(":");

            const tiempoAlmuerzo = TIEMPO_ALMUERZO.split(':');
            const tiempoAlmuerzoMinutos = (+tiempoAlmuerzo[0]) * 60 + (+tiempoAlmuerzo[1]);

            const horaEntradaDelDia = add(fechaEscogida, { hours: +hora_entrada, minutes: +minuto_entrada })
            const horaSalidaDelDia = add(fechaEscogida, { hours: +hora_salida, minutes: +minuto_salida })

            const horaEntradaPermitidaDelDia = add(fechaEscogida, { hours: +hora_entrada_permitida, minutes: +minuto_entrada_permitida })
            const horaSalidaPermitidaDelDia = add(fechaEscogida, { hours: +hora_salida_permitida, minutes: +minuto_salida_permitida })

            const diferenciaHorasHorarioLaboral = (+differenceInMinutes(horaSalidaDelDia, horaEntradaDelDia)) / 60;
            const diferenciaMinutos = +differenceInMinutes(horaSalidaDelDia, horaEntradaDelDia);
            const diferencia = toHoursAndMinutes(diferenciaMinutos - tiempoAlmuerzoMinutos);
            setHorasSolicitdaCH(diferencia);
            if (diferenciaHorasHorarioLaboral < 0) {
                seterrorHoras("La hora de salida debe de ser mayor que la hora de entrada.")
            } else if (diferenciaHorasHorarioLaboral > 0 && diferenciaHorasHorarioLaboral != 6.5) {
                seterrorHoras("El horario laboral debe de tener una duración de 6 horas.")
            } else if (diferenciaHorasHorarioLaboral > 0 && diferenciaHorasHorarioLaboral == 6.5 && horaDesdeCH == horaDesdeAnterior && horaHastaCH == horaHastaAnterior) {
                seterrorHoras("La hora de entrada o la hora de salida deben de ser diferentes al horario ya existente.")
            } else if (horaEntradaDelDia < horaEntradaPermitidaDelDia) {
                seterrorHoras("La hora de entrada no puede ser menor a la hora permitida por su régimen.")
            } else if (horaSalidaDelDia > horaSalidaPermitidaDelDia) {
                seterrorHoras("La hora de salida no puede ser mayor a la hora permitida por su régimen.")
            } else {
                seterrorHoras("")
            }
        }
    }, [horaDesdeCH, horaHastaCH])



    const inputHoraHasta = useCallback(
        () => {
            const handleBlur = () => {
                // Aquí pones la lógica para lanzar el modal cuando se cumplan ciertas condiciones
                if (horarioAlmuerzo) {
                    Swal.fire({
                        text: "¿El permiso solicitado incluye su tiempo de receso?",
                        imageUrl: `${AnuncioSVG}`,
                        imageHeight: 100,
                        imageAlt: "Anuncio",
                        showCancelButton: true,
                        confirmButtonText: "NO",
                        confirmButtonColor: "#243165",
                        cancelButtonText: "SI",
                        cancelButtonColor: "#243165",
                        reverseButtons: true,
                        customClass: {
                            cancelButton: 'custom-cancel-button'
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            mostrarMensajeRecuerdo();
                        } else if (result.isDismissed) {
                            setincluyeHoraAlmuerzo(true);

                        }
                    });
                }

                if (errorHoras !== "") {
                    Swal.fire({
                        text: errorHoras,
                        imageUrl: `${WarningSVG}`,
                        imageHeight: 100, // Ajusta el tamaño según sea necesario
                        imageAlt: "Anuncio",
                        confirmButtonText: "Entendido",
                        confirmButtonColor: "#243165",
                    });
                }
            };
            return (
                <>
                    <Input disabled={!habilitarIngresoHoras || (horaDesde !== undefined && horaHasta === undefined && errorHoras !== "") || horaDesde === undefined || horaDesde === ""} type="time" className="inputTime" min={"08:01"} max={"16:30"} value={horaHasta} onChange={(e) => OnChangeHoraHasta(e)} onBlur={handleBlur} style={{ padding: "5px 1px" }} />
                </>
            )
        },
        [horaDesde, horaHasta, habilitarIngresoHoras, errorHoras, horarioAlmuerzo, incluyeHoraAlmuerzo]
    )

    const InputHoraHastaEditar = ({ horaHastaInicial, onHoraHastaChange }) => {
        const [horaHasta, setHoraHasta] = useState(horaHastaInicial || "");
        useEffect(() => {
            setHoraHasta(horaHastaInicial || "");
        }, [horaHastaInicial]);

        const handleChange = (e) => {
            const newHoraHasta = e.target.value;
            setHoraHasta(newHoraHasta);
            onHoraHastaChange(newHoraHasta); // Actualizar el estado en el componente padre

        };

        return (
            <Input
                type="time"
                className="inputTime"
                min="08:01"
                max="16:30"
                value={horaHasta}
                onChange={handleChange}
                style={{ padding: "5px 1px" }}
            />
        );
    };

    const InputHoraDesdeEditar = ({ horaDesdeInicial, onHoraDesdeChange }) => {
        const [horaDesde, setHoraDesde] = useState(horaDesdeInicial || "");
        useEffect(() => {
            setHoraDesde(horaDesdeInicial || "");
        }, [horaDesdeInicial]);

        const handleChange = (e) => {
            const newHoraHasta = e.target.value;
            setHoraDesde(newHoraHasta);
            onHoraDesdeChange(newHoraHasta); // Actualizar el estado en el componente padre

        };

        return (
            <Input
                type="time"
                className="inputTime"
                min="08:01"
                max="16:30"
                value={horaDesde}
                onChange={handleChange}
                style={{ padding: "5px 1px" }}
            />
        );
    };


    const AuxiliarCrearSolicitudPermisosPost = useCallback(
        () => {
            setstateCard({ ...stateCard, loadingCreacion: true })
            if (fechaPermisoHora) {

                if (tipoLicenciaSeleccionado === 36 || tipoLicenciaSeleccionado === 37) {
                    const formData = new FormData()
                    const incluyeAlmuerzo = incluyeHoraAlmuerzo || descontandoTiempoAlmuerzo
                    formData.append('Observacion', observacionPermiso)
                    formData.append('TipoPermiso', tipoLicenciaSeleccionado.toString())
                    formData.append('HoraInicio', horaDesde)
                    formData.append('HoraFin', horaHasta)
                    formData.append('PermisoHoraIncluyeAlmuerzo', incluyeAlmuerzo.toString())
                    formData.append('Subtipo', '0')
                    if (stateCard.fechaEvento != null) {
                        formData.append('FechaEvento', PruebaSolucion2(stateCard.fechaEvento))
                    }
                    if (stateCard.fechaDesde != null) {
                        formData.append('FechaInicio', PruebaSolucion2(stateCard.fechaDesde))
                    }
                    if (stateCard.fechaHasta != null) {
                        formData.append('FechaFin', PruebaSolucion2(stateCard.fechaHasta))
                    }
                    if (certMedico.length > 0) {
                        certMedico.map((fileData) => {
                            formData.append('CertMedico', fileData.file, fileData.file.name);
                        });
                    }
                    formData.append('identificacionConyuge', cedulaConyugue);
                    formData.append('tipoEventoMatrimonio', tipoEventoMatrimonio);
                    formData.append('modalidadLicenciaMatrimonio', tipoMatrimonio);
                    formData.append('tipoIdentificacion', tipoIdentificacion);
                    formData.append('Conyuge', nombreCompletoConyuge);

                    return formData;
                } 

                else {
                    const condicionPermisoPorHoras = habilitarIngresoHoras && fraccionHoraDia !== undefined && fraccionHoraDia < 1;
                    const fechaDesdeConHoras = AgregarHoraAFecha(fechaPermisoHora, horaDesde)
                    const fechaHastaConHoras = AgregarHoraAFecha(fechaPermisoHora, horaHasta)
                    const incluyeAlmuerzo = incluyeHoraAlmuerzo || descontandoTiempoAlmuerzo
                    const formData = new FormData()
                    formData.append('FechaInicio', PruebaSolucion2(fechaDesdeConHoras).toString())
                    formData.append('FechaFin', PruebaSolucion2(fechaHastaConHoras).toString())
                    formData.append('Observacion', observacionPermiso)
                    formData.append('TipoPermiso', tipoPermisoSeleccionado.toString())
                    formData.append('HoraInicio', horaDesde)
                    formData.append('HoraFin', horaHasta)
                    formData.append('PermisoHoraIncluyeAlmuerzo', incluyeAlmuerzo.toString())
                    if (tipoCalamidadSeleccionado !== 0) {
                        formData.append('Subtipo', tipoCalamidadSeleccionado.toString())
                    }
                    if (tipoNacMaternidadSeleccionado !== 0) {
                        formData.append('Subtipo', tipoNacMaternidadSeleccionado.toString())
                    }
                    if (tipoNacPaternidadSeleccionado !== 0) {
                        formData.append('Subtipo', tipoNacPaternidadSeleccionado.toString())
                    }
                    if (tipoCertificadoEGSeleccionado !== 0) {
                        formData.append('Subtipo', tipoCertificadoEGSeleccionado.toString())
                    }
                    if (hijoSeleccionado !== 0) {
                        formData.append('idDependiente', hijoSeleccionado.toString())
                    }
                    if (certMedico.length > 0) {
                        certMedico.map((fileData) => {
                            formData.append('CertMedico', fileData.file, fileData.file.name);
                        });
                    }
                    if (certProgCita.length > 0) {
                        certProgCita.map((fileData) => {
                            formData.append('CertProgCita', fileData.file, fileData.file.name);
                        });
                    }
                    formData.append('identificacionConyuge', cedulaConyugue);
                    formData.append('tipoEventoMatrimonio', tipoEventoMatrimonio);
                    formData.append('modalidadLicenciaMatrimonio', tipoMatrimonio);
                    formData.append('tipoIdentificacion', tipoIdentificacion);
                    formData.append('Conyuge', nombreCompletoConyuge);
                    return formData;
                }

            } else {

                const formData = new FormData()
                formData.append('Observacion', observacionPermiso)
                if (tipoPermisoSeleccionado == 0 && tipoLicenciaSeleccionado !== 0) {
                    formData.append('TipoPermiso', tipoLicenciaSeleccionado.toString())
                }
                if (horaDesde == "") {
                    formData.append('HoraInicio', props.horarioLaboralPersona[0].horaentrada)
                }
                if (horaHasta == "") {
                    formData.append('HoraFin', props.horarioLaboralPersona[0].horasalida)
                } if (stateCard.fechaEvento != null) {
                    formData.append('FechaEvento', PruebaSolucion2(stateCard.fechaEvento))
                }
                if (stateCard.fechaDesde != null) {
                    formData.append('FechaInicio', PruebaSolucion2(stateCard.fechaDesde))
                }
                if (stateCard.fechaHasta != null) {
                    formData.append('FechaFin', PruebaSolucion2(stateCard.fechaHasta))
                }
                if (tipoCalamidadSeleccionado !== 0) {
                    formData.append('Subtipo', tipoCalamidadSeleccionado.toString())
                }
                if (tipoNacMaternidadSeleccionado !== 0) {
                    formData.append('Subtipo', tipoNacMaternidadSeleccionado.toString())
                }
                if (tipoNacPaternidadSeleccionado !== 0) {
                    formData.append('Subtipo', tipoNacPaternidadSeleccionado.toString())
                }
                if (tipoCertificadoSeleccionado !== 0) {
                    formData.append('Subtipo', tipoCertificadoSeleccionado.toString())
                }
                if (tipoCertificadoEGSeleccionado !== 0) {
                    formData.append('Subtipo', tipoCertificadoEGSeleccionado.toString())
                }
                if (provinciaSeleccionado !== 0) {
                    formData.append('idProvincia', provinciaSeleccionado.toString())
                }
                if (certMedico.length > 0) {
                    certMedico.map((fileData) => {
                        formData.append('CertMedico', fileData.file, fileData.file.name);
                    });
                }
                if (certProgCita.length > 0) {
                    certProgCita.map((fileData) => {
                        formData.append('CertProgCita', fileData.file, fileData.file.name);
                    });
                }  
                formData.append('identificacionConyuge', cedulaConyugue);
                formData.append('tipoEventoMatrimonio', tipoEventoMatrimonio);
                formData.append('modalidadLicenciaMatrimonio', tipoMatrimonio);
                formData.append('tipoIdentificacion', tipoIdentificacion);
                formData.append('Conyuge', nombreCompletoConyuge);
                return formData;


            }



        },
        [stateCard, horaDesde, horaHasta, fechaPermisoHora, observacionPermiso, fechasEscogidas, props.acuerdoMediosElectronicos, tipoPermisoSeleccionado, certMedico, tipoCertificadoEGSeleccionado, props.horarioLaboralPersona, tipoLicenciaSeleccionado, informacionConyugue, tipoEventoMatrimonio, tipoMatrimonio, cedulaConyugue, tipoIdentificacion, nombreCompletoConyuge],
    )

    const handleCedulaConyugue = (event) => {
        setMensajeAdvertencia("");
        setCedulaConyugue(event.target.value);
        let mensajeAdvertenciaTemp = "";
        if (event.target.value && event.target.value.length == 10) {
            buscarConyugue(event.target.value);            
        } 
        else if (event.target.value && event.target.value.length != 10) {
            limpiarDatosConyugue()
        }        
    };

    function buscarConyugue(identificacion: string) {
        var nombresConyugue = "";
        var apellidosConyugue = "";
        var nombrecompletoConyugue = "";
        var estadocivilConyugue = "";
        var personaConyugue = "";
        let conyugue: InformacionConyugueData = {
            apellidos: "",
            nombres: "",
            nombrecompleto: "",
            numeroidentificacion: identificacion,
            tipoidentificacion: "CED",
            estadocivil: "",
            nombreconyugue: ""
        };
        let mensajeAdvertenciaTemp = "";

        // Validación básica de identificación (puedes ajustar según tus requisitos)
        if (!identificacion || identificacion.trim() === "") {
            alertService.error("Por favor ingrese un número de cédula válido.");
            return;
        }

        fetch(API_URL + "DatosGenerales/Ciudadano/" + identificacion)
            .then(res => {
                if (!res.ok) {
                    throw new Error("No se pudo conectar con el servicio de consulta");
                }
                return res.json();
            })
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        if (result.entTabla && result.entTabla.length > 0 && result.entTabla[0].error != "N.U.I. INCORRECTO.") {
                            if (result.entTabla[0].nombrePadre && result.entTabla[0].nombreMadre && result.entTabla[0].nombre) {
                                const { nombre, apellido, apellido2 } = getNombresCompletos(
                                    result.entTabla[0].nombrePadre,
                                    result.entTabla[0].nombreMadre,
                                    result.entTabla[0].nombre
                                );
                                nombresConyugue = nombre;
                                apellidosConyugue = apellido + " " + apellido2;
                                nombrecompletoConyugue = nombre + " " + apellido + " " + apellido2;
                            }

                            estadocivilConyugue = (result.entTabla[0].estadoCivil === "CASADO" ? "C" :
                                result.entTabla[0].estadoCivil === "EN UNION DE HECHO" ? "U" : "S");
                            personaConyugue = result.entTabla[0].conyugue || "";

                            conyugue = {
                                apellidos: apellidosConyugue,
                                nombres: nombresConyugue,
                                nombrecompleto: nombrecompletoConyugue,
                                numeroidentificacion: identificacion,
                                tipoidentificacion: "CED",
                                estadocivil: estadocivilConyugue,
                                nombreconyugue: personaConyugue
                            };

                            setInformacionConyugue(conyugue);
                            setNombreCompletoConyuge(conyugue.nombrecompleto);

                            if ((conyugue.estadocivil === "C" || conyugue.estadocivil === "U") && tipoMatrimonio == "A") {
                                mensajeAdvertenciaTemp = "La persona ingresada ya se encuentra casado(a) o en unión libre, no puede realizar la solicitud.";
                                showAlertWarning(mensajeAdvertenciaTemp, WarningSVG, true);
                                limpiarFechasCardYModal();
                                setTipoLicenciaSeleccionado(0);
                            }
                        } else {
                            // Caso cuando la cédula no existe (entTabla vacío)
                            mensajeAdvertenciaTemp = "La cédula ingresada no existe en el registro civil.";
                            showAlertWarning(mensajeAdvertenciaTemp, WarningSVG, true);
                            limpiarFechasCardYModal();
                            setTipoLicenciaSeleccionado(0);
                        }
                    } else {
                        // Caso cuando strEstado no es "S"
                        mensajeAdvertenciaTemp = "No se encontró información para la cédula ingresada.";
                        showAlertWarning(mensajeAdvertenciaTemp, WarningSVG, true);
                        limpiarFechasCardYModal();
                        setTipoLicenciaSeleccionado(0);
                    }

                    if (mensajeAdvertenciaTemp !== "") {
                        setMensajeAdvertencia(mensajeAdvertenciaTemp);
                    }
                },
                (error) => {
                    alertService.error("Ocurrió un error al consultar: " + error.message);
                    limpiarDatosConyugue();
                }
            );
    }

    // Función auxiliar para limpiar los datos del cónyuge
    function limpiarDatosConyugue() {
        setInformacionConyugue(defaultStateInformacionConyugue);
        setNombreCompletoConyuge("");
    }

    function getNombresCompletos(nombre_padre, nombre_madre, nombre: string) {
        var nombres = "";
        var apellido_padre = "";
        var apellido_madre = "";

        var padre_list: string[] = nombre_padre.trim().split(' ');
        var madre_list: string[] = nombre_madre.trim().split(' ');
        var nombres_list = nombre.trim().split(' ');

        var herencia_padre_tmp = padre_list.filter(x => nombres_list.includes(x.toString()));
        var herencia_madre_tmp = madre_list.filter(x => nombres_list.includes(x.toString()));

        var herencia_padre_array = herencia_padre_tmp;
        var herencia_madre_array = herencia_madre_tmp;

        if (herencia_padre_tmp.length === 0 && herencia_madre_tmp.length > 0) {
            const indiceApellidoMadre = nombre.indexOf(herencia_madre_tmp[0]);
            padre_list = nombre.slice(0, indiceApellidoMadre).trim().split(' ');
            herencia_padre_array = padre_list;

            if (herencia_padre_array.length > 0 && herencia_padre_array[0] === "") {
                const division_nombres: string[] = nombre.split(" ");
                var nombres_input: string = ""
                var apellido: string
                var apellido2: string

                if (division_nombres.length === 4) {
                    division_nombres.slice(2, undefined).forEach(n => {
                        nombres_input += n + " ";
                    });
                    apellido = division_nombres[0];
                    apellido2 = division_nombres[1];

                    return {
                        nombre: nombres_input,
                        apellido: apellido,
                        apellido2: apellido2
                    };
                }
            }
        }

        if (herencia_padre_array.length === 0 && herencia_madre_array.length === 0) {
            const division_nombres: string[] = nombre.split(" ");
            var nombres_input: string = ""
            var apellido: string
            var apellido2: string

            if (division_nombres.length === 4) {
                division_nombres.slice(2, undefined).forEach(n => {
                    nombres_input += n + " ";
                });
                apellido = division_nombres[0];
                apellido2 = division_nombres[1];

                return {
                    nombre: nombres_input,
                    apellido: apellido,
                    apellido2: apellido2
                };
            }
            else if (division_nombres.length === 5) {
                division_nombres.slice(3, undefined).forEach(n => {
                    nombres_input += n + " ";
                });
                apellido = division_nombres[0];
                apellido2 = division_nombres[1] + " " + division_nombres[2];

                return {
                    nombre: nombres_input,
                    apellido: apellido,
                    apellido2: apellido2
                };
            }
        }

        var herencia_padre: any[] = [];
        var herencia_madre: any[] = [];

        //Obtenemos el primer apellido
        var primer_apellido = "";
        if (herencia_padre_array.length > 0) {
            primer_apellido = padre_list[0];
        }
        else {
            primer_apellido = madre_list[0];
        }

        //APELLIDOS NOMBRES
        if (nombre.indexOf(primer_apellido) === 0) {
            var i_tmp = 0;
            //Limpiamos la herencia del padre
            herencia_padre = [];
            i_tmp = 0;
            for (let i = 0; i < herencia_padre_array.length; i++) {
                if (padre_list.indexOf(herencia_padre_array[i]) === i_tmp) {
                    herencia_padre.push(herencia_padre_array[i]);
                    i_tmp++;
                }
            }

            //Limpiamos la herencia del madre
            var i_tmp = 0;
            herencia_madre = [];
            i_tmp = 0;
            for (let i = 0; i < herencia_madre_array.length; i++) {
                if (madre_list.indexOf(herencia_madre_array[i]) === i_tmp) {
                    herencia_madre.push(herencia_madre_array[i]);
                    i_tmp++;
                }
            }
        }
        else {
            //Limpiamos la herencia del padre
            herencia_padre = [];
            var pos_ap = 0;
            for (let i = 0; i < herencia_padre_array.length; i++) {
                if (nombres_list.indexOf(herencia_padre_array[i]) === pos_ap) {
                    herencia_padre.push(herencia_padre_array[i]);
                    pos_ap++;
                }
            }

            //Limpiamos la herencia del madre
            herencia_madre = [];
            for (let i = 0; i < herencia_madre_array.length; i++) {
                if (nombres_list.indexOf(herencia_madre_array[i]) === pos_ap) {
                    herencia_madre.push(herencia_madre_array[i]);
                    pos_ap++;
                }
            }
        }

        herencia_padre.forEach(i_padre => {
            apellido_padre += i_padre + " ";
        }
        );

        apellido_padre = apellido_padre.trim();

        //Obtenemos el apellido de la madre
        herencia_madre.forEach(i_madre => {
            apellido_madre += i_madre + " ";
        }
        );

        apellido_madre = apellido_madre.trim();

        try {
            if (apellido_padre != "") {
                nombres = nombre.trim().replace(apellido_padre, "");
            }
            else {
                nombres = nombre;
            }

            if (apellido_madre != "") {
                nombres = nombres.replace(apellido_madre, "");
            }
            nombres = nombres.trim();
        }
        catch
        {
            nombres = "";
            apellido_padre = "";
            apellido_madre = "";
        }

        return {
            nombre: nombres,
            apellido: apellido_padre,
            apellido2: apellido_madre
        };
    }

    function GetHTMLSolicitudVacacionesIngresadas(solicitudes: Array<SolicitudPermisos>): any {
        var fechaActual = new Date();

        const htmlRowsSolicitudes = solicitudes.map((val, ind) => {
            var fechaDesde = val.fechaDesde ?? new Date()
            var fechaHasta = val.fechaHasta ?? new Date()
            var fechaEvento = val.fechaEvento ?? new Date()
            const fila = (
                <Row key={"SolicitudesVacacionesUsuario" + ind} className="mt-2 rowSolicitarPermisos">
                    <Col md={5}>
                        <FormGroup>
                            <Label for="Tipo">
                                Tipo Solicitud
                            </Label>
                            <Input type="text" readOnly className="bold" value={val.strTipoPermiso}></Input>
                        </FormGroup>
                    </Col>
                    {(val.tipoPermiso == 5 || val.tipoPermiso == 29) && (
                        <>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha:
                                    </Label>
                                    <Input type="text" readOnly className="bold" value={formatoFecha(fechaDesde.toString())}></Input>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Hora Desde:
                                    </Label>
                                    <Input type="text" readOnly className="bold" value={val.horaDesde}></Input>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Hora Hasta:
                                    </Label>
                                    <Input type="text" readOnly className="bold" value={val.horaHasta}></Input>
                                </FormGroup>
                            </Col>
                        </>
                    )}
                    {(val.tipoPermiso == 17 || val.tipoPermiso == 3 || val.tipoPermiso == 12 || val.tipoPermiso == 11 || val.tipoPermiso == 16 || val.tipoPermiso == 36 || val.tipoPermiso == 37 || val.tipoPermiso == 25) && (
                        <>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha evento:
                                    </Label>
                                    <Input type="text" readOnly className="bold" value={formatoFecha(fechaEvento.toString())}></Input>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha desde:
                                    </Label>
                                    <Input type="text" readOnly className="bold" value={formatoFecha(fechaDesde.toString())}></Input>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha hasta:
                                    </Label>
                                    <Input type="text" readOnly className="bold" value={formatoFecha(fechaHasta.toString())}></Input>
                                </FormGroup>
                            </Col>
                        </>
                    )}
                    <Col md={3}>
                        <FormGroup>
                            <Label for="Fecha">
                                Estado:
                            </Label>
                            <Input type="text" readOnly id="estadoSolicitudReplanificacion" value={val.strEstadoPermiso}></Input>
                        </FormGroup>
                    </Col>
                </Row>
            )
            return fila;

        })



        return htmlRowsSolicitudes;
    }

    /*function GetHTMLSolicitudConfirmacion(solicitud: SolicitudLicenciasPost | SolicitudPermisosPost | undefined, certMedico: Array<FileInfoUrl>): any {
        var fechaActual = new Date();
        var strTipoPermiso: string | null = "";
        var fechaPermiso = solicitud?.FechaInicio;
        var fechaPermisoFin = solicitud?.FechaFin;
        var tipoPermiso = solicitud?.TipoPermiso;
        
        var difDays: number | null = 0;
        if (fechaPermiso != undefined && fechaPermisoFin != undefined) {
            difDays = differenceInDays(fechaPermiso, fechaPermisoFin);
        }
        if (solicitud && (tipoPermiso === 5 || tipoPermiso === 38 || tipoPermiso === 29)) {
            const solicitudPermisos = solicitud as SolicitudPermisosPost;
            const tipo  = props.subtipoPermisos.find(p => p.idtipopermiso == tipoPermiso)
            if (tipo && fechaPermiso != null && solicitudPermisos.PermisoHoraIncluyeAlmuerzo !== undefined && solicitudPermisos.FechaInicio && solicitudPermisos.HoraInicio && solicitudPermisos.HoraFin) {
                const strTipoPermiso = tipo.nombre;
                const contenidoJSX = (
                    <>
                        <div>
                            {`¿Está seguro que desea registrar su ${strTipoPermiso?.toLowerCase()} del día ${formatDateToString(solicitudPermisos.FechaInicio.toString())} desde las ${solicitud.HoraInicio} hasta las ${solicitud.HoraFin}?`}

                        </div>
                        {(((solicitudPermisos.HoraInicio >= props.horaInicioAlmuerzo && solicitudPermisos.HoraInicio <= props.horaFinAlmuerzo) || (solicitudPermisos.HoraFin >= props.horaInicioAlmuerzo && solicitudPermisos.HoraFin <= props.horaFinAlmuerzo)) && !solicitudPermisos.PermisoHoraIncluyeAlmuerzo) && (
                            <small className='small-error-mensaje '>Recuerde que debe de registrar la marcación de receso</small>
                        )}
                    </>
                );
                return ReactDOMServer.renderToString(contenidoJSX);
                
            }
        } else if (solicitud && (tipoPermiso === 17 || tipoPermiso === 3 || tipoPermiso === 12 || tipoPermiso === 11|| tipoPermiso === 16)) {
     
            const solicitudLicencias = solicitud as SolicitudLicenciasPost;
            const tipo  = props.subtipoPermisos.find(p => p.idtipopermiso == tipoPermiso)
            var subtipo = props.subtipoPermisos.find(p => p.idtipopermiso == tipoPermiso && p.idprntipoproceso == solicitudLicencias.Subtipo)
            if (tipo && subtipo && fechaPermiso != null && fechaPermisoFin != null && solicitudLicencias.FechaInicio && solicitudLicencias.FechaFin ) {

                const solicitudLicencias = solicitud as SolicitudLicenciasPost;
                const tipo = tiposLicencias.find(p => p.idtipopermiso === tipoPermiso);
                if (tipo && subtipo && fechaPermiso != null && fechaPermisoFin != null && solicitudLicencias.FechaInicio && solicitudLicencias.FechaFin ) {
                    var fechaFinAct = typeof solicitudLicencias.FechaFin === 'string' ? new Date(solicitudLicencias.FechaFin) : solicitudLicencias.FechaFin;
                    if (solicitudLicencias.idProvincia) {
                          fechaFinAct.setDate(fechaFinAct.getDate() + 1);
                    }
                    console.log(fechaFinAct)
                    const strTipoPermiso = tipo.descripcion;
                    const strSubtipo = subtipo.nombre.toLowerCase();
                    
                    const contenidoJSX = (
                      <>
                          {(certMedico.length == 0) && (
                            <small className='small-error-mensaje '>Usted va a notificar una licencia por calamidad doméstica. Para completar la solicitud deberá registrar la evidencia de la calamidad</small>
                          )}
                        <div>
                            {`¿Está seguro que desea registrar su ${strTipoPermiso?.toLowerCase()} por motivo de  ${strSubtipo}, desde el día ${formatDateToString(solicitudLicencias.FechaInicio.toString())} hasta el día ${formatDateToString(fechaFinAct)}, por ${difDays} días?`}

                        </div> 
                      </>
                          
                    );
                    return ReactDOMServer.renderToString(contenidoJSX);
                }
            }

            return <div></div>;
        }
    }*/

    function GetHTMLSolicitudConfirmacion(solicitud: SolicitudLicenciasPost | SolicitudPermisosPost | undefined, certMedico: Array<FileInfoUrl>): any {
        var fechaActual = new Date();
        var strTipoPermiso: string | null = "";
        var fechaPermiso = solicitud?.FechaInicio;
        var fechaPermisoFin = solicitud?.FechaFin;
        var tipoPermiso = solicitud?.TipoPermiso;
        var difDays: number | null = 0;

        if ((fechaPermiso != undefined && fechaPermiso != null && fechaPermisoFin != undefined && tipoPermiso == 25) || (fechaPermiso != undefined && fechaPermiso != null && fechaPermisoFin != undefined && tipoPermiso == 17)) {
            difDays = NewdifferenceInBusinessDays(fechaPermisoFin, fechaPermiso);
        } else if (fechaPermiso != undefined && fechaPermiso != null && fechaPermisoFin != undefined) {
            difDays = differenceInDays(fechaPermisoFin, fechaPermiso); // Use correct order and add 1 for inclusive days
        }

        if (solicitud && (tipoPermiso === 5 || tipoPermiso === 38 || tipoPermiso === 29)) {
            const solicitudPermisos = solicitud as SolicitudPermisosPost;
            const tipo = props.subtipoPermisos.find(p => p.idtipopermiso === tipoPermiso);
            if (tipo && fechaPermiso && solicitudPermisos.PermisoHoraIncluyeAlmuerzo !== undefined && solicitudPermisos.FechaInicio && solicitudPermisos.HoraInicio && solicitudPermisos.HoraFin) {
                const strTipoPermiso = tipo.nombre;
                const contenidoJSX = (
                    <>
                        <div>
                            {`¿Está seguro que desea registrar su ${strTipoPermiso?.toLowerCase()} del día ${formatDateToString(solicitudPermisos.FechaInicio.toString())} desde las ${solicitud.HoraInicio} hasta las ${solicitud.HoraFin}?`}
                        </div>
                        {(((solicitudPermisos.HoraInicio >= props.horaInicioAlmuerzo && solicitudPermisos.HoraInicio <= props.horaFinAlmuerzo) || (solicitudPermisos.HoraFin >= props.horaInicioAlmuerzo && solicitudPermisos.HoraFin <= props.horaFinAlmuerzo)) && !solicitudPermisos.PermisoHoraIncluyeAlmuerzo) && (
                            <small className='small-error-mensaje '>Recuerde que debe de registrar la marcación de receso</small>
                        )}
                    </>
                );
                return ReactDOMServer.renderToString(contenidoJSX);
            }
        } else if (solicitud && (tipoPermiso === 17 || tipoPermiso === 3 || tipoPermiso === 12 || tipoPermiso === 11 || tipoPermiso === 16)) {
            const solicitudLicencias = solicitud as SolicitudLicenciasPost;
            const tipo = props.tiposSolicitudLicencias.find(p => p.idtipopermiso === tipoPermiso);
            const subtipo = props.subtipoPermisos.find(p => p.idtipopermiso === tipoPermiso && p.idprnsubtipopermisos === solicitudLicencias.Subtipo);

            if (tipo && subtipo && fechaPermiso && fechaPermisoFin) {
                const strTipoPermiso = tipo.descripcion;
                const strSubtipo = subtipo.nombre.toLowerCase();
                var fechaFinAct = GetDateObjectFromIsoFormat(fechaPermisoFin.toString()) ?? new Date();

                if (solicitudLicencias.idProvincia && difDays) {
                    difDays += 1;
                    fechaFinAct.setDate(fechaFinAct.getDate() + 1);
                }

                const contenidoJSX = (
                    <>
                        {mensajeAdvertencia && (
                            <small className='small-error-mensaje '>{mensajeAdvertencia}</small>
                        )}
                        {certMedico.length === 0 && (
                            <small className='small-error-mensaje '>Usted va a notificar una licencia por calamidad doméstica. Para completar la solicitud deberá registrar la evidencia de la calamidad</small>
                        )}
                        <div>
                            {`¿Está seguro que desea registrar su ${strTipoPermiso?.toLowerCase()} por motivo de "${strSubtipo}", desde el día ${ObtenerFechaFromIsoFormat(fechaPermiso.toString())} hasta el día ${formatDateToString(fechaFinAct.toString())}, por ${difDays} días?`}
                        </div>
                    </>
                );
                return ReactDOMServer.renderToString(contenidoJSX);
            }
        } else if (solicitud && (tipoPermiso === 36 || tipoPermiso === 37)) {
            const solicitudLicencias = solicitud as SolicitudLicenciasPost;

            const tipo = props.tiposSolicitudLicencias.find(p => p.idtipopermiso === tipoPermiso);

            if (tipo && fechaPermiso && fechaPermisoFin && solicitudLicencias.PermisoHoraIncluyeAlmuerzo !== undefined && solicitudLicencias.HoraInicio && solicitudLicencias.HoraFin) {
                const strTipoPermiso = tipo.descripcion;
                var fechaFinAct = new Date(fechaPermisoFin);

                const contenidoJSX = (
                    <>

                        <div>
                            {`¿Está seguro que desea registrar su ${strTipoPermiso?.toLowerCase()}, desde el día ${formatDateToString(fechaPermiso.toString())} hasta el día ${formatDateToString(fechaFinAct.toString())} de ${horasSolicitadas} de duración, por ${difDays} días ?`}
                        </div>
                        {(((solicitudLicencias.HoraInicio >= props.horaInicioAlmuerzo && solicitudLicencias.HoraInicio <= props.horaFinAlmuerzo) || (solicitudLicencias.HoraFin >= props.horaInicioAlmuerzo && solicitudLicencias.HoraFin <= props.horaFinAlmuerzo)) && !solicitudLicencias.PermisoHoraIncluyeAlmuerzo) && (
                            <small className='small-error-mensaje '>Recuerde que debe de registrar la marcación de receso</small>
                        )}
                    </>
                );
                return ReactDOMServer.renderToString(contenidoJSX);
            }
        } else if (solicitud && tipoPermiso === 25) {
            const solicitudLicencias = solicitud as SolicitudLicenciasPost;
            const tipo = props.tiposSolicitudLicencias.find(p => p.idtipopermiso === tipoPermiso);


            if (tipo && fechaPermiso && fechaPermisoFin) {
                const strTipoPermiso = tipo.descripcion;
                var fechaFinAct = new Date(fechaPermisoFin);

                const contenidoJSX = (
                    <>
                        {mensajeAdvertencia && (
                            <small className='small-error-mensaje '>{mensajeAdvertencia}</small>
                        )}
                        <div>
                            {`¿Está seguro que desea registrar su ${strTipoPermiso?.toLowerCase()}, desde el día ${formatDateToString(fechaPermiso.toString())} hasta el día ${formatDateToString(fechaFinAct.toString())}, por ${difDays} días?`}
                        </div>                        
                    </>
                );
                return ReactDOMServer.renderToString(contenidoJSX);
            }
            return <div></div>;
        }
     }

    function GetHTMLSolicitudPermisosRechazadas(solicitudes: Array<SolicitudPermisos>): any {
        var fechaActual = new Date();
        //fechaActual = SumarDiasFecha(fechaActual, 7);
        const htmlRowsSolicitudes = solicitudes.map((val, ind) => {

            const fechaSolicitud = val.fechaSolicitud ?? new Date()
            const fechaInicio = val.fechaDesde ?? new Date()
            const fechaFin = val.fechaHasta ?? new Date()
            const fechaEvento = val.fechaEvento ?? new Date()

            const tipoEvento = val.tipoEventoMatrimonio
            const modalidadEvento = val.modalidadLicenciaMatrimonio

            let fechaSolicitudDate = new Date(fechaSolicitud)
            let fechaEventoDate = new Date(fechaEvento)
            let fechaInicioDate = new Date(fechaInicio)
            let fechaFinDate = new Date(fechaFin)

            const puedeEditar = (val.tipoPermiso === 5
                && val.estadoPermiso === "F"
                && fechaActual <= new Date(fechaInicioDate.getTime() + 2 * 24 * 60 * 60 * 1000));
            const puedeEditarDocumento = (val.tipoPermiso === 5
                && val.estadoPermiso === "F"
                && fechaActual < fechaInicioDate);

            const puedeEditarMaternidad = (val.tipoPermiso === 3
                && val.estadoPermiso === "E")

            const puedeEditarPaternidad = (val.tipoPermiso === 12
                && val.estadoPermiso === "E")

            const puedeEditarLicencia = val.estadoPermiso === "E"

            const fila = (
                <Row key={"SolicitudesVacacionesUsuario" + ind} className="mt-2 rowSolicitarPermisos">
                    <Col md={1}></Col>
                    <Col md={10} style={{ paddingRight: 0 }}>
                        <FormGroup>
                            <Label for="Tipo">
                                Tipo Solicitud
                            </Label>
                            <Input type="text" readOnly className="input-readonly-custom" value={val.strTipoPermiso}></Input>
                        </FormGroup>
                    </Col>                    
                    {val.estadoPermiso == "E" && (
                        <>
                            <Col md={{size: 10, offset: 1}} className="pr-0" style={{ paddingRight: 0 }}>
                                <FormGroup>
                                    <Label for="nuevoMotivoRechazo" className="label-permiso">Motivo del Rechazo</Label>
                                    <Input type="textarea" value={val.motivoRechazo} readOnly className="input-readonly-custom" id="nuevoMotivoRechazo" rows="2"></Input>
                                </FormGroup>
                            </Col>
                        </>
                    )}
                    {(val.tipoPermiso != 3 && val.tipoPermiso != 12 && val.tipoPermiso != 25) && (
                        <>
                            <Col md={{ size: 2, offset: 1 }}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha Solicitud
                                    </Label>
                                    <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaSolicitud.toString())}></Input>
                                </FormGroup>
                            </Col>
                        </>
                    ) }                    
                    {(val.tipoPermiso == 5) ? (
                        <>                            
                            {(val.estadoPermiso == "F") ? (
                                <>
                                    <Col md={{size: 2, offset: 1}}>
                                        <FormGroup>
                                            <Label for="Fecha">
                                                Fecha de Permiso:
                                            </Label>
                                            {puedeEditar ? (
                                                <DatePickerFechaHoraEditar FechaInicial={val.fechaDesde} onFechaInicialChange={OnChangeFechaPermisoNuevo} TipoPermiso={val.tipoPermiso} />
                                            ) : (
                                                    <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaInicio.toString())}></Input>
                                            )}
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup>
                                            <Label for="Fecha">
                                                Hora Desde:
                                            </Label>
                                            {puedeEditar ? (
                                                <InputHoraDesdeEditar horaDesdeInicial={val.horaDesde} onHoraDesdeChange={OnChangeHoraDesdeNuevo} />
                                            ) : (
                                                    <Input type="text" readOnly className="input-readonly-custom" value={val.horaDesde}></Input>
                                            )}
                                        </FormGroup>
                                    </Col>
                                    <Col md={{ size: 2, offset: 1 }}>
                                        <FormGroup>
                                            <Label for="Fecha">
                                                Hora Hasta:
                                            </Label>
                                            {puedeEditar ? (
                                                <InputHoraHastaEditar horaHastaInicial={val.horaHasta} onHoraHastaChange={OnChangeHoraHastaNuevo} />
                                            ) : (
                                                <Input type="text" readOnly className="input-readonly-custom" value={val.horaHasta}></Input>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </>
                            ) : (val.estadoPermiso == "E") ? (
                                    <>
                                        <Col md={{ size: 2, offset: 1 }}>
                                            <FormGroup>
                                                <Label for="Fecha">
                                                    Fecha del Permiso:
                                                </Label>
                                                <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaInicio.toString())}></Input>
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup>
                                                <Label for="Fecha">
                                                    Hora Desde:
                                                </Label>
                                                <Input type="text" readOnly className="input-readonly-custom" value={val.horaDesde}></Input>
                                            </FormGroup>
                                        </Col>
                                        <Col md={{ size: 2, offset: 1 }}>
                                            <FormGroup>
                                                <Label for="Fecha">
                                                    Hora Hasta:
                                                </Label>
                                                <Input type="text" readOnly className="input-readonly-custom" value={val.horaHasta}></Input>
                                            </FormGroup>
                                        </Col>
                                    </>
                            ) : (<></>)}
                        </>
                    ) : (val.tipoPermiso == 29) && (
                            <>                                
                            <Col md={{size: 2, offset: 1}}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha del Permiso*:
                                    </Label>
                                    <DatePickerEditarFechaEvento fechaEventoOriginal={fechaEventoEditar} tipoAlumbramiento={"matriculacion"} fechaSolicitud={fechaSolicitudDate} />
                                </FormGroup>
                            </Col>
                            <Col md={5} style={{ paddingRight: 0 }}>
                                    <FormGroup>
                                        <Label for="Tipo">
                                            Hijo/a
                                        </Label>
                                        <Input type="text" readOnly className="input-readonly-custom" value={val.strNombreHijo}></Input>
                                    </FormGroup>
                            </Col>
                            <Col md={{size: 2, offset: 1}}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Hora Desde:
                                    </Label>
                                        <Input type="text" readOnly className="input-readonly-custom" value={val.horaDesde}></Input>
                                </FormGroup>
                                </Col>
                                <Col md={1}></Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Hora Hasta:
                                    </Label>
                                        <Input type="text" readOnly className="input-readonly-custom" value={val.horaHasta}></Input>
                                </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Label for="Fecha">
                                            Horas Solicitadas:
                                        </Label>
                                        <Input type="text" readOnly className="input-readonly-custom" value={val.horasSolicitadas}></Input>
                                    </FormGroup>
                                </Col>
                        </>
                    )}
                    {(val.tipoPermiso == 11 || val.tipoPermiso == 17 || val.tipoPermiso == 16 || val.tipoPermiso == 36 || val.tipoPermiso == 37) ? (
                        <>
                           {(puedeEditarLicencia && (val.tipoPermiso == 11 || val.tipoPermiso == 17)) ? (
                                <Col md={{ size: 2, offset: 1 }}>
                                    <FormGroup>
                                        <Label for="Fecha">
                                            Fecha Desde*:
                                        </Label>
                                        <DatePickerFechaHoraEditar FechaInicial={val.fechaDesde} onFechaInicialChange={OnChangeFechaPermisoNuevo} TipoPermiso={val.tipoPermiso} />
                                    </FormGroup>
                                </Col>
                            ) : (
                                <Col md={{ size: 2, offset: 1 }}>
                                    <FormGroup>
                                        <Label for="Fecha">
                                            Fecha Desde:
                                        </Label>
                                        <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaInicio.toString())}></Input>
                                    </FormGroup>
                                </Col>
                            )}

                            {(puedeEditarLicencia && (val.tipoPermiso == 11 || val.tipoPermiso == 17)) ? (
                                <Col md={2}>
                                    <FormGroup>
                                        <Label for="Fecha">
                                            Fecha Hasta*:
                                        </Label>
                                        <DatePickerEditarFechaEvento fechaEventoOriginal={fechaEventoEditar} tipoAlumbramiento={val.certificadoValidado} fechaSolicitud={fechaSolicitudDate} />
                                    </FormGroup>
                                </Col>
                            ): (
                                <Col md={2}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha Hasta:
                                    </Label>
                                    <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaFin.toString())}></Input>
                                </FormGroup>
                            </Col>
                            ) }
                            <Col md={{ size: 2, offset: 1 }} className="pr-0">
                                <FormGroup>
                                    <Label for="diasSolicitados" className="label-permiso">
                                        Días Solicitados
                                    </Label>
                                    <Input
                                        type="text"
                                        value={val.diasSolicitadas}
                                        readOnly
                                        className="input-readonly-custom"
                                        id="horas_solicitadas"
                                        style={{ minHeight: "30px" }}
                                    ></Input>
                                </FormGroup>
                            </Col>
                        </>
                    ) : (val.tipoPermiso == 3 && val.estadoPermiso == "E") ? (
                            <>
                                <Col md={{ size: 2, offset: 1 }}>
                                    <FormGroup>
                                        <Label for="Fecha">
                                            Fecha Solicitud
                                        </Label>
                                        <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaSolicitud.toString())}></Input>
                                    </FormGroup>
                                </Col>
                                <Col md={{ size: 2, offset: 1 }}>
                                    <FormGroup>
                                        <Label for="Fecha">
                                            Fecha Evento*:
                                        </Label>
                                        {puedeEditarMaternidad ? (
                                            <DatePickerEditarFechaEvento fechaEventoOriginal={fechaEventoEditar} tipoAlumbramiento={tipoAlumbramiento} fechaSolicitud={fechaSolicitudDate} />
                                        ) : (
                                            <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaEvento.toString())}></Input>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col md={5} className="pr-0" style={{ paddingRight: 0 }}>
                                <FormGroup>
                                    <Label for="nuevoTipoAlumbramiento" className="label-permiso">Tipo de Alumbramiento*</Label>
                                    <Input
                                        type="select"
                                        value={tipoAlumbramiento}
                                        onChange={handleNuevoTipoAlumbramientoChange}
                                        id="nuevoTipoAlumbramiento"
                                    >
                                        <option value="">{tipoAlumbramiento}</option>
                                        {tipoAlumbramiento == "NACIMIENTO MÚLTIPLE" ? (
                                            <option value="NACIMIENTO 1 HIJO, POR PARTO NATURAL O CESÁREA">NACIMIENTO 1 HIJO, POR PARTO NATURAL O CESÁREA</option>
                                        ) : (
                                            <option value="NACIMIENTO MÚLTIPLE">NACIMIENTO MÚLTIPLE</option>
                                        )}
                                    </Input>
                                </FormGroup>
                                </Col>                               
                            <Col md={{size: 2, offset: 1}}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha Desde:
                                    </Label>
                                    {fechaInicioEditar ? (
                                            <Input type="text" readOnly className="input-readonly-custom" value={formatDateToString(fechaInicioEditar)} />
                                    ) : (
                                                <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaInicio.toString())}></Input>)}
                                </FormGroup>
                                </Col>
                                <Col md={1}></Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha Hasta:
                                    </Label>
                                    {fechaInicioEditar ? (
                                            <Input type="text" readOnly className="input-readonly-custom" value={formatDateToString(SumarDiasFecha(fechaInicioEditar, diasSolicitadosEditar - 1))} />
                                    ) : (
                                                <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaFin.toString())}></Input>)}
                                </FormGroup>
                            </Col>
                            <Col md={2} className="pr-0">
                                <FormGroup>
                                    <Label for="diasSolicitados" className="label-permiso">
                                        Días Solicitados
                                    </Label>
                                    {fechaEventoEditar ? (
                                        <Input type="text" readOnly value={diasSolicitadosEditar} id="horas_solicitadas" style={{ minHeight: "30px" }} />
                                    ) : (
                                        <Input
                                            type="text"
                                            value={val.diasSolicitadas}
                                            readOnly
                                            id="horas_solicitadas"
                                            style={{ minHeight: "30px" }}
                                        ></Input>
                                    )}
                                </FormGroup>
                                </Col>
                                <Col md={4}></Col>
                                <Col md={{ size: 5, offset: 1 }} style={{ paddingRight: 0 }}>
                                <FormGroup>
                                    <Label for="archivo">
                                        Subir Evidencia*
                                    </Label>
                                    <InputFileUpload3
                                        icon="upload"
                                        name="MEN"
                                        onChange={handleFileUpload}
                                        placeholder={""}
                                    />
                                </FormGroup>
                            </Col>
                        </>
                        ) : (val.tipoPermiso == 12 && val.estadoPermiso == "E") ? (
                                <>
                                    <Col md={{ size: 2, offset: 1 }}>
                                        <FormGroup>
                                            <Label for="Fecha">
                                                Fecha Solicitud
                                            </Label>
                                            <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaSolicitud.toString())}></Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md={{ size: 2, offset: 1 }}>
                                        <FormGroup>
                                            <Label for="Fecha">
                                                Fecha Evento*:
                                            </Label>
                                            {puedeEditarPaternidad ? (
                                                <DatePickerEditarFechaEvento fechaEventoOriginal={fechaEventoEditar} tipoAlumbramiento={tipoAlumbramiento} fechaSolicitud={fechaSolicitudDate} />
                                            ) : (
                                                <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaEvento.toString())}></Input>
                                            )}
                                        </FormGroup>
                                    </Col>
                                    <Col md={5} className="pr-0" style={{ paddingRight: 0 }}>
                                        <FormGroup>
                                            <Label for="nuevoTipoAlumbramiento" className="label-permiso">Tipo de Alumbramiento*</Label>
                                            <Input
                                                type="select"
                                                value={tipoAlumbramiento}
                                                onChange={handleNuevoTipoAlumbramientoChange}
                                                id="nuevoTipoAlumbramiento"
                                            >
                                                <option value="">{tipoAlumbramiento}</option>
                                                {(tipoAlumbramiento == "NACIMIENTO DE 1 HIJO POR PARTO NATURAL") ? (
                                                    <>
                                                    <option value="NACIMIENTO MÚLTIPLE O CESÁREA">NACIMIENTO MÚLTIPLE O CESÁREA</option>
                                                    <option value="NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL">NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL</option>
                                                    <option value="NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA">NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA</option>
                                                    <option value="NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO">NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO</option>
                                                        <option value="ADOPCIÓN">ADOPCIÓN</option>
                                                    </>
                                                ) : (tipoAlumbramiento == "NACIMIENTO MÚLTIPLE O CESÁREA") ? (
                                                    <>
                                                    <option value="NACIMIENTO DE 1 HIJO POR PARTO NATURAL">NACIMIENTO DE 1 HIJO POR PARTO NATURAL</option>
                                                    <option value="NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL">NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL</option>
                                                    <option value="NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA">NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA</option>
                                                    <option value="NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO">NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO</option>
                                                            <option value="ADOPCIÓN">ADOPCIÓN</option>
                                                    </>
                                                ) : (tipoAlumbramiento == "NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL") ? (
                                                    <>
                                                    <option value="NACIMIENTO MÚLTIPLE O CESÁREA">NACIMIENTO MÚLTIPLE O CESÁREA</option>
                                                    <option value="NACIMIENTO DE 1 HIJO POR PARTO NATURAL">NACIMIENTO DE 1 HIJO POR PARTO NATURAL</option>
                                                    <option value="NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA">NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA</option>
                                                    <option value="NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO">NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO</option>
                                                                <option value="ADOPCIÓN">ADOPCIÓN</option>
                                                    </>
                                                ) : (tipoAlumbramiento == "NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA") ? (
                                                    <>
                                                    <option value="NACIMIENTO MÚLTIPLE O CESÁREA">NACIMIENTO MÚLTIPLE O CESÁREA</option>
                                                    <option value="NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL">NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL</option>
                                                    <option value="NACIMIENTO DE 1 HIJO POR PARTO NATURAL">NACIMIENTO DE 1 HIJO POR PARTO NATURAL</option>
                                                    <option value="NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO">NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO</option>
                                                                    <option value="ADOPCIÓN">ADOPCIÓN</option>
                                                    </>
                                                ) : (tipoAlumbramiento == "NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO") ? (
                                                    <>
                                                    <option value="NACIMIENTO MÚLTIPLE O CESÁREA">NACIMIENTO MÚLTIPLE O CESÁREA</option>
                                                    <option value="NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL">NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL</option>
                                                    <option value="NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA">NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA</option>
                                                    <option value="NACIMIENTO DE 1 HIJO POR PARTO NATURAL">NACIMIENTO DE 1 HIJO POR PARTO NATURAL</option>
                                                                        <option value="ADOPCIÓN">ADOPCIÓN</option>
                                                    </>
                                                ) : (
                                                    <>
                                                    <option value="NACIMIENTO DE 1 HIJO POR PARTO NATURAL">NACIMIENTO DE 1 HIJO POR PARTO NATURAL</option>
                                                    <option value="NACIMIENTO MÚLTIPLE O CESÁREA">NACIMIENTO MÚLTIPLE O CESÁREA</option>
                                                    <option value="NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL">NACIMIENTO PREMATURO O EN CONDICIONES DE CUIDADO ESPECIAL</option>
                                                    <option value="NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA">NACIMIENTO CON ENFERMEDAD DEGENERATIVA, TERMINAL O IRREVERSIBLE, O CON UN GRADO DE DISCAPACIDAD SEVERA</option>
                                                                            <option value="NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO">NACIMIENTO MÚLTIPLE O CESÁREA Y PREMATURO</option>
                                                    </>
                                                )}
                                            </Input>
                                        </FormGroup>
                                    </Col>                                    
                                    <Col md={{ size: 2, offset: 1 }}>
                                        <FormGroup>
                                            <Label for="Fecha">
                                                Fecha Desde:
                                            </Label>
                                            {fechaInicioEditar ? (
                                                <Input type="text" readOnly className="input-readonly-custom" value={formatDateToString(fechaInicioEditar)} />
                                            ) : (
                                                    <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaInicio.toString())}></Input>)}
                                        </FormGroup>
                                    </Col>
                                    <Col md={{ size: 2, offset: 1 }}>
                                        <FormGroup>
                                            <Label for="Fecha">
                                                Fecha Hasta:
                                            </Label>
                                            {fechaInicioEditar ? (
                                                <Input type="text" readOnly className="input-readonly-custom" value={formatDateToString(SumarDiasFecha(fechaInicioEditar, diasSolicitadosEditar - 1))} />
                                            ) : (
                                                    <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaFin.toString())}></Input>)}
                                        </FormGroup>
                                    </Col>
                                    <Col md={2} className="pr-0">
                                        <FormGroup>
                                            <Label for="diasSolicitados" className="label-permiso">
                                                Días Solicitados
                                            </Label>
                                            {fechaEventoEditar ? (
                                                <Input type="text" readOnly value={diasSolicitadosEditar} id="horas_solicitadas" style={{ minHeight: "30px" }} />
                                            ) : (
                                                <Input
                                                    type="text"
                                                    value={val.diasSolicitadas}
                                                    readOnly
                                                    id="horas_solicitadas"
                                                    style={{ minHeight: "30px" }}
                                                ></Input>
                                            )}
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}></Col>
                                    <Col md={{ size: 5, offset: 1 }} style={{ paddingRight: 0 }}>
                                        <FormGroup>
                                            <Label for="archivo">
                                                Subir Evidencia*
                                            </Label>
                                            <InputFileUpload3
                                                icon="upload"
                                                name="MEN"
                                                onChange={handleFileUpload}
                                                placeholder={""}
                                            />
                                        </FormGroup>
                                    </Col>
                                </>
                    ): (val.tipoPermiso == 25 && val.estadoPermiso == "F") ? (
                        <>
                            <Col md={{size: 3, offset: 1}}>
                                <FormGroup>
                                    <Label for="tipo">
                                        Tipo Evento:
                                    </Label>
                                {tipoEvento == "C" ? (
                                    <Input type="text" readOnly className="input-readonly-custom" value={"MATRIMONIO"}></Input>
                                ) : (
                                    <Input type="text" readOnly className="input-readonly-custom" value={"UNIÓN DE HECHO"}></Input>
                                )}
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="modalidad">
                                        Modalidad Licencia:
                                    </Label>
                                    {modalidadEvento == "A" ? (
                                                    <Input type="text" readOnly className="input-readonly-custom" value={"ANTES"}></Input>
                                    ) : (
                                                        <Input type="text" readOnly className="input-readonly-custom" value={"DESPUÉS"}></Input>
                                    )}
                                </FormGroup>
                            </Col>                            
                                        <Col md={5} style={{ paddingRight: 0 }}></Col>
                                        <Col md={{ size: 2, offset: 1 }}>
                                            <FormGroup>
                                                <Label for="Fecha">
                                                    Fecha Solicitud
                                                </Label>
                                                <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaSolicitud.toString())}></Input>
                                            </FormGroup>
                                        </Col>
                            <Col md={{ size: 2, offset: 1 }}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha Evento:
                                    </Label>
                                    <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaEvento.toString())}></Input>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha Desde:
                                    </Label>
                                                <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaInicio.toString())}></Input>
                                </FormGroup>
                            </Col>
                                        <Col md={{ size: 2, offset: 1 }}>
                                <FormGroup>
                                    <Label for="fechaHasta" className="label-permiso">
                                        Fecha Hasta:
                                    </Label>
                                                <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaFin.toString())}></Input>
                                </FormGroup>
                            </Col>
                        </>
                    ) : (val.tipoPermiso == 25 && val.estadoPermiso == "E") && (
                        <>
                        <Col md={{size: 3, offset: 1}}>
                            <FormGroup>
                                <Label for="tipo">
                                    Tipo Evento:
                                </Label>
                                {tipoEvento == "C" ? (
                                    <Input type="text" readOnly className="input-readonly-custom" value={"MATRIMONIO"}></Input>
                                ) : (
                                    <Input type="text" readOnly className="input-readonly-custom" value={"UNIÓN DE HECHO"}></Input>
                                )}
                            </FormGroup>
                        </Col>
                            <Col md={{size: 2, offset: 1}}>
                                <FormGroup>
                                    <Label for="modalidad">
                                        Modalidad Licencia:
                                    </Label>
                                    {modalidadEvento == "A" ? (
                                                        <Input type="text" readOnly className="input-readonly-custom" value={"ANTES"}></Input>
                                    ) : (
                                                            <Input type="text" readOnly className="input-readonly-custom" value={"DESPUÉS"}></Input>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={5} style={{ paddingRight: 0 }}></Col>
                            <Col md={{ size: 2, offset: 1 }}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha Solicitud
                                    </Label>
                                    <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaSolicitud.toString())}></Input>
                                </FormGroup>
                            </Col>
                            <Col md={{ size: 2, offset: 2 }}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha Evento:
                                    </Label>
                                    <DatePickerEditarFechaEvento fechaEventoOriginal={fechaEventoEditar} tipoAlumbramiento={"matrimonio"} fechaSolicitud={fechaSolicitudDate} />
                                </FormGroup>
                                        </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Fecha Desde:
                                    </Label>
                                    <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaInicio.toString())}></Input>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="fechaHasta" className="label-permiso">
                                        Fecha Hasta:
                                    </Label>
                                    <Input type="text" readOnly className="input-readonly-custom" value={formatoFecha(fechaFin.toString())}></Input>
                                </FormGroup>
                            </Col>
                            <Col md={{size: 2, offset: 1}}>
                                <FormGroup>
                                    <Label for="Fecha">
                                        Días Solicitados:
                                    </Label>
                                    <Input type="text" readOnly id="estadoSolicitudReplanificacion" value={val.diasSolicitadas}></Input>
                                </FormGroup>
                            </Col>
                            <Col md={1}></Col>
                        </>
                    )}
                    {(val.tipoPermiso == 5 && val.estadoPermiso == "F") ? (
                        <>
                            {puedeEditarDocumento ? (
                                <Col md={{ size: 5, offset: 1 }} style={{ paddingRight: 0 }}>
                                    <FormGroup>
                                        <Label for="archivo">
                                            Subir Programación de Cita*
                                        </Label>
                                        <InputFileUpload3
                                            icon="upload"
                                            name="MEN"
                                            onChange={handleFileUploadProgCita}
                                            placeholder={""}
                                        />
                                    </FormGroup>
                                </Col>
                            ) : (
                                    <Col md={{size: 5, offset: 1}} style={{ paddingRight: 0 }}>
                                    <FormGroup>
                                        <Label for="archivo">
                                            Subir Evidencia Asistencia Cita*
                                        </Label>
                                        <InputFileUpload3
                                            icon="upload"
                                            name="MEN"
                                            onChange={handleFileUpload}
                                            placeholder={""}
                                        />
                                    </FormGroup>
                                </Col>
                            )}
                        </>
                    ) : (val.tipoPermiso == 25 && (val.estadoPermiso == "F") && (fechaEventoDate > fechaActual)) ? (
                            <Col md={{size: 6, offset: 1}} style={{ paddingRight: 0 }}>
                            <FormGroup>
                                <Label for="archivo">
                                    Subir Evidencia
                                </Label>
                                <Input type="text" readOnly></Input>
                            </FormGroup>
                        </Col>
                    ) : (val.tipoPermiso == 25 && (val.estadoPermiso == "F" || val.estadoPermiso == "E")) ? (
                                <Col md={{size: 6, offset: 1}} style={{ paddingRight: 0 }}>
                            <FormGroup>
                                <Label for="archivo">
                                    Subir Evidencia*
                                </Label>
                                <InputFileUpload3
                                    icon="upload"
                                    name="MEN"
                                    onChange={handleFileUpload}
                                    placeholder={""}
                                />
                            </FormGroup>
                        </Col>
                    ) : (val.tipoPermiso != 3 && val.tipoPermiso != 12) ? (
                        <Col md={{size: 5, offset: 1}} style={{ paddingRight: 0 }}>
                            <FormGroup>
                                <Label for="archivo">
                                    Subir Evidencia*
                                </Label>
                                <InputFileUpload3
                                    icon="upload"
                                    name="MEN"
                                    onChange={handleFileUpload}
                                    placeholder={""}
                                />
                            </FormGroup>
                        </Col>
                    ) : (<></>)}
                </Row>
            )
            return fila;
        })

        //console.log(fechaEventoEditar)
        //console.log(fechaInicioEditar)
        //console.log(fechaFinEditar)
        //console.log(diasSolicitadosEditar)

        return htmlRowsSolicitudes;
    }

    useEffect(() => {
        if (stateModalEditar.solicitud) {
            const updatedModal = { ...stateModalEditar };
            const content: any = GetHTMLSolicitudPermisosRechazadas([stateModalEditar.solicitud])
            updatedModal.content = content;
            setstateModalEditar(updatedModal)
        } 
    }, [fechaEventoEditar, fechaInicioEditar, fechaFinEditar, diasSolicitadosEditar, tipoAlumbramiento, motivoRechazo]);

    function GetHTMLSolicitudConfirmacionCH(solicitud: SolicitudPost | undefined, idRegimenLaboral: number): any {
        if (solicitud && solicitud.nuevoHorario) {
            if (solicitud.nuevoHorario.HoraEntradaTarde && solicitud.nuevoHorario.HoraSalidaTarde && solicitud.nuevoHorario.FechaDesde && solicitud.nuevoHorario.FechaHasta && idRegimenLaboral != 8) {
                const contenidoJSX = (
                    <div>
                        {`Su permiso para el cuidado del recién nacido, es de ${solicitud.nuevoHorario.HoraEntrada} a ${solicitud.nuevoHorario.HoraSalida} y de ${solicitud.nuevoHorario.HoraEntradaTarde} a ${solicitud.nuevoHorario.HoraSalidaTarde};`}
                        <br />
                        {`su horario laboral será de ${solicitud.nuevoHorario.horaEntradaLaboral} a ${solicitud.nuevoHorario.horaSalidaLaboral},`}
                        <br />
                        {nuevoHorario != undefined ? `a partir de ${(solicitud.nuevoHorario.FechaDesde)} hasta el ${(solicitud.nuevoHorario.FechaHasta)}` : `a partir de ${formatDateToString(solicitud.nuevoHorario.FechaDesde.toString())} hasta el ${formatDateToString(solicitud.nuevoHorario.FechaHasta.toString())}`}
                    </div>
                );
                return ReactDOMServer.renderToString(contenidoJSX);
            } else if (solicitud.nuevoHorario.HoraEntrada && solicitud.nuevoHorario.HoraSalida && solicitud.nuevoHorario.FechaDesde && solicitud.nuevoHorario.FechaHasta && idRegimenLaboral != 8) {
                const contenidoJSX = (
                    <div>
                        {`Su permiso para el cuidado del recién nacido, es de ${solicitud.nuevoHorario.HoraEntrada} a ${solicitud.nuevoHorario.HoraSalida};`}
                        <br />
                        {`su horario laboral será de ${solicitud.nuevoHorario.horaEntradaLaboral} a ${solicitud.nuevoHorario.horaSalidaLaboral},`}
                        <br />
                        {nuevoHorario != undefined ? `a partir de ${(solicitud.nuevoHorario.FechaDesde)} hasta el ${(solicitud.nuevoHorario.FechaHasta)}` : `A partir de ${formatDateToString(solicitud.nuevoHorario.FechaDesde.toString())} hasta el ${formatDateToString(solicitud.nuevoHorario.FechaHasta.toString())}`}
                    </div>
                );
                return ReactDOMServer.renderToString(contenidoJSX);
            } else if (solicitud.nuevoHorario.HoraEntradaTarde && solicitud.nuevoHorario.HoraSalidaTarde && solicitud.nuevoHorario.FechaDesde && solicitud.nuevoHorario.FechaHasta && idRegimenLaboral == 8) {
                const contenidoJSX = (
                    <div>
                        {`Su permiso para el cuidado del recién nacido, es de ${solicitud.nuevoHorario.HoraEntrada} a ${solicitud.nuevoHorario.HoraSalida} y de ${solicitud.nuevoHorario.HoraEntradaTarde} a ${solicitud.nuevoHorario.HoraSalidaTarde},`}
                        <br />
                        {nuevoHorario != undefined ? `a partir de ${(solicitud.nuevoHorario.FechaDesde)} hasta el ${(solicitud.nuevoHorario.FechaHasta)}` : `A partir de ${formatDateToString(solicitud.nuevoHorario.FechaDesde.toString())} hasta el ${formatDateToString(solicitud.nuevoHorario.FechaHasta.toString())}`}
                    </div>
                );
                return ReactDOMServer.renderToString(contenidoJSX);
            } else if (solicitud.nuevoHorario.HoraEntrada && solicitud.nuevoHorario.HoraSalida && solicitud.nuevoHorario.FechaDesde && solicitud.nuevoHorario.FechaHasta && idRegimenLaboral == 8) {
                const contenidoJSX = (
                    <div>
                        {`Su permiso para el cuidado del recién nacido, es de ${solicitud.nuevoHorario.HoraEntrada} a ${solicitud.nuevoHorario.HoraSalida},`}
                        <br />
                        {nuevoHorario != undefined ? `a partir de ${(solicitud.nuevoHorario.FechaDesde)} hasta el ${(solicitud.nuevoHorario.FechaHasta)}` : `A partir de ${formatDateToString(solicitud.nuevoHorario.FechaDesde.toString())} hasta el ${formatDateToString(solicitud.nuevoHorario.FechaHasta.toString())}`}
                    </div>
                );
                return ReactDOMServer.renderToString(contenidoJSX);
            }
        }

        return <div></div>;
    }

        const handleClickSolicitar = useCallback(
            async () => {
                var titulo = "";
                var respuestaSolicitud: ResponseRequest = { status: -1 };
                let solicitudNueva: SolicitudPermisosPost = {
                    FechaInicio: "",
                    FechaFin: "",
                    TipoPermiso: null,
                    Observacion: "",
                    HoraInicio: "",
                    HoraFin: "",
                    PermisoHoraIncluyeAlmuerzo: false,
                    idDependiente: null
                };
                const { fechaDesde, fechaHasta } = stateCard
                setstateCard({ ...stateCard, loadingCreacion: true })

                const condicionPermisoPorHoras = habilitarIngresoHoras && fraccionHoraDia !== undefined && fraccionHoraDia < 1;
                if (fechaDesde && fechaHasta && typeof (fechaDesde) !== "string" && typeof (fechaHasta) !== "string" && !condicionPermisoPorHoras) {

                    if (overlaps_dates(fechaDesde, fechaHasta, fechasEscogidas)) {
                        setmensajeError("Debe escoger un rango de fechas que no interfiera con sus solicitudes de permisos o sus fechas de licencia")
                        showAlertWarning("Debe escoger un rango de fechas que no interfiera con sus solicitudes de permisos o sus fechas de licencia", WarningSVG, true);
                        setstateCard({ ...stateCard, loadingCreacion: false })
                    } else {
                        setmensajeError("")
                    }
                }

                if (fechaPermisoHora !== undefined && fechaPermisoHora !== null) {
                    const fechaDesdeConHoras = AgregarHoraAFecha(fechaPermisoHora, horaDesde)
                    const fechaHastaConHoras = AgregarHoraAFecha(fechaPermisoHora, horaHasta)

                    solicitudNueva = {
                        FechaInicio: fechaDesdeConHoras,
                        FechaFin: fechaHastaConHoras,
                        TipoPermiso: tipoPermisoSeleccionado,
                        Observacion: observacionPermiso,
                        HoraInicio: horaDesde,
                        HoraFin: horaHasta,
                        PermisoHoraIncluyeAlmuerzo: incluyeHoraAlmuerzo || descontandoTiempoAlmuerzo,
                        idDependiente: hijoSeleccionado
                    }

                    respuestaSolicitud = await SolicitarPermisosFormulario(solicitudNueva, props.acuerdoMediosElectronicos);
                }

                if (respuestaSolicitud.status === 200) {


                    var content: any = undefined;

                    if (!props.acuerdoMediosElectronicos) {
                        content = (
                            <AlertNew
                                mensaje={MENSAJE_ADVERTENCIA_USO_MEDIOS_ELECTRONICOS}
                                oncloseElement={() => ""}
                                closeButton={false}

                            />
                        )
                    }

                    if (solicitudNueva.TipoPermiso == 5) {
                        titulo = "Solicitud de Permiso para Atención Médica"
                    } else if (solicitudNueva.TipoPermiso == 29) {
                        titulo = "Solicitud de Permiso para Matriculación de hijos o relaciones"
                    }

                    setstateCard({ ...stateCard, loadingCreacion: false })


                    setstateModalFormulario({ url: respuestaSolicitud.dataResponse, loadingFormulario: false, tituloModal: titulo, content, solicitudNueva })

                }
                else {
                    //alertService.error(respuestaSolicitud.errorMessage ?? "");
                    await showAlert(respuestaSolicitud.errorMessage ?? "", ErrorSVG, true);
                    setstateCard({ ...stateCard, loadingCreacion: false })

                }
                ScrollToTop();
            }, [stateCard, horaDesde, horaHasta, fechaPermisoHora, observacionPermiso, fechasEscogidas, props.acuerdoMediosElectronicos, tipoPermisoSeleccionado, hijoSeleccionado, certMedico, incluyeHoraAlmuerzo, descontandoTiempoAlmuerzo]
        )

        const handleClickSolicitarLCD = useCallback(
            async () => {
                var titulo = "";
                var respuestaSolicitud: ResponseRequest = { status: -1 };
                /*var respuestaSolicitudMatrimonio: ResponseRequest = { status: -1 };*/
                let solicitudNueva: SolicitudLicenciasPost = {
                    FechaEvento: "",
                    FechaInicio: "",
                    FechaFin: "",
                    TipoPermiso: null,
                    Observacion: "",
                    HoraInicio: "",
                    HoraFin: "",
                    Subtipo: undefined,
                    idProvincia: null,
                    identificacionConyuge: "",
                    tipoEventoMatrimonio: "",
                    modalidadLicenciaMatrimonio: "",
                    tipoIdentificacion: "",
                    Conyuge: ""
                };                
                const { fechaDesde, fechaHasta, fechaEvento } = stateCard
                setstateCard({ ...stateCard, loadingCreacion: true })



                if (fechaDesde !== undefined && fechaHasta !== undefined) {
                    var subtipo = 0;
                    if (tipoLicenciaSeleccionado == 17) {
                        subtipo = tipoCalamidadSeleccionado;
                    } else if (tipoLicenciaSeleccionado == 3) {
                        subtipo = tipoNacMaternidadSeleccionado;
                    } else if (tipoLicenciaSeleccionado == 12) {
                        subtipo = tipoNacPaternidadSeleccionado;
                    } else if (tipoLicenciaSeleccionado == 11) {
                        subtipo = tipoCertificadoSeleccionado;
                    } else if (tipoLicenciaSeleccionado == 16) {
                        subtipo = tipoCertificadoEGSeleccionado;
                    }
                    if (tipoLicenciaSeleccionado == 25) {
                        if (tipoMatrimonio == "A") {
                            if (tipoEventoMatrimonio == "C") {
                                if (tipoIdentificacion == "CED") {
                                    solicitudNueva = {
                                        FechaEvento: fechaEvento,
                                        FechaInicio: fechaDesde,
                                        FechaFin: fechaHasta,
                                        TipoPermiso: tipoLicenciaSeleccionado,
                                        Observacion: observacionPermiso,
                                        HoraInicio: "",
                                        HoraFin: "",
                                        Subtipo: undefined,
                                        idProvincia: null,
                                        identificacionConyuge: cedulaConyugue,
                                        tipoEventoMatrimonio: tipoEventoMatrimonio,
                                        modalidadLicenciaMatrimonio: tipoMatrimonio,
                                        tipoIdentificacion: tipoIdentificacion,
                                        Conyuge: nombreCompletoConyuge
                                    }
                                } else {
                                    solicitudNueva = {
                                        FechaEvento: fechaEvento,
                                        FechaInicio: fechaDesde,
                                        FechaFin: fechaHasta,
                                        TipoPermiso: tipoLicenciaSeleccionado,
                                        Observacion: observacionPermiso,
                                        HoraInicio: "",
                                        HoraFin: "",
                                        Subtipo: undefined,
                                        idProvincia: null,
                                        identificacionConyuge: cedulaConyugue,
                                        tipoEventoMatrimonio: tipoEventoMatrimonio,
                                        modalidadLicenciaMatrimonio: tipoMatrimonio,
                                        tipoIdentificacion: tipoIdentificacion,
                                        Conyuge: nombreCompletoConyuge
                                    }
                                }                                
                            } else {
                                if (tipoIdentificacion == "CED") {
                                    solicitudNueva = {
                                        FechaEvento: fechaEvento,
                                        FechaInicio: fechaDesde,
                                        FechaFin: fechaHasta,
                                        TipoPermiso: tipoLicenciaSeleccionado,
                                        Observacion: observacionPermiso,
                                        HoraInicio: "",
                                        HoraFin: "",
                                        Subtipo: undefined,
                                        idProvincia: null,
                                        identificacionConyuge: cedulaConyugue,
                                        tipoEventoMatrimonio: tipoEventoMatrimonio,
                                        modalidadLicenciaMatrimonio: tipoMatrimonio,
                                        tipoIdentificacion: tipoIdentificacion,
                                        Conyuge: nombreCompletoConyuge
                                    }
                                } else {
                                    solicitudNueva = {
                                        FechaEvento: fechaEvento,
                                        FechaInicio: fechaDesde,
                                        FechaFin: fechaHasta,
                                        TipoPermiso: tipoLicenciaSeleccionado,
                                        Observacion: observacionPermiso,
                                        HoraInicio: "",
                                        HoraFin: "",
                                        Subtipo: undefined,
                                        idProvincia: null,
                                        identificacionConyuge: cedulaConyugue,
                                        tipoEventoMatrimonio: tipoEventoMatrimonio,
                                        modalidadLicenciaMatrimonio: tipoMatrimonio,
                                        tipoIdentificacion: tipoIdentificacion,
                                        Conyuge: nombreCompletoConyuge
                                    }
                                }                                
                            }
                        } else {
                            if (tipoEventoMatrimonio == "C") {
                                if (tipoIdentificacion == "CED") {
                                    solicitudNueva = {
                                        FechaEvento: fechaEvento,
                                        FechaInicio: fechaDesde,
                                        FechaFin: fechaHasta,
                                        TipoPermiso: tipoLicenciaSeleccionado,
                                        Observacion: observacionPermiso,
                                        HoraInicio: "",
                                        HoraFin: "",
                                        Subtipo: undefined,
                                        idProvincia: null,
                                        identificacionConyuge: cedulaConyugue,
                                        tipoEventoMatrimonio: tipoEventoMatrimonio,
                                        modalidadLicenciaMatrimonio: tipoMatrimonio,
                                        tipoIdentificacion: tipoIdentificacion,
                                        Conyuge: nombreCompletoConyuge
                                    }
                                } else {
                                    solicitudNueva = {
                                        FechaEvento: fechaEvento,
                                        FechaInicio: fechaDesde,
                                        FechaFin: fechaHasta,
                                        TipoPermiso: tipoLicenciaSeleccionado,
                                        Observacion: observacionPermiso,
                                        HoraInicio: "",
                                        HoraFin: "",
                                        Subtipo: undefined,
                                        idProvincia: null,
                                        identificacionConyuge: cedulaConyugue,
                                        tipoEventoMatrimonio: tipoEventoMatrimonio,
                                        modalidadLicenciaMatrimonio: tipoMatrimonio,
                                        tipoIdentificacion: tipoIdentificacion,
                                        Conyuge: nombreCompletoConyuge
                                    }
                                }
                            } else {
                                if (tipoIdentificacion == "CED") {
                                    solicitudNueva = {
                                        FechaEvento: fechaEvento,
                                        FechaInicio: fechaDesde,
                                        FechaFin: fechaHasta,
                                        TipoPermiso: tipoLicenciaSeleccionado,
                                        Observacion: observacionPermiso,
                                        HoraInicio: "",
                                        HoraFin: "",
                                        Subtipo: undefined,
                                        idProvincia: null,
                                        identificacionConyuge: cedulaConyugue,
                                        tipoEventoMatrimonio: tipoEventoMatrimonio,
                                        modalidadLicenciaMatrimonio: tipoMatrimonio,
                                        tipoIdentificacion: tipoIdentificacion,
                                        Conyuge: nombreCompletoConyuge
                                    }
                                } else {
                                    solicitudNueva = {
                                        FechaEvento: fechaEvento,
                                        FechaInicio: fechaDesde,
                                        FechaFin: fechaHasta,
                                        TipoPermiso: tipoLicenciaSeleccionado,
                                        Observacion: observacionPermiso,
                                        HoraInicio: "",
                                        HoraFin: "",
                                        Subtipo: undefined,
                                        idProvincia: null,
                                        identificacionConyuge: cedulaConyugue,
                                        tipoEventoMatrimonio: tipoEventoMatrimonio,
                                        modalidadLicenciaMatrimonio: tipoMatrimonio,
                                        tipoIdentificacion: tipoIdentificacion,
                                        Conyuge: nombreCompletoConyuge
                                    }
                                }
                            }
                        }  
                    } else if (tipoLicenciaSeleccionado === 36 || tipoLicenciaSeleccionado === 37) {
                        solicitudNueva = {
                            FechaEvento: fechaEvento,
                            FechaInicio: fechaDesde,
                            FechaFin: fechaHasta,
                            TipoPermiso: tipoLicenciaSeleccionado,
                            Observacion: observacionPermiso,
                            HoraInicio: horaDesde,
                            HoraFin: horaHasta,
                            Subtipo: subtipo,
                            idProvincia: provinciaSeleccionado,
                            PermisoHoraIncluyeAlmuerzo: incluyeHoraAlmuerzo || descontandoTiempoAlmuerzo,
                            identificacionConyuge: "",
                            tipoEventoMatrimonio: "",
                            modalidadLicenciaMatrimonio: "",
                            tipoIdentificacion: tipoIdentificacion,
                            Conyuge: nombreCompletoConyuge
                        }
                    } else {
                        solicitudNueva = {
                            FechaEvento: PruebaSolucion2(fechaEvento ?? new Date()),
                            FechaInicio: PruebaSolucion2(fechaDesde ?? new Date()),
                            FechaFin: PruebaSolucion2(fechaHasta ?? new Date()),
                            TipoPermiso: tipoLicenciaSeleccionado,
                            Observacion: observacionPermiso,
                            HoraInicio: HORA_INICIO_PERMITIDA,
                            HoraFin: HORA_FIN_PERMITIDA,
                            Subtipo: subtipo,
                            idProvincia: provinciaSeleccionado,
                            identificacionConyuge: "",
                            tipoEventoMatrimonio: "",
                            modalidadLicenciaMatrimonio: "",
                            tipoIdentificacion: tipoIdentificacion,
                            Conyuge: nombreCompletoConyuge
                        }
                    }

                    respuestaSolicitud = await SolicitarLicenciasFormulario(solicitudNueva, props.acuerdoMediosElectronicos);
                    /*respuestaSolicitudMatrimonio = await SolicitarLicenciasMatrimonio(solicitudMatrimonio, props.acuerdoMediosElectronicos);*/
                }

                if (respuestaSolicitud.status === 200) {


                    var content: any = undefined;

                    if (!props.acuerdoMediosElectronicos) {
                        content = (
                            <AlertNew
                                mensaje={MENSAJE_ADVERTENCIA_USO_MEDIOS_ELECTRONICOS}
                                oncloseElement={() => ""}
                                closeButton={false}

                            />
                        )
                    }

                    if (solicitudNueva.TipoPermiso == 17) {
                        titulo = "Solicitud de Licencia por Calamidad Doméstica"
                    } else if (solicitudNueva.TipoPermiso == 3) {
                        titulo = "Solicitud de Licencia por Maternidad"
                    } else if (solicitudNueva.TipoPermiso == 12) {
                        titulo = "Solicitud de Licencia por Paternidad"
                    } else if (solicitudNueva.TipoPermiso == 11) {
                        titulo = "Solicitud de Licencia por Enfermedad Física o Psicológica"
                    } else if (solicitudNueva.TipoPermiso == 16) {
                        titulo = "Solicitud de Licencia por Enfermedad Castrófica - Grave"
                    } else if (solicitudNueva.TipoPermiso == 36) {
                        titulo = "Solicitud de Licencia para Rehabilitación por Enfermedad Física o Psicológica"
                    } else if (solicitudNueva.TipoPermiso == 37) {
                        titulo = "Solicitud de Licencia para Rehabilitación por Enfermedad Castrófica o Accidente Grave"
                    } else if (solicitudNueva.TipoPermiso == 25) {
                        titulo = "Solicitud de Licencia por Matrimonio/Unión de Hecho"
                        /*setstateModalFormulario({ url: respuestaSolicitudMatrimonio.dataResponse, loadingFormulario: false, tituloModal: titulo, content, solicitudNueva })*/
                    }

                    setstateCard({ ...stateCard, loadingCreacion: false })
                    setstateModalFormulario({ url: respuestaSolicitud.dataResponse, loadingFormulario: false, tituloModal: titulo, content, solicitudNueva })

                }
                else {
                    //alertService.error(respuestaSolicitud.errorMessage ?? "");
                    await showAlert(respuestaSolicitud.errorMessage ?? "", ErrorSVG, true);
                    setstateCard({ ...stateCard, loadingCreacion: false })
                }
                ScrollToTop();
            }, [stateCard, horaDesde, horaHasta, fechaPermisoHora, observacionPermiso, fechasEscogidas, props.acuerdoMediosElectronicos, tipoPermisoSeleccionado, tipoLicenciaSeleccionado, certMedico, incluyeHoraAlmuerzo, descontandoTiempoAlmuerzo, provinciaSeleccionado, tipoCertificadoSeleccionado, tipoNacPaternidadSeleccionado, tipoNacMaternidadSeleccionado, tipoCalamidadSeleccionado, informacionConyugue, tipoEventoMatrimonio]
        )

    const handleClickSolicitarCH = useCallback(async () => {
        // Validación de solicitud existente
        //if (props.solicitudesIngresadasCH.length > 0) {
        //    seterrorHoras("Usted ya tiene una solicitud de cambio de horario de permiso para cuidado del recién nacido. Si desea ingresar una solicitud nueva debe de anular la solicitud existente.");
        //    return;
        //}

        setNuevoHorario(undefined)

        let titulo = "";
        let respuestaSolicitud: ResponseRequest = { status: -1 };

        // Estructura base de la solicitud
        let solicitudNueva: SolicitudPost = {
            tieneHorarioPermiso: props.tieneHorarioPermiso,
            nuevoHorario: undefined,
            //infantes: []
        };

        // Preparación del horario según el caso
        let horarioNuevo: NuevoHorario = {
            FechaDesde: "",
            FechaHasta: "",
            HoraEntrada: "",
            HoraSalida: "",
            HoraEntradaTarde: "",
            HoraSalidaTarde: "",
            Observacion: observacionPermiso,
            horaEntradaLaboral: "",  // Nueva propiedad
            horaSalidaLaboral: "",    // Nueva propiedad            
        };

        if (props.idRegimenLaboralS == 8) {
            horarioNuevo = {
                FechaDesde: props.permisosCRN[0].fechaDesde,
                FechaHasta: props.permisosCRN[0].fechaHasta,
                HoraEntrada: props.permisosCRN[0].horaDesde,
                HoraSalida: props.permisosCRN[0].horaHasta,
                // Incluir horario tarde si existe en el horario actual
                ...(props.permisosCRN[0].horaDesdeTarde && props.permisosCRN[0].horaHastaTarde && {
                    HoraEntradaTarde: props.permisosCRN[0].horaDesdeTarde,
                    HoraSalidaTarde: props.permisosCRN[0].horaHastaTarde
                }),
                Observacion: observacionPermiso,
                horaEntradaLaboral: props.horarioLaboralPersona[0].horaentrada,
                horaSalidaLaboral: props.horarioLaboralPersona[0].horasalida,
            };
        } else {
            horarioNuevo = {
                FechaDesde: props.permisosCRN[0].fechaDesde,
                FechaHasta: props.permisosCRN[0].fechaHasta,
                HoraEntrada: props.permisosCRN[0].horaDesde,
                HoraSalida: props.permisosCRN[0].horaHasta,
                // Incluir horario tarde si existe en el horario actual
                ...(props.permisosCRN[0].horaDesdeTarde && props.permisosCRN[0].horaHastaTarde && {
                    HoraEntradaTarde: props.permisosCRN[0].horaDesdeTarde,
                    HoraSalidaTarde: props.permisosCRN[0].horaHastaTarde
                }),
                Observacion: observacionPermiso,
                horaEntradaLaboral: props.empHorario[0].horaEntrada,
                horaSalidaLaboral: props.empHorario[0].horaSalida,
            };
        }        

        // Construcción final de la solicitud
        solicitudNueva = {
            ...solicitudNueva,
            nuevoHorario: horarioNuevo,
            //infantes: infantesRegistrado
        };

        //console.log(solicitudNueva);

        // Envío al backend
        respuestaSolicitud = await SolicitarFormulario(solicitudNueva, props.acuerdoMediosElectronicos);

        if (respuestaSolicitud.status === 200) {
            let content: any = undefined;

            if (!props.acuerdoMediosElectronicos) {
                content = (
                    <AlertNew
                        mensaje={MENSAJE_ADVERTENCIA_USO_MEDIOS_ELECTRONICOS}
                        oncloseElement={() => ""}
                        closeButton={false}
                    />
                );
            }

            titulo = "Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido";

            setstateModalFormularioCH({
                url: respuestaSolicitud.dataResponse,
                loadingFormulario: false,
                tituloModal: titulo,
                content,
                solicitudNueva
            });
        } else {
            await showAlert(respuestaSolicitud.errorMessage ?? "", ErrorSVG, true);
        }

        ScrollToTop();
    }, [horaDesdeCH, horaHastaCH, fechaDesdeNueva, observacionPermiso, props.acuerdoMediosElectronicos]);

        const handleClickAnular = (solicitud: SolicitudPermisos) => {
            const content: any = GetHTMLSolicitudVacacionesIngresadas([solicitud])
            setstateModal({
                showModal: true,
                solicitud,
                content
            });
        }


        const handleClickConfirmar = (solicitud: SolicitudPermisosPost | SolicitudLicenciasPost | undefined) => {
            const content: any = GetHTMLSolicitudConfirmacion(solicitud, certMedico)
            let tituloModal: string | null = "";
            if (solicitud !== undefined) {
                var strTitulo: string | null = ""
                if (solicitud.TipoPermiso == 5 || solicitud.TipoPermiso == 38 || solicitud.TipoPermiso == 29) {
                    strTitulo = tiposPermisos.filter(p => p.idtipopermiso == solicitud.TipoPermiso).map(pr => pr.descripcion)[0];
                    tituloModal = strTitulo

                } else if (solicitud.TipoPermiso == 25) {
                    tituloModal = "licencia por matirmonio /\n unión de hecho"
                } else {
                    strTitulo = tiposLicencias.filter(p => p.idtipopermiso == solicitud.TipoPermiso).map(pr => pr.descripcion)[0];
                    tituloModal = strTitulo
                }
            }
            setstateModalConfirmacion({
                showModal: true,
                solicitud,
                content,
                tituloModal
            });
        }

        const handleClickConfirmarCH = (solicitud: SolicitudPost | undefined, idRegimenLaboral: number) => {
            const content: any = GetHTMLSolicitudConfirmacionCH(solicitud, idRegimenLaboral)
            let tituloModal: string | null = "";
            if (solicitud !== undefined) {
                tituloModal = "Solicitud de cambio de horario para permiso de cuidado del recién nacido"
            }
            setstateModalConfirmacionCH({
                showModal: true,
                solicitud,
                content,
                tituloModal
            });
        }

    const handleClickEditar = (solicitud: SolicitudPermisos) => {
        const content: any = GetHTMLSolicitudPermisosRechazadas([solicitud])
        if (solicitud.tipoPermiso == 3 || solicitud.tipoPermiso == 12) {
            setTipoAlumbramiento(solicitud.strSubTipoPermiso)
            setfechaEventoEditar(solicitud.fechaEvento ? new Date(solicitud.fechaEvento) : null)
            setDiasSolicitadosEditar(solicitud.diasSolicitadas)
        } else if (solicitud.tipoPermiso == 25) {
            setfechaEventoEditar(solicitud.fechaEvento ? new Date(solicitud.fechaEvento) : null)
            if (solicitud.tipoEventoMatrimonio) {
                setTipoAlumbramiento(solicitud.tipoEventoMatrimonio)
            }
            setDiasSolicitadosEditar(solicitud.diasSolicitadas)
        } else if (solicitud.tipoPermiso == 29) {
            setfechaEventoEditar(solicitud.fechaDesde ? new Date(solicitud.fechaDesde) : null)
        }
            setstateModalEditar({
                showModal: true,
                solicitud,
                content
            });
        }

        const onClickVerDoc = useCallback(
            async (referencia: string) => {
                setstateModalVP({ ...stateModalVP, loading: true })
                const datosUsuario: UserData = authenticationService.currentUserValue;
                const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
                setstateModalVP({ ...stateModalVP, loading: false, url })
            }, [stateModalVP])

        function GetHtmlSolicitudPermisosIngresada(solicitudes: SolicitudPermisos[], solicitudesCH: SolicitudCambioHorarioIngresada[], solicitudesL: SolicitudLicencias[], solicitudesV: SolicitudPermisos[]) {
            if (solicitudes.length > 0 || solicitudesCH.length > 0 || solicitudesL.length > 0 || solicitudesV.length > 0) {
                return (
                    <>
                        <p className="margen-superior titulo-solicitudes"><strong> Solicitudes En Curso / Por Ejecutarse</strong></p>
                        <TableSolicitudesPermisosIngresados
                            dataprops={solicitudes}
                            datapropsCH={solicitudesCH}
                            datapropsL={solicitudesL}
                            datapropsV={solicitudesV}
                            onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                            onClickAnularSolicitud={(solicitud: SolicitudPermisos) => handleClickAnular(solicitud)}
                            onClickEditarSolicitud={(solicitud: SolicitudPermisos) => handleClickEditar(solicitud)}
                            onClickAnularSolicitudCH={(solicitud: SolicitudCambioHorarioIngresada) => handleClickAnularCH(solicitud)}
                        />
                    </>


                );
            }

        }

        function GetHtmlSolicitudLicenciasIngresada(solicitudes: SolicitudLicencias[]) {
            if (solicitudes.length > 0) {
                return (
                    <>
                        <p className="margen-superior titulo-solicitudes"><strong> Solicitudes Ingresadas</strong></p>
                        <TableSolicitudesLicenciasIngresadas
                            dataprops={solicitudes}
                            onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                            onClickAnularSolicitud={(solicitud: SolicitudPermisos) => handleClickAnular(solicitud)}
                        />
                    </>
                );
            }

        }

    function GetHTMLSolicitudCambioHorarioIngresadas(solicitudes: Array<SolicitudCambioHorarioIngresada>): any {
        return solicitudes.map((val, ind) => {
            var fechaDesde = val.fechaDesde ?? new Date();
            var fechaHasta = val.fechaHasta ?? new Date();

            let horarioCompleto = `${val.horaInicio} - ${val.horaFin}`;
            if (val.horaInicioTarde && val.horaFinTarde) {
                horarioCompleto += `\n${val.horaInicioTarde} - ${val.horaFinTarde}`;
            }

            return (
                <Row key={"SolicitudesCambioHorario" + ind} className="mt-2" style={{
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center'
                }}>
                    <Col md={3}>
                        <FormGroup>
                            <Label> Tipo Solicitud: </Label>
                            <Input type="text" readOnly className="bold" value={"Cambio de horario"} />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label> Fecha Desde: </Label>
                            <Input type="text" readOnly className="bold" value={formatoFecha(fechaDesde.toString())} />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label> Fecha Hasta: </Label>
                            <Input type="text" readOnly className="bold" value={formatoFecha(fechaHasta.toString())} />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label> Horario: </Label>
                            <Input
                                type="textarea"
                                readOnly
                                className="bold"
                                value={horarioCompleto}
                                style={{ whiteSpace: 'pre-line', textAlign: 'center' }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label> Estado: </Label>
                            <Input type="text" readOnly value={val.strEstadoPermiso} />
                        </FormGroup>
                    </Col>
                </Row>
            );
        });
    }

        async function OnCloseModalConfirmacionAnulacion() {
            await props.onInsertSolicitud()
            ScrollToTop();

        }
        async function OnCloseModalConfirmacionEdicion() {
            await props.onInsertSolicitud()
            ScrollToTop();

        }

        async function AnularSolicitud(idPermiso: number) {
            const statusAnulacion = await AnularSolicitudPermisos(idPermiso);
            if (statusAnulacion === 1) {
                await showAlert("La solicitud ha sido anulada con éxito", ExitoSVG, true);
            }
            else {

                await showAlert("Ha ocurrido un inconveniente al intentar anular la solicitud", ErrorSVG, false);
            }
            return statusAnulacion;
        }


        const handleClickAnularCH = (solicitud: SolicitudCambioHorarioIngresada) => {
            const content: any = GetHTMLSolicitudCambioHorarioIngresadas([solicitud])
            setstateModalCH({
                showModal: true,
                solicitud,
                content
            });
        }

        async function AnularSolicitudCH(idSolicitud: number) {
            const statusAnulacion = await AnularSolicitudCambioHorario(idSolicitud);
            if (statusAnulacion === 1) {
                await showAlert("La solicitud ha sido anulada con éxito", ExitoSVG, true);
                await props.onInsertSolicitud()
            }
            else {
                await showAlert("Ha ocurrido un inconveniente al intentar anular la solicitud", ErrorSVG, true);
            }
            return statusAnulacion;
        }

    const ModalEliminarSolicitudesCambioHorario = useMemo(() => {
        // Obtener el contenido de la tabla usando la función existente
        const tableContent = stateModalCH.solicitud
            ? GetHTMLSolicitudCambioHorarioIngresadas([stateModalCH.solicitud])
            : null;

        // Crear contenido centrado
        const centeredContent = (
            <div style={{ textAlign: 'center' }}>
                <div className="mb-3">¿Desea anular la solicitud?</div>
                {tableContent && (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        margin: '0 auto',
                        width: '100%'
                    }}>
                        <div style={{
                            width: 'fit-content',
                            textAlign: 'center'
                        }}>
                            {tableContent}
                        </div>
                    </div>
                )}
            </div>
        );

        return (
            <ModalConfirmacion
                show={stateModalCH.showModal && (stateModalCH.solicitud?.idSolicitud ?? -1) > -1}
                size="xl"
                mensajeConfirmacion={''} // Lo quitamos porque lo incluimos en el contentModal
                classNamemensajeConfirmacion='mensajeConfirmacionAnulacionSolicitud'
                tituloModal='Anulación de Solicitud'
                nombreBotonAccion='Aceptar'
                nombreBotonCerrarModal='Cancelar'
                onClose={() => setstateModalCH(defaultStateModalCH)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                asyncOnClick={async () => AnularSolicitudCH(stateModalCH.solicitud?.idSolicitud ?? -1)}
                contentModal={centeredContent}
                classNameAllModal={"text-center"}
            />
        );
    }, [stateModalCH]);

    async function EditarSolicitud(idPermiso: number, certMedicoFile: any[], horaHastaNuevo: String, horaDesde: String, horaDesdeNuevo: String, certProgCita: any[], fechaPermisoEditar: Date | null | undefined, fechaEventoEditar: string | Date | null, tipoAlumbramiento: string, motivoRechazo: string, tipoPermiso: number) {

        const formData = new FormData()        
        formData.append('idPermiso', idPermiso.toString())
        if (horaHastaNuevo !== "") {
            if (horaHastaNuevo > props.horaSalida) {
                Swal.fire({
                    text: "La hora hasta no puede ser mayor que la hora de salida.",
                    imageUrl: `${WarningSVG}`, // Utiliza el formato PNG
                    imageHeight: 100, // Ajusta el tamaño según sea necesario
                    imageAlt: "Anuncio",
                    confirmButtonText: "Entendido",
                    confirmButtonColor: "#243165",

                });
                return -1;
            } else if (horaHastaNuevo < horaDesde) {
                Swal.fire({
                    text: "La hora hasta no puede ser menor que la hora desde.",
                    imageUrl: `${WarningSVG}`, // Utiliza el formato PNG
                    imageHeight: 100, // Ajusta el tamaño según sea necesario
                    imageAlt: "Warning",
                    confirmButtonText: "Entendido",
                    confirmButtonColor: "#243165",

                });
                return -1;
            } else {
                formData.append('HoraHasta', horaHastaNuevo.toString())
            }

        }
        if (horaDesdeNuevo !== "") {
            if (horaDesdeNuevo < props.horaEntrada) {
                Swal.fire({
                    text: "La hora desde no puede ser menor que la hora de entrada.",
                    imageUrl: `${WarningSVG}`, // Utiliza el formato PNG
                    imageHeight: 100, // Ajusta el tamaño según sea necesario
                    imageAlt: "Anuncio",
                    confirmButtonText: "Entendido",
                    confirmButtonColor: "#243165",

                });
                return -1;
            } else if (horaHastaNuevo !== "" && horaHastaNuevo < horaDesdeNuevo) {
                Swal.fire({
                    text: "La hora hasta no puede ser menor que la hora desde.",
                    imageUrl: `${WarningSVG}`, // Utiliza el formato PNG
                    imageHeight: 100, // Ajusta el tamaño según sea necesario
                    imageAlt: "Warning",
                    confirmButtonText: "Entendido",
                    confirmButtonColor: "#243165",

                });
                return -1;
            } else {
                formData.append('HoraDesde', horaDesdeNuevo.toString())
            }
        }
        if (fechaPermisoEditar !== null && fechaPermisoEditar !== undefined) {
            formData.append('FechaInicio', PruebaSolucion2(fechaPermisoEditar))
        }

        if ((fechaEventoEditar == null || fechaEventoEditar == undefined) && tipoPermiso == 11) {
            Swal.fire({
                text: "Ingrese la fecha de fin",
                imageUrl: `${WarningSVG}`, // Utiliza el formato PNG
                imageHeight: 100, // Ajusta el tamaño según sea necesario
                imageAlt: "Warning",
                confirmButtonText: "Entendido",
                confirmButtonColor: "#243165",

            });
            return -1;
        }

        if (fechaEventoEditar !== null && fechaEventoEditar !== undefined) {
            if (tipoPermiso == 11 || tipoPermiso == 17) {
                formData.append('FechaFin', PruebaSolucion2(fechaEventoEditar))
            } else {
                formData.append('FechaEvento', PruebaSolucion2(fechaEventoEditar))
            }
            
        }
        if (tipoAlumbramiento !== "") {
            formData.append('TipoAlumbramiento', tipoAlumbramiento)
        }
        
    if (certMedicoFile.length > 0 || certProgCita.length > 0) {
        if (certMedicoFile.length > 0) {
            certMedicoFile.map((fileData) => {
                formData.append('CertMedico', fileData.file, fileData.file.name);
            });
        } else if (certProgCita.length > 0) {
            certProgCita.map((fileData) => {
                formData.append('CertProgCita', fileData.file, fileData.file.name);
            });
        }
    } else if (tipoPermiso != 3) {
        Swal.fire({
            text: "Debe de subir la evidencia",
            imageUrl: `${WarningSVG}`, // Utiliza el formato PNG
            imageHeight: 100, // Ajusta el tamaño según sea necesario
            imageAlt: "Warning",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",

        });
        return -1;
    }
        const statusEdicion = await SolicitarPermisosAtencionMedicaEdicion(formData);
        if (statusEdicion.status === 200) {
            await showAlert("La solicitud ha sido actualizada con éxito", ExitoSVG, true);
        }
        else if (statusEdicion.errorMessage !== "") {
            await showAlert(statusEdicion.errorMessage, ErrorSVG, false);
        } else {
            await showAlert("Ha ocurrido un inconveniente al intentar editar la solicitud", ErrorSVG, false);
        }
        return 1;
    }

        const ModalEliminarSolicitudesPermisos = useMemo(() => {
            return (
                <ModalConfirmacion
                    show={stateModal.showModal && (stateModal.solicitud?.idPermiso ?? -1) > -1}
                    size="lg"
                    mensajeConfirmacion={'¿Desea anular la solicitud?'}
                    classNamemensajeConfirmacion='mensajeConfirmacionAnulacionSolicitud'
                    tituloModal='Anulación de Solicitud'
                    nombreBotonAccion='Aceptar'
                    nombreBotonCerrarModal='Cancelar'
                    onClose={() => setstateModal(defaultStateModal)}
                    asyncAccion={true}
                    asyncClose={true}
                    closeAfterAccion={true}
                    hideBotonCerrar={false}
                    asyncOnClick={async () => AnularSolicitud(stateModal.solicitud?.idPermiso ?? -1)}
                    asyncAfterOnClose={() => OnCloseModalConfirmacionAnulacion()}
                    contentModal={stateModal.content}
                    classNameAllModal={""}

                />
            )

        }, [stateModal])

        const ModalEditarSolicitudesPermisos = useMemo(() => {
            return (
                <ModalConfirmacion
                    show={stateModalEditar.showModal && (stateModalEditar.solicitud?.idPermiso ?? -1) > -1}
                    size="xl"
                    mensajeConfirmacion={''}
                    classNamemensajeConfirmacion='mensajeConfirmacionAnulacionSolicitud'
                    tituloModal='Edición de Solicitud'
                    nombreBotonAccion='Aceptar'
                    nombreBotonCerrarModal='Cancelar'
                    onClose={() => setstateModalEditar(defaultStateModal)}
                    asyncAccion={true}
                    asyncClose={true}
                    closeAfterAccion={true}
                    hideBotonCerrar={false}
                    asyncOnClick={async () => EditarSolicitud(stateModalEditar.solicitud?.idPermiso ?? -1, certMedico, horaHastaNuevo, stateModalEditar.solicitud?.horaDesde ?? "", horaDesdeNuevo, certProgCita, fechaPermisoHoraEditar, fechaEventoEditar, tipoAlumbramiento, motivoRechazo, stateModalEditar.solicitud?.tipoPermiso ?? -1)}
                    asyncAfterOnClose={() => OnCloseModalConfirmacionEdicion()}
                    contentModal={stateModalEditar.content}
                    classNameAllModal={"modal-xl-custom"}

                />
            )

        }, [stateModalEditar, certMedico, horaHastaNuevo, horaDesdeNuevo, certProgCita, fechaPermisoHoraEditar, fechaEventoEditar, fechaInicioEditar, fechaFinEditar, diasSolicitadosEditar, tipoAlumbramiento, motivoRechazo])

        const SolicitudesPermisos = useMemo(() => {
            if (props.permisosIngresados.length !== 0 || props.solicitudesIngresadasCH.length !== 0 || props.licenciasIngresadas.length !== 0 || props.vacacionesIngresadas.length !== 0) {
                const htmlSolicitudPermisos = GetHtmlSolicitudPermisosIngresada(props.permisosIngresados, props.solicitudesIngresadasCH, props.licenciasIngresadas, props.vacacionesIngresadas);
                const solicitudes = (
                    <div>
                        {htmlSolicitudPermisos}
                    </div>
                )
                return solicitudes;
            }

        }, [props.permisosIngresados, props.solicitudesIngresadasCH, props.vacacionesIngresadas, props.licenciasIngresadas])



        const limpiarFechasCardYModal = useCallback(
            () => {
                setfechaPermisoHora(null)
                setHoraDesde("")
                setHoraHasta("")
                setHorasSolicitdas("")
                setCertMedico([])
                setCertProgCita([])
                setHoraDesdeCH("")
                setHoraHastaCH("")
                setfechaDesdeNueva(null)
                setstateCard(defaultState)
                setmensajeMarcacionAlmuerzo("")
                setdescontadoTiempoAlmuerzo(false)
                setstateModalFormulario(defaultStateModalFormulario)
                setstateModalConfirmacion(defaultStateModalConfirmacion)
                setstateModalFormularioCH(defaultStateModalFormularioCH)
                setstateModalConfirmacionCH(defaultStateModalConfirmacionCH)
                setProvinciaSeleccionado(0)
                setObservacionPermiso("")
                setCedulaConyugue("")
                setInformacionConyugue(defaultStateInformacionConyugue)
                setNombreCompletoConyuge("")
                document.body.classList.remove('modal-open')
            },
            [stateModalFormulario, stateCard, stateModalConfirmacion, provinciaSeleccionado, tipoCalamidadSeleccionado],
        )


        const OnClickAccionModalFormulario = useCallback(async (): Promise<number> => {

            const { fechaDesde, fechaHasta } = stateCard;
            var respuesta: ResponseRequest = { status: -1 };
            if ((fechaDesde !== null && fechaHasta !== null) || fechaPermisoHora !== null) {

                const solicitudNueva = AuxiliarCrearSolicitudPermisosPost();

                if (solicitudNueva === undefined) {
                    await showAlert("No ha sido posible ingresar la solicitud", ErrorSVG, false);
                }
                else {
                    respuesta = await SolicitarPermisosLicenciasCreacion(solicitudNueva);

                }
                if (respuesta.status === 200) {
                    const tipoPermiso = solicitudNueva.get('TipoPermiso');
                    const certMedico = solicitudNueva.get('CertMedico');
                    const certProgCita = solicitudNueva.get('CertProgCita');
                    if (tipoPermiso !== null && typeof tipoPermiso === 'string' && parseInt(tipoPermiso) === 5 && !certMedico && certProgCita) {
                        await showAlert("La programación de su cita ha sido notificada a su Directivo.. Para completar la solicitud deberá registrar el certificado de asistencia a la cita médica", ExitoSVG, false);
                        Swal.fire({
                            html: "La programación de su cita ha sido notificada a su Directivo. <br/><span style='color: #F00C0C;'>Recuerde que para completar la solicitud de su permiso, deberá registrar el certificado de asistencia a la cita médica.</span>  ",
                            imageUrl: `${ExitoSVG}`,
                            imageHeight: 100,
                            imageAlt: "Anuncio",
                            confirmButtonText: "Entendido",
                            confirmButtonColor: "#243165",
                        });
                    } else if (tipoPermiso !== null && typeof tipoPermiso === 'string' && parseInt(tipoPermiso) === 25 && !certMedico) {                        
                        await showAlert("<p>La solicitud ha sido guardada con éxito.</p>" +
                            "<p><b>Para justificar la solicitud, deberá registrar el documento que respalde el evento, con máximo 3 días después de su reintegro al puesto.</b></p>", ExitoSVG, false);
                    } else {
                        await showAlert("La solicitud ha sido guardada con éxito", ExitoSVG, false);
                    }
                    limpiarFechasCardYModal()
                    await props.onInsertSolicitud();
                    ScrollToTop();
                    return 200;
                }
                else {
                    if (respuesta.errorMessage) {
                        await showAlert(respuesta.errorMessage, ErrorSVG, false);
                    }
                    limpiarFechasCardYModal()
                    await props.onInsertSolicitud();
                    ScrollToTop();
                    return respuesta.status;
                }

            } else {
                // Si no se cumple la condición, devolver un código de error
                return -1;
            }

        }
            , [stateCard, fechaPermisoHora, limpiarFechasCardYModal, AuxiliarCrearSolicitudPermisosPost])

        const AuxiliarCrearSolicitudPost = useCallback(
            () => {
                let solicitudNueva: SolicitudPost = {
                    tieneHorarioPermiso: props.tieneHorarioPermiso,
                    nuevoHorario: undefined,
                    //infantes: []
                };

                let horarioNuevo: NuevoHorario = {
                    FechaDesde: "",
                    FechaHasta: "",
                    HoraSalida: "",
                    HoraEntrada: "",
                    HoraEntradaTarde: "",
                    HoraSalidaTarde: "",
                    Observacion: "",
                    horaEntradaLaboral: "",
                    horaSalidaLaboral: ""
                };

                //if (props.solicitudesIngresadasCH.length > 0) {
                //    seterrorHoras("Usted ya tiene una solicitud de cambio de horario de permiso para cuidado del recién nacido. Si desea ingresar una solicitud nueva debe de anular la solicitud existente.")
                //    return
                //}

                if (nuevoHorario != undefined) {
                    horarioNuevo = {
                        FechaDesde: nuevoHorario.fechaDesde,
                        FechaHasta: nuevoHorario.fechaHasta,
                        HoraSalida: nuevoHorario.horaSalida,
                        HoraEntrada: nuevoHorario.horaEntrada,
                        HoraEntradaTarde: nuevoHorario.horaEntradaTarde,
                        HoraSalidaTarde: nuevoHorario.horaSalidaTarde,
                        Observacion: nuevoHorario.observacion,
                        horaEntradaLaboral: nuevoHorario.horaEntradaLaboral,  // Nueva propiedad
                        horaSalidaLaboral: nuevoHorario.horaSalidaLaboral    // Nueva propiedad
                    }
                    //respuestaSolicitud = await SolicitarFormulario(solicitudNueva, props.acuerdoMediosElectronicos);
                } else if (props.idRegimenLaboralS != 8) {
                    horarioNuevo = {
                        FechaDesde: empHorario[0].fechaVigDesde,
                        FechaHasta: empHorario[0].fechaVigHasta,
                        HoraSalida: props.permisosCRN[0].horaHasta,
                        HoraEntrada: props.permisosCRN[0].horaDesde,
                        HoraEntradaTarde: props.permisosCRN[0].horaDesdeTarde,
                        HoraSalidaTarde: props.permisosCRN[0].horaHastaTarde,
                        Observacion: observacionPermiso,
                        horaEntradaLaboral: empHorario[0].horaEntrada,  // Nueva propiedad
                        horaSalidaLaboral: empHorario[0].horaSalida    // Nueva propiedad
                    }
                    //respuestaSolicitud = await ConfirmarFormulario(solicitudNueva, props.acuerdoMediosElectronicos);
                } else {
                    horarioNuevo = {
                        FechaDesde: formatDateToString(props.permisosCRN[0].fechaDesde),
                        FechaHasta: formatDateToString(props.permisosCRN[0].fechaHasta),
                        HoraSalida: props.permisosCRN[0].horaHasta,
                        HoraEntrada: props.permisosCRN[0].horaDesde,
                        HoraEntradaTarde: props.permisosCRN[0].horaDesdeTarde,
                        HoraSalidaTarde: props.permisosCRN[0].horaHastaTarde,
                        Observacion: observacionPermiso,
                        horaEntradaLaboral: props.horarioLaboralPersona[0].horaentrada,  // Nueva propiedad
                        horaSalidaLaboral: props.horarioLaboralPersona[0].horasalida    // Nueva propiedad
                    }
                }

                solicitudNueva = {
                    tieneHorarioPermiso: props.tieneHorarioPermiso,
                    nuevoHorario: horarioNuevo,
                    //infantes: infantesRegistrado
                }

                return solicitudNueva

            },
            [nuevoHorario, empHorario, infantesRegistrado, props.permisosCRN, props.idRegimenLaboralS],
        )

        const OnClickAccionModalFormularioCH = useCallback(async (): Promise<number> => {

            var respuesta: ResponseRequest = { status: -1 };
            var solicitudNueva = AuxiliarCrearSolicitudPost();


            if (solicitudNueva && solicitudNueva.nuevoHorario != undefined) {
                if (solicitudNueva === undefined) {
                    await showAlert("No ha sido posible ingresar la solicitud", ErrorSVG, false);
                }
                else {
                    respuesta = await SolicitarCambioHorarioCreacion(solicitudNueva);
                    await props.onInsertSolicitud();
                }

                if (respuesta.status === 200) {
                    await showAlert("La solicitud ha sido guardada con éxito", ExitoSVG, false);
                    limpiarFechasCardYModal()
                    await props.onInsertSolicitud();


                    ScrollToTop();
                    return 200;
                }
                else {
                    //alertService.error(respuesta.errorMessage ?? "No ha sido posible ingresar la solicitud de cambio de horario del permiso de cuidado del recién nacido.Intente más tarde")
                    await showAlert(respuesta.errorMessage ?? "No ha sido posible ingresar la solicitud de cambio de horario del permiso de cuidado del recién nacido.Intente más tarde", ErrorSVG, true);
                    limpiarFechasCardYModal()

                    ScrollToTop();
                    return respuesta.status;
                }
            }
            return 1;

        }, [limpiarFechasCardYModal, AuxiliarCrearSolicitudPost, nuevoHorario, infantesRegistrado])


        const validarCamposPAMProgramada = () => {
            return fechaPermisoHora != undefined && horaDesde != "" && horaHasta != "" && certProgCita.length > 0
        }
        const validarCamposPAMAsistencia = () => {
            return fechaPermisoHora != undefined && horaDesde != "" && horaHasta != "" && certMedico.length > 0
        }

        const validarCamposPMH = () => {
            return hijoSeleccionado != 0 && fechaPermisoHora != undefined && horaDesde != "" && horaHasta != "" && certMedico.length > 0
        }

        const validarCamposLPM = () => {
            return tipoNacMaternidadSeleccionado != 0 && stateCard.fechaEvento != undefined && certMedico.length > 0
        }

        const validarCamposLPP = () => {
            return tipoNacPaternidadSeleccionado != 0 && stateCard.fechaEvento != undefined && certMedico.length > 0
        }

        const validarCamposLPCD = () => {
            return tipoCalamidadSeleccionado != 0 && stateCard.fechaEvento != undefined && stateCard.fechaHasta != undefined
        }

        const validarCamposLPEFP = () => {
            return tipoCertificadoSeleccionado != 0 && stateCard.fechaEvento != undefined && stateCard.fechaHasta != undefined && certMedico.length > 0
        }

        const validarCamposLPEG = () => {
            return tipoCertificadoEGSeleccionado != 0 && stateCard.fechaEvento != undefined && stateCard.fechaHasta != undefined && certMedico.length > 0
        }

        const validarCamposLMT = () => {
            return stateCard.fechaEvento != undefined && stateCard.fechaHasta != undefined
        }

        const validarCamposLR = () => {
            return stateCard.fechaEvento != undefined && stateCard.fechaHasta != undefined && stateCard.fechaDesde != undefined && certMedico.length > 0 && fechaPermisoHora != undefined && horaDesde != "" && horaHasta != "" && errorHoras === ""
        }

        const validarCamposCH = () => {
            return horaDesdeCH != "" && horaHastaCH != "" && fechaDesdeNueva != null
        }

    const validarCamposLPMtAntes = () => {
        return stateCard.fechaEvento != undefined && stateCard.fechaHasta != undefined && mensajeAdvertencia === "" && cedulaConyugue != "" && tipoEventoMatrimonio != "" && nombreCompletoConyuge != ""
    }
    const validarCamposLPMtAntesMenor = () => {
        return stateCard.fechaEvento != undefined && stateCard.fechaHasta != undefined && mensajeAdvertencia === "" && cedulaConyugue != "" && tipoEventoMatrimonio != "" && certMedico.length > 0 && nombreCompletoConyuge != ""
    }
    const validarCamposLPMtDespues = () => {
        return stateCard.fechaEvento != undefined && stateCard.fechaHasta != undefined && mensajeAdvertencia === "" && cedulaConyugue != "" && tipoEventoMatrimonio != "" && nombreCompletoConyuge != ""
    }
    const validarCamposLPMtDespuesMenor = () => {
        return stateCard.fechaEvento != undefined && stateCard.fechaHasta != undefined && mensajeAdvertencia === "" && cedulaConyugue != "" && tipoEventoMatrimonio != "" && certMedico.length > 0 && nombreCompletoConyuge != ""
    }

        const toggleModal = () => setModalOpenCH(!modalOpenCH);
        const toggleModalRegistrarInfante = () => setModalOpenRI(!modalOpenRI);

        const handleHoraEntradaChange = (e) => setHoraDesdeCH(e.target.value);
        const handleHoraSalidaChange = (e) => setHoraHastaCH(e.target.value);

        useEffect(() => {
            setTipoPermisoSeleccionado(0)
            setTipoLicenciaSeleccionado(0)
            setmensajeError("")
            seterrorHoras("")
            seterrorDias("")
            setmensajeInformacionHijo("")
            setmensajePermisoMedico("")
            setfechaPermisoHora(null)
            setHoraDesde("")
            setHoraHasta("")
            setHorasSolicitdas("")
            setCertMedico([])
            setHoraDesdeCH("")
            setHoraHastaCH("")
            setfechaDesdeNueva(null)
            setMensajeAdvertencia("")
            setstateCard({ ...stateCard })
        }, [tabActiva])



        /*if (mensajeTiempoPermiso !== "") {
            Swal.fire({
                text: mensajeTiempoPermiso,
                imageUrl: `${AnuncioSVG}`, 
                imageHeight: 100, // Ajusta el tamaño según sea necesario
                imageAlt: "Anuncio",
                confirmButtonText: "Entendido",
                confirmButtonColor: "#243165",
                didClose: () => {
                    // Elimina el mensajeTiempoPermiso aquí
                    setmensajeTiempoPermiso("");
                }
            });
        }*/

        useEffect(() => {
            if (tipoLicenciaSeleccionado === 3 && mensajeErrorCRN !== "") {
                Swal.fire({
                    text: mensajeErrorCRN,
                    imageUrl: `${WarningSVG}`, // Utiliza el formato PNG
                    imageHeight: 100, // Ajusta el tamaño según sea necesario
                    imageAlt: "Anuncio",
                    confirmButtonText: "Entendido",
                    confirmButtonColor: "#243165",
                });
            }
        }, [tipoLicenciaSeleccionado, mensajeErrorCRN]);



        function verificarInclusionAlmuerzo() {
            Swal.fire({
                text: "¿El permiso solicitado incluye su tiempo de receso?",
                imageUrl: `${AnuncioSVG}`,
                imageHeight: 100,
                imageAlt: "Anuncio",
                showCancelButton: true,
                confirmButtonText: "NO",
                confirmButtonColor: "#243165",
                cancelButtonText: "SI",
                cancelButtonColor: "#243165",
                reverseButtons: true,
                customClass: {
                    cancelButton: 'custom-cancel-button'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    mostrarMensajeRecuerdo();
                } else if (result.isDismissed) {
                    setincluyeHoraAlmuerzo(true);
                    setmensajeMarcacionAlmuerzo("");
                }
            });
        }

        function mostrarMensajeRecuerdo() {
            setincluyeHoraAlmuerzo(false)
            Swal.fire({
                html: "Recuerde que usted <span style='color: #1CB5A4; font-weight: bold;'>SI DEBE DE MARCAR</span> <br/> su hora de inicio y fin de receso",
                imageUrl: `${RecesoSVG}`,
                imageHeight: 100,
                imageAlt: "Anuncio",
                confirmButtonText: "Entendido",
                confirmButtonColor: "#243165",
                didClose: () => {
                    setmensajeMarcacionAlmuerzo("Recuerde que usted SI DEBE DE MARCAR su hora de inicio y fin de receso")
                }
            });
        }

        const mostrarConfirmacionSwal = async (solicitud) => {
            const contenidoHTML = GetHTMLSolicitudConfirmacion(solicitud, certMedico);
            const result = await Swal.fire({
                title: `Confirmación de ${stateModalConfirmacion.tituloModal?.toLowerCase()}`,
                html: contenidoHTML,
                showCancelButton: true,
                confirmButtonText: 'SI',
                cancelButtonText: 'NO',
                confirmButtonColor: "#243165",
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger'
                },
                width: '800px',
            });

            if (result.isConfirmed) {
                await OnClickAccionModalFormulario();
            } else {
                limpiarFechasCardYModal();
            }
        };

        useEffect(() => {
            if (stateModalConfirmacion.showModal) {
                mostrarConfirmacionSwal(stateModalConfirmacion.solicitud);
            }
        }, [stateModalConfirmacion.showModal])

        const mostrarConfirmacionCHSwal = async (solicitud, idRegimenLaboral: number) => {
            const contenidoHTML = GetHTMLSolicitudConfirmacionCH(solicitud, idRegimenLaboral);
            const result = await Swal.fire({
                title: `Confirmación de ${stateModalConfirmacionCH.tituloModal?.toLowerCase()}`,
                html: contenidoHTML,
                showCancelButton: true,
                confirmButtonText: 'SI',
                cancelButtonText: 'NO',
                confirmButtonColor: "#243165",
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger'
                },
                width: '800px',
                didClose: () => {
                    limpiarFechasCardYModal();
                }
            });

            if (result.isConfirmed) {
                await OnClickAccionModalFormularioCH();
            }
        };

        useEffect(() => {
            if (stateModalConfirmacionCH.showModal) {
                mostrarConfirmacionCHSwal(stateModalConfirmacionCH.solicitud, props.idRegimenLaboralS);
            }
        }, [stateModalConfirmacionCH.showModal])


        const DatePickerFechaDesde = useCallback((permiso: boolean) => {
            const feriadosFechas = props.feriados.map((val, ind) => {
                return new Date(val)
            })

            const fechaDesdeAnteriorDate = fechaDesdeAnterior ? new Date(fechaDesdeAnterior) : "";
            const fechaHastaAnteriorDate = fechaHastaAnterior ? new Date(fechaHastaAnterior) : null;

            var excludeDates = [...feriadosFechas];
            const fechaMinima = SumarDiasFecha(fechaDesdeAnteriorDate, 1);
            const fechaMaxima = fechaHastaAnteriorDate


            const handleChangeFechaDesde = (e: Date) => {
                setfechaDesdeNueva(e)
            };

            return (
                <Datepicker2
                    value={fechaDesdeNueva}
                    disabled={!permiso}
                    name="fechadesde"
                    id="fechadesde"
                    onChange={handleChangeFechaDesde}
                    min={fechaMinima}
                    max={fechaMaxima}
                    showDisabledMonthNavigation={true}
                    excludeDates={excludeDates}
                    filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, props.feriados)}
                    dayClassName={(date: Date) => isFeriado(date, props.feriados)}
                />
            )
        }, [props.feriados, fechaDesdeNueva]);

        //const handleSave = (data) => {
        //    setNuevoHorario(data);// Lógica para manejar el guardado de datos
    //};

    const handleSave = useCallback(async (data) => {
        try {
            setNuevoHorario(data);

            // Validación de solicitud existente
            //if (props.solicitudesIngresadasCH.length > 0) {
                //seterrorHoras("Usted ya tiene una solicitud de cambio de horario de permiso para cuidado del recién nacido. Si desea ingresar una solicitud nueva debe de anular la solicitud existente.");
                //return;
            //}

            let titulo = "";
            let respuestaSolicitud: ResponseRequest = { status: -1 };

            // Preparación del horario según el caso
            let horarioNuevo: NuevoHorario;

            if (data) {
                // Caso con nuevo horario definido (desde el modal)
                horarioNuevo = {
                    FechaDesde: data.fechaDesde,
                    FechaHasta: data.fechaHasta,
                    HoraEntrada: data.horaEntrada,
                    HoraSalida: data.horaSalida,
                    ...(data.horaEntradaTarde && data.horaSalidaTarde && {
                        HoraEntradaTarde: data.horaEntradaTarde,
                        HoraSalidaTarde: data.horaSalidaTarde
                    }),
                    Observacion: data.observacion,
                    horaEntradaLaboral: data.horaEntradaLaboral,
                    horaSalidaLaboral: data.horaSalidaLaboral,
                };
            } else {
                // Validar que exista horario actual
                if (!props.permisosCRN?.length || !props.empHorario?.length) {
                    throw new Error("No se encontró información del horario actual");
                }

                // Caso con horario actual del empleado
                horarioNuevo = {
                    FechaDesde: props.permisosCRN[0].fechaDesde,
                    FechaHasta: props.permisosCRN[0].fechaHasta,
                    HoraEntrada: props.permisosCRN[0].horaDesde,
                    HoraSalida: props.permisosCRN[0].horaHasta,
                    ...(props.permisosCRN[0].horaDesdeTarde && props.permisosCRN[0].horaHastaTarde && {
                        HoraEntradaTarde: props.permisosCRN[0].horaDesdeTarde,
                        HoraSalidaTarde: props.permisosCRN[0].horaHastaTarde
                    }),
                    Observacion: observacionPermiso,
                    horaEntradaLaboral: props.empHorario[0].horaEntrada,
                    horaSalidaLaboral: props.empHorario[0].horaSalida,
                };
            }

            // Construcción final de la solicitud
            const solicitudNueva: SolicitudPost = {
                tieneHorarioPermiso: props.tieneHorarioPermiso,
                nuevoHorario: horarioNuevo,
                //infantes: infantesRegistrado
            };

            //console.log(solicitudNueva);

            // Envío al backend
            respuestaSolicitud = await SolicitarFormulario(solicitudNueva, props.acuerdoMediosElectronicos);

            if (respuestaSolicitud.status === 200) {
                let content: React.ReactNode = undefined;

                if (!props.acuerdoMediosElectronicos) {
                    content = (
                        <AlertNew
                            mensaje={MENSAJE_ADVERTENCIA_USO_MEDIOS_ELECTRONICOS}
                            oncloseElement={() => ""}
                            closeButton={false}
                        />
                    );
                }

                titulo = "Solicitud de Cambio de Horario de Permiso para Cuidado del Recién Nacido";

                setstateModalFormularioCH({
                    url: respuestaSolicitud.dataResponse,
                    loadingFormulario: false,
                    tituloModal: titulo,
                    content,
                    solicitudNueva
                });
            } else {
                await showAlert(respuestaSolicitud.errorMessage ?? "", ErrorSVG, true);
            }

            ScrollToTop();
        } catch (error) {
            console.error("Error en handleSave:", error);
            await showAlert("Ocurrió un error al procesar la solicitud", ErrorSVG, true);
        }
    }, [horaDesdeCH, horaHastaCH, fechaDesdeNueva, observacionPermiso, props.acuerdoMediosElectronicos, nuevoHorario, infantesRegistrado])

        const handleSaveRegistrarInfante = (data) => {
            setInfantesRegistrado([...infantesRegistrado, data]);// Lógica para manejar el guardado de datos
        };

    const licenciasTipo3 = props.licenciaMaternidad
        .filter(licencia => licencia.tipoPermiso === 3 && licencia.fechaHasta !== null)  // Solo procesa si fechaHasta existe
        .map(licencia => ({
            fechaDesde: licencia.fechaDesde,
            fechaHasta: licencia.fechaHasta!,  // Usamos "!" porque ya filtramos nulls
            diasSolicitados: licencia.diasSolicitadas,
            subtipo: licencia.strSubTipoPermiso || "No especificado",
            inicioCuidado: SumarDiasFecha(licencia.fechaHasta!, 1)  // Safe porque ya está validado
        }));

    const handleModalClose = async () => {
        await props.onInsertSolicitud();
    };

    const permisosCambioRN = (props.permisosCRN || []).map((permiso, index) => ({
        horaDesde: permiso?.horaDesde ?? "08:00",
        horaHasta: permiso?.horaHasta ?? "10:00",
        fechaDesde: permiso?.fechaDesde ?? "",
        fechaHasta: permiso?.fechaHasta ?? "",
        horaDesdeTarde: permiso?.horaDesdeTarde ?? "14:00",
        horaHastaTarde: permiso?.horaHastaTarde ?? "16:00",
        archivo: permiso?.refArchivoPermiso ?? "",
    }));

    const horariosCambioRN = (props.listadoHorarios || []).map(horario => ({
        idRegimenLaboral: horario.idRegimenLaboral,
        horaInicioR1: horario.horaInicioR1,
        horaFinR1: horario.horaFinR1,
        horaInicioR2: horario.horaInicioR2 ?? "",
        horaFinR2: horario.horaFinR2 ?? "",
    }))

    const permisosCuidadoRN = (props.permisosIngresados || [])
        .filter(permiso => permiso?.tipoPermiso === 18 && permiso?.estadoPermiso === "J")
        .map((permiso, index) => ({
            estadoPermiso: permiso?.estadoPermiso ?? "",
        }));

    const solicitudesCambioHorario = (props.solicitudesIngresadasCH || [])
        .filter(solicitud => solicitud?.estadoPermiso === "A")
        .map(solicitud => ({
            fechaDesde: solicitud.fechaDesde,
            fechaHasta: solicitud.fechaHasta,
            horaInicio: solicitud.horaInicio,
            horaFin: solicitud.horaFin,
            horaInicioTarde: solicitud.horaInicioTarde ?? "",
            horaFinTarde: solicitud.horaFinTarde ?? "",
        }))

    const resolvedData = {
        fechaDesde: solicitudesCambioHorario?.[0]?.fechaDesde ?? permisosCambioRN[0]?.fechaDesde ?? "",
        fechaHasta: solicitudesCambioHorario?.[0]?.fechaHasta ?? permisosCambioRN[0]?.fechaHasta ?? "",
        horaDesde: solicitudesCambioHorario?.[0]?.horaInicio ?? permisosCambioRN[0]?.horaDesde ?? "08:00",
        horaHasta: solicitudesCambioHorario?.[0]?.horaFin ?? permisosCambioRN[0]?.horaHasta ?? "10:00",
        horaDesdeTarde: solicitudesCambioHorario?.[0]?.horaInicioTarde ?? permisosCambioRN[0]?.horaDesdeTarde ?? "",
        horaHastaTarde: solicitudesCambioHorario?.[0]?.horaFinTarde ?? permisosCambioRN[0]?.horaHastaTarde ?? ""
    };

    const getLabelPermiso = (permiso) => {
        if (permiso.idtipopermiso === 46) {
            return "PERMISO PARA CUIDADO DEL RECIEN NACIDO";
        }
        return permiso.descripcion;
    };

    //console.log("Fecha Fin Contrato: ", props.fechaFinContrato);
    //console.log("Regímenes encontrados:", props.idRegimenLaboralS);
    //console.log("Licencia Maternidad:", licenciasTipo3[0]);
    //console.log(props.permisosCRN)

    return (            
            <>
                <div style={{ marginTop: "30px" }}></div>
                <Card id="CardSolicitudes2">
                    <CardBody
                        className="cardBodyContenedorSolicitudes"
                        style={{ padding: "0px !important" }}
                    >
                        <div id="container-CBSolicitudes">
                            <Nav tabs className={"containerListadoTabs2"}>
                                <NavItem className={"listadoTabs2"}>
                                    {/*{TabNavegacion(*/}
                                    {/*    "Permisos",*/}
                                    {/*    TabSolicitudActiva.PERMISOS,*/}
                                    {/*    false*/}
                                    {/*)}*/}
                                    {TabNavegacion(
                                        "Licencias con remuneración",
                                        TabSolicitudActiva.LICENCIAS,
                                        false
                                    )}
                                </NavItem>
                            </Nav>
                            {/*<TabContent activeTab={tabActiva}>*/}
                            {/*    <TabPane tabId={TabSolicitudActiva.PERMISOS}>*/}
                            {/*        <Row className="ContentTabSolicitudes2">*/}

                            {/*            <Col sm="12" style={{ paddingLeft: 0, paddingRight: 0 }}>*/}
                            {/*                <Form autoComplete="off">*/}
                            {/*                    {mensajePermisoNot !== "" && (*/}
                            {/*                        <Row className="mb-3">*/}
                            {/*                            <Col md={10}>*/}
                            {/*                                <AlertNewAction*/}
                            {/*                                    cabeceraTitulo={"¡¡ADVERTENCIA!!"}*/}
                            {/*                                    mensaje={mensajePermisoNot}*/}
                            {/*                                    tipo={TiposAlerta.ADVERTENCIA}*/}
                            {/*                                    oncloseElement={() => { ; }}*/}
                            {/*                                />*/}
                            {/*                            </Col>*/}
                            {/*                        </Row>*/}
                            {/*                    )}*/}
                            {/*                    {mensajeLicenciaNot !== "" && (*/}
                            {/*                        <Row className="mb-3">*/}
                            {/*                            <Col md={10}>*/}
                            {/*                                <AlertNewAction*/}
                            {/*                                    mensajeHTML={mensajeLicenciaNot}*/}
                            {/*                                    tipo={TiposAlerta.ADVERTENCIA}*/}
                            {/*                                    cabeceraTitulo={"¡¡ADVERTENCIA!!"}*/}
                            {/*                                />*/}
                            {/*                            </Col>*/}
                            {/*                        </Row>*/}
                            {/*                    )}*/}
                            {/*                    {mensajePermisoDev !== "" && (*/}
                            {/*                        <Row className="mb-3">*/}
                            {/*                            <Col md={10}>*/}
                            {/*                                <AlertNewAction*/}
                            {/*                                    mensajeHTML={mensajePermisoDev}*/}
                            {/*                                    tipo={TiposAlerta.PARA_CONOCIMIENTO}*/}
                            {/*                                    cabeceraTitulo={"PARA SU CONOCIMIENTO"}*/}
                            {/*                                />*/}
                            {/*                            </Col>*/}
                            {/*                        </Row>*/}
                            {/*                    )}*/}
                            {/*                    {mensajeLicenciaDev !== "" && (*/}
                            {/*                        <Row className="mb-3">*/}
                            {/*                            <Col md={10}>*/}
                            {/*                                <AlertNewAction*/}
                            {/*                                    mensajeHTML={mensajeLicenciaDev}*/}
                            {/*                                    tipo={TiposAlerta.PARA_CONOCIMIENTO}*/}
                            {/*                                    cabeceraTitulo={"PARA SU CONOCIMIENTO"}*/}
                            {/*                                />*/}
                            {/*                            </Col>*/}
                            {/*                        </Row>*/}
                            {/*                    )}*/}
                            {/*                    {mensajeErrorLicencia !== "" && (*/}
                            {/*                        <Row className="mb-3">*/}
                            {/*                            <Col md={10}>*/}
                            {/*                                <AlertNewAction*/}
                            {/*                                    mensajeHTML={mensajeErrorLicencia}*/}
                            {/*                                    tipo={TiposAlerta.PARA_CONOCIMIENTO}*/}
                            {/*                                    cabeceraTitulo={"PARA SU CONOCIMIENTO"}*/}
                            {/*                                />*/}
                            {/*                            </Col>*/}
                            {/*                        </Row>*/}
                            {/*                    )}*/}
                            {/*                    {mensajeLicenciaComision !== "" && (*/}
                            {/*                        <Row className="mb-3">*/}
                            {/*                            <Col md={10}>*/}
                            {/*                                <AlertNewAction*/}
                            {/*                                    mensajeHTML={mensajeLicenciaComision}*/}
                            {/*                                    tipo={TiposAlerta.PARA_CONOCIMIENTO}*/}
                            {/*                                    cabeceraTitulo={"PARA SU CONOCIMIENTO"}*/}
                            {/*                                />*/}
                            {/*                            </Col>*/}
                            {/*                        </Row>*/}
                            {/*                    )}*/}
                            {/*                    {mensajePermisoMedico !== "" && (*/}
                            {/*                        <Row className="mb-3">*/}
                            {/*                            <Col md={10}>*/}
                            {/*                                <AlertNewAction*/}
                            {/*                                    mensajeHTML={mensajePermisoMedico}*/}
                            {/*                                    tipo={TiposAlerta.PARA_CONOCIMIENTO}*/}
                            {/*                                    cabeceraTitulo={"PARA SU CONOCIMIENTO"}*/}
                            {/*                                />*/}
                            {/*                            </Col>*/}
                            {/*                        </Row>*/}
                            {/*                    )}*/}
                            {/*                    {mensajeMarcacionAlmuerzo !== "" && (*/}
                            {/*                        <Row className="mb-3">*/}
                            {/*                            <Col md={10}>*/}
                            {/*                                <AlertNewAction*/}
                            {/*                                    cabeceraTitulo={"¡¡ADVERTENCIA!!"}*/}
                            {/*                                    mensajeHTML={mensajeMarcacionAlmuerzo}*/}
                            {/*                                    tipo={TiposAlerta.MENSAJE_ALMUERZO}*/}
                            {/*                                    onActionElement={() =>*/}
                            {/*                                        verificarInclusionAlmuerzo()*/}
                            {/*                                    }*/}
                            {/*                                    actionButton={true}*/}
                            {/*                                />*/}
                            {/*                            </Col>*/}
                            {/*                        </Row>*/}
                            {/*                    )}*/}
                            {/*                    <Row className="rowSolicitarPermisos">*/}
                            {/*                        <Col md={6} className="pr-0">*/}
                            {/*                            <FormGroup>*/}
                            {/*                                <Label*/}
                            {/*                                    className="label-permiso"*/}
                            {/*                                    for="tipoPermiso"*/}
                            {/*                                >*/}
                            {/*                                    Tipo de permiso:{" "}*/}
                            {/*                                </Label>*/}
                            {/*                                <SelectItem2*/}
                            {/*                                    options={tiposPermisos.map((permiso) => ({*/}
                            {/*                                        value: permiso.idtipopermiso,*/}
                            {/*                                        label: getLabelPermiso(permiso),*/}
                            {/*                                    }))}*/}
                            {/*                                    placeholder=""*/}
                            {/*                                    name="tipoPermiso"*/}
                            {/*                                    id="tipoPermiso"*/}
                            {/*                                    icon="fa-caret-down"*/}
                            {/*                                    value={tipoPermisoSeleccionado}*/}
                            {/*                                    onChange={handleTipoPermisoChange}*/}
                            {/*                                />*/}
                            {/*                            </FormGroup>*/}
                            {/*                        </Col>*/}
                            {/*                    </Row>*/}
                            {/*                    {tipoPermisoSeleccionado === 5 && (*/}
                            {/*                        <>*/}
                            {/*                            <Row>*/}
                            {/*                                <Col md={3} className="pr-0">*/}
                            {/*                                    <FormGroup>*/}
                            {/*                                        <Label for="tipoCita" className="label-permiso">Tipo Documento a Entregar*</Label>*/}
                            {/*                                        <Input*/}
                            {/*                                            type="select"*/}
                            {/*                                            value={tipoCita}*/}
                            {/*                                            onChange={handleTipoCitaChange}*/}
                            {/*                                            id="tipoCita"*/}
                            {/*                                        >*/}
                            {/*                                            <option value="">SELECCIONE EL TIPO DE DOCUMENTO A REGISTRAR</option>*/}
                            {/*                                            <option value="programada">PROGRAMACIÓN DE CITA</option>*/}
                            {/*                                            <option value="asistencia">CERTIFICADO DE ASISTENCIA A CITA</option>*/}
                            {/*                                        </Input>*/}
                            {/*                                    </FormGroup>*/}
                            {/*                                </Col>*/}
                            {/*                            </Row>*/}
                            {/*                            {tipoCita === "programada" && (*/}
                            {/*                                <>*/}
                            {/*                                    <Row>*/}
                            {/*                                        <Col md={2} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="fecha" className="label-permiso">*/}
                            {/*                                                    Fecha cita médica**/}
                            {/*                                                </Label>*/}
                            {/*                                                {DatePickerFechaHora(true)}*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                        <Col md={1} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="horaInicio" className="label-permiso">*/}
                            {/*                                                    Hora Inicio**/}
                            {/*                                                </Label>*/}
                            {/*                                                {inputHoraDesde()}*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                        <Col md={1} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="horaFin" className="label-permiso">*/}
                            {/*                                                    Hora Fin**/}
                            {/*                                                </Label>*/}
                            {/*                                                {inputHoraHasta()}*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                        <Col md={1} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="diasSolicitados" className="label-permiso">*/}
                            {/*                                                    H. solicitadas*/}
                            {/*                                                </Label>*/}
                            {/*                                                <Input*/}
                            {/*                                                    disabled={!habilitarIngresoHoras}*/}
                            {/*                                                    type="text"*/}
                            {/*                                                    value={*/}
                            {/*                                                        horasSolicitadas === undefined*/}
                            {/*                                                            ? ""*/}
                            {/*                                                            : horasSolicitadas*/}
                            {/*                                                    }*/}
                            {/*                                                    readOnly*/}
                            {/*                                                    id="horas_solicitadas"*/}
                            {/*                                                    style={{ minHeight: "30px" }}*/}
                            {/*                                                ></Input>*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                        <Col md={2} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="archivo" className="label-permiso">*/}
                            {/*                                                    Subir evidencia programación de cita**/}
                            {/*                                                </Label>*/}
                            {/*                                                <InputFileUpload2*/}
                            {/*                                                    icon="upload"*/}
                            {/*                                                    name="CERT"*/}
                            {/*                                                    onChange={handleFileUploadProgCita}*/}
                            {/*                                                    placeholder={""}*/}
                            {/*                                                    fileArray={certProgCita}*/}
                            {/*                                                />*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                    </Row>*/}
                            {/*                                    <Row>*/}
                            {/*                                        <Col md={6} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="archivo" className="label-permiso">*/}
                            {/*                                                    Observación (Máximo 100 caracteres)*/}
                            {/*                                                </Label>*/}
                            {/*                                                <Input*/}
                            {/*                                                    type="text"*/}
                            {/*                                                    value={observacionPermiso}*/}
                            {/*                                                    onChange={handleObservacionChange}*/}
                            {/*                                                    maxLength={100}*/}
                            {/*                                                    id="observacion"*/}
                            {/*                                                    style={{ minHeight: "30px" }}*/}
                            {/*                                                ></Input>*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}

                            {/*                                        <Col md={1} className="align-self-start d-flex justify-content-start mt-3 pl-3 pr-0">*/}
                            {/*                                            <Button*/}
                            {/*                                                onClick={() => handleClickSolicitar()}*/}
                            {/*                                                disabled={*/}
                            {/*                                                    errorHoras !== "" ||*/}
                            {/*                                                    mensajeError !== "" ||*/}
                            {/*                                                    !validarCamposPAMProgramada()*/}
                            {/*                                                }*/}
                            {/*                                            >*/}
                            {/*                                                SOLICITAR*/}
                            {/*                                            </Button>*/}
                            {/*                                        </Col>*/}
                            {/*                                    </Row>*/}
                            {/*                                </>*/}
                            {/*                            )}*/}
                            {/*                            {tipoCita === "asistencia" && (*/}
                            {/*                                <>*/}
                            {/*                                    <Row>*/}
                            {/*                                        <Col md={2} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="fecha" className="label-permiso">*/}
                            {/*                                                    Fecha de Asistencia**/}
                            {/*                                                </Label>*/}
                            {/*                                                {DatePickerFechaHora(true)}*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                        <Col md={1} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="horaInicio" className="label-permiso">*/}
                            {/*                                                    Hora Inicio**/}
                            {/*                                                </Label>*/}
                            {/*                                                {inputHoraDesde()}*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                        <Col md={1} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="horaFin" className="label-permiso">*/}
                            {/*                                                    Hora Fin**/}
                            {/*                                                </Label>*/}
                            {/*                                                {inputHoraHasta()}*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                        <Col md={1} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="diasSolicitados" className="label-permiso">*/}
                            {/*                                                    H. solicitadas*/}
                            {/*                                                </Label>*/}
                            {/*                                                <Input*/}
                            {/*                                                    disabled={!habilitarIngresoHoras}*/}
                            {/*                                                    type="text"*/}
                            {/*                                                    value={*/}
                            {/*                                                        horasSolicitadas === undefined*/}
                            {/*                                                            ? ""*/}
                            {/*                                                            : horasSolicitadas*/}
                            {/*                                                    }*/}
                            {/*                                                    readOnly*/}
                            {/*                                                    id="horas_solicitadas"*/}
                            {/*                                                    style={{ minHeight: "30px" }}*/}
                            {/*                                                ></Input>*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                        <Col md={2} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="archivo" className="label-permiso">*/}
                            {/*                                                    Subir certificado de asistencia**/}
                            {/*                                                </Label>*/}
                            {/*                                                <InputFileUpload2*/}
                            {/*                                                    icon="upload"*/}
                            {/*                                                    name="CERT"*/}
                            {/*                                                    onChange={handleFileUpload}*/}
                            {/*                                                    placeholder={""}*/}
                            {/*                                                    fileArray={certMedico}*/}
                            {/*                                                />*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                    </Row>*/}
                            {/*                                    <Row>*/}
                            {/*                                        <Col md={6} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label for="archivo" className="label-permiso">*/}
                            {/*                                                    Observación (Máximo 100 caracteres)*/}
                            {/*                                                </Label>*/}
                            {/*                                                <Input*/}
                            {/*                                                    type="text"*/}
                            {/*                                                    value={observacionPermiso}*/}
                            {/*                                                    onChange={handleObservacionChange}*/}
                            {/*                                                    maxLength={100}*/}
                            {/*                                                    id="observacion"*/}
                            {/*                                                    style={{ minHeight: "30px" }}*/}
                            {/*                                                ></Input>*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}

                            {/*                                        <Col md={1} className="align-self-start d-flex justify-content-start mt-3 pl-3 pr-0">*/}
                            {/*                                            <Button*/}
                            {/*                                                onClick={() => handleClickSolicitar()}*/}
                            {/*                                                disabled={*/}
                            {/*                                                    errorHoras !== "" ||*/}
                            {/*                                                    mensajeError !== "" ||*/}
                            {/*                                                    !validarCamposPAMAsistencia()*/}
                            {/*                                                }*/}
                            {/*                                            >*/}
                            {/*                                                SOLICITAR*/}
                            {/*                                            </Button>*/}
                            {/*                                        </Col>*/}
                            {/*                                    </Row>*/}
                            {/*                                </>*/}
                            {/*                            )}*/}


                            {/*                        </>*/}
                            {/*                    )}*/}
                            {/*                    {tipoPermisoSeleccionado === 29 && (*/}
                            {/*                        <>*/}
                            {/*                            <Row>*/}
                            {/*                                <>*/}
                            {/*                                    <Col md={4} className="pr-0">*/}
                            {/*                                        <FormGroup>*/}
                            {/*                                            <Label*/}
                            {/*                                                for="fecha"*/}
                            {/*                                                className="label-permiso"*/}
                            {/*                                            >*/}
                            {/*                                                Hijo/a* (Información extraída de Datos*/}
                            {/*                                                Personales - Información Familiar)*/}
                            {/*                                            </Label>*/}
                            {/*                                            <SelectItem2*/}
                            {/*                                                options={*/}
                            {/*                                                    informacionHijos.length > 0*/}
                            {/*                                                        ? informacionHijos.map((hijo) => ({*/}
                            {/*                                                            value: hijo.idDependientePersona,*/}
                            {/*                                                            label: hijo.nombre,*/}
                            {/*                                                        }))*/}
                            {/*                                                        : [*/}
                            {/*                                                            {*/}
                            {/*                                                                value: "",*/}
                            {/*                                                                label:*/}
                            {/*                                                                    "No existe información de hijos en edad escolar",*/}
                            {/*                                                                isDisabled: true,*/}
                            {/*                                                            },*/}
                            {/*                                                        ]*/}
                            {/*                                                }*/}
                            {/*                                                placeholder={*/}
                            {/*                                                    informacionHijos.length > 0*/}
                            {/*                                                        ? ""*/}
                            {/*                                                        : "No existe información de hijos en edad escolar"*/}
                            {/*                                                }*/}
                            {/*                                                name="informacionHijo"*/}
                            {/*                                                id="informacionHijo"*/}
                            {/*                                                icon="fa-caret-down"*/}
                            {/*                                                value={hijoSeleccionado}*/}
                            {/*                                                onChange={handleHijoChange}*/}
                            {/*                                                isSearchable={false}*/}
                            {/*                                            />*/}
                            {/*                                        </FormGroup>*/}
                            {/*                                    </Col>*/}
                            {/*                                    <Col md={2} className="pr-0">*/}
                            {/*                                        <FormGroup>*/}
                            {/*                                            <Label*/}
                            {/*                                                for="fecha"*/}
                            {/*                                                className="label-permiso"*/}
                            {/*                                            >*/}
                            {/*                                                Fecha**/}
                            {/*                                            </Label>*/}
                            {/*                                            {DatePickerFechaHora(true)}*/}
                            {/*                                        </FormGroup>*/}
                            {/*                                    </Col>*/}
                            {/*                                    <Col md={1} className="pr-0">*/}
                            {/*                                        <FormGroup>*/}
                            {/*                                            <Label*/}
                            {/*                                                for="horaInicio"*/}
                            {/*                                                className="label-permiso"*/}
                            {/*                                            >*/}
                            {/*                                                Hora inicio**/}
                            {/*                                            </Label>*/}
                            {/*                                            {inputHoraDesde()}*/}
                            {/*                                        </FormGroup>*/}
                            {/*                                    </Col>*/}
                            {/*                                    <Col md={1} className="pr-0">*/}
                            {/*                                        <FormGroup>*/}
                            {/*                                            <Label*/}
                            {/*                                                for="horaInicio"*/}
                            {/*                                                className="label-permiso"*/}
                            {/*                                            >*/}
                            {/*                                                Hora fin**/}
                            {/*                                            </Label>*/}
                            {/*                                            {inputHoraHasta()}*/}
                            {/*                                        </FormGroup>*/}
                            {/*                                    </Col>*/}
                            {/*                                    <Col md={1} className="pr-0">*/}
                            {/*                                        <FormGroup>*/}
                            {/*                                            <Label*/}
                            {/*                                                for="diasSolicitados"*/}
                            {/*                                                className="label-permiso"*/}
                            {/*                                            >*/}
                            {/*                                                Horas solicitadas*/}
                            {/*                                            </Label>*/}
                            {/*                                            <Input*/}
                            {/*                                                disabled={!habilitarIngresoHoras}*/}
                            {/*                                                type="text"*/}
                            {/*                                                value={*/}
                            {/*                                                    horasSolicitadas === undefined*/}
                            {/*                                                        ? ""*/}
                            {/*                                                        : horasSolicitadas*/}
                            {/*                                                }*/}
                            {/*                                                readOnly*/}
                            {/*                                                id="horas_solicitadas"*/}
                            {/*                                                style={{ minHeight: "30px" }}*/}
                            {/*                                            ></Input>*/}
                            {/*                                        </FormGroup>*/}
                            {/*                                    </Col>*/}
                            {/*                                </>*/}
                            {/*                            </Row>*/}
                            {/*                            <Row>*/}
                            {/*                                <Col md={6} className="pr-0">*/}
                            {/*                                    <FormGroup>*/}
                            {/*                                        <Label*/}
                            {/*                                            for="archivo"*/}
                            {/*                                            className="label-permiso"*/}
                            {/*                                        >*/}
                            {/*                                            Observación (Máximo 100 caracteres)*/}
                            {/*                                        </Label>*/}
                            {/*                                        <Input*/}
                            {/*                                            type="text"*/}
                            {/*                                            value={observacionPermiso}*/}
                            {/*                                            onChange={handleObservacionChange}*/}
                            {/*                                            maxLength={100}*/}
                            {/*                                            id="observacion"*/}
                            {/*                                            style={{ minHeight: "30px" }}*/}
                            {/*                                        ></Input>*/}
                            {/*                                    </FormGroup>*/}
                            {/*                                </Col>*/}
                            {/*                                <Col md={2} className="pr-0">*/}
                            {/*                                    <FormGroup>*/}
                            {/*                                        <Label*/}
                            {/*                                            for="archivo"*/}
                            {/*                                            className="label-permiso"*/}
                            {/*                                        >*/}
                            {/*                                            Subir evidencia**/}
                            {/*                                        </Label>*/}
                            {/*                                        <InputFileUpload2*/}
                            {/*                                            icon="upload"*/}
                            {/*                                            name="CERT"*/}
                            {/*                                            onChange={handleFileUpload}*/}
                            {/*                                            placeholder={""}*/}
                            {/*                                            fileArray={certMedico}*/}
                            {/*                                        />*/}
                            {/*                                    </FormGroup>*/}
                            {/*                                </Col>*/}
                            {/*                                <Col*/}
                            {/*                                    md={1}*/}
                            {/*                                    className="align-self-start d-flex justify-content-start mt-3"*/}
                            {/*                                >*/}
                            {/*                                    <Button*/}
                            {/*                                        onClick={() => handleClickSolicitar()}*/}
                            {/*                                        disabled={*/}
                            {/*                                            errorHoras !== "" ||*/}
                            {/*                                            mensajeError !== "" ||*/}
                            {/*                                            mensajeErrorMat !== "" ||*/}
                            {/*                                            !validarCamposPMH()*/}
                            {/*                                        }*/}
                            {/*                                    >*/}
                            {/*                                        SOLICITAR{" "}*/}
                            {/*                                    </Button>*/}
                            {/*                                </Col>*/}
                            {/*                            </Row>*/}
                            {/*                        </>*/}
                            {/*                    )}*/}
                            {/*                    {tipoPermisoSeleccionado === 46 && (*/}
                            {/*                            <>*/}
                            {/*                        <Row>*/}
                            {/*                            <Col md={12} className="notificacion-permiso">*/}
                            {/*                                <Label>*/}
                            {/*                                    <em><strong>*/}
                            {/*                                        {licenciasTipo3[0].fechaHasta ? (*/}
                            {/*                                            `El rango de fechas de su permiso para el cuidado del recién nacido, inicia el ${formatDateToString(licenciasTipo3[0].inicioCuidado)} hasta el ${formatDateToString(SumarMesesFecha(licenciasTipo3[0].fechaHasta, 15))}, que equivale a un período de 15 meses.`*/}
                            {/*                                        ) : (*/}
                            {/*                                            "No se encontró información de licencia de maternidad"*/}
                            {/*                                        )}*/}
                            {/*                                    </strong></em>*/}
                            {/*                                </Label>*/}
                            {/*                            </Col>*/}
                            {/*                        </Row>*/}
                            {/*                        <Row>*/}
                            {/*                        <Col md={12}>*/}
                            {/*                                        <Label className="label-permiso">*/}
                            {/*                                            HORARIO DE PERMISO*/}
                            {/*                                        </Label>*/}
                            {/*                                    </Col>*/}
                            {/*                                </Row>*/}
                            {/*                                <Row>*/}
                            {/*                                <>*/}
                            {/*                                    <Col md={2} className="pr-0">*/}
                            {/*                                        <FormGroup>*/}
                            {/*                                            <Label*/}
                            {/*                                                for="fechadesde"*/}
                            {/*                                                className="label-permiso"*/}
                            {/*                                            >*/}
                            {/*                                                Fecha Desde*/}
                            {/*                                            </Label>*/}
                            {/*                                        <Input*/}
                            {/*                                            value={*/}
                            {/*                                                solicitudesCambioHorario?.length > 0 && solicitudesCambioHorario[0]?.fechaDesde*/}
                            {/*                                                    ? formatDateToString(solicitudesCambioHorario[0].fechaDesde)*/}
                            {/*                                                    : props.permisosCRN?.length > 0 && props.permisosCRN[0]?.fechaDesde*/}
                            {/*                                                        ? formatDateToString(props.permisosCRN[0].fechaDesde)*/}
                            {/*                                                        : ''*/}
                            {/*                                            }*/}
                            {/*                                            disabled*/}
                            {/*                                        />*/}
                            {/*                                        </FormGroup>*/}
                            {/*                                    </Col>*/}
                            {/*                                    <Col md={2} className="pr-0">*/}
                            {/*                                        <FormGroup>*/}
                            {/*                                            <Label*/}
                            {/*                                                for="fechahasta"*/}
                            {/*                                                className="label-permiso"*/}
                            {/*                                            >*/}
                            {/*                                                Fecha Hasta*/}
                            {/*                                            </Label>*/}
                            {/*                                        <Input*/}
                            {/*                                            value={*/}
                            {/*                                                solicitudesCambioHorario?.length > 0 && solicitudesCambioHorario[0]?.fechaHasta*/}
                            {/*                                                    ? formatDateToString(solicitudesCambioHorario[0].fechaHasta)*/}
                            {/*                                                    : props.permisosCRN?.length > 0 && props.permisosCRN[0]?.fechaHasta*/}
                            {/*                                                        ? formatDateToString(props.permisosCRN[0].fechaHasta)*/}
                            {/*                                                        : ''*/}
                            {/*                                            }*/}
                            {/*                                            disabled*/}
                            {/*                                        />*/}
                            {/*                                        </FormGroup>*/}
                            {/*                                    </Col>*/}
                            {/*                                        <Col md={1} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label*/}
                            {/*                                                    for="horaentrada"*/}
                            {/*                                                    className="label-permiso"*/}
                            {/*                                                >*/}
                            {/*                                                    Hora Inicio*/}
                            {/*                                                </Label>*/}
                            {/*                                        <Input*/}
                            {/*                                            value={*/}
                            {/*                                                solicitudesCambioHorario?.length > 0 && solicitudesCambioHorario[0]?.horaInicio*/}
                            {/*                                                    ? solicitudesCambioHorario[0].horaInicio*/}
                            {/*                                                    : props.permisosCRN?.length > 0 && props.permisosCRN[0]?.horaDesde*/}
                            {/*                                                        ? props.permisosCRN[0].horaDesde*/}
                            {/*                                                        : ''*/}
                            {/*                                            }*/}
                            {/*                                            disabled*/}
                            {/*                                        />*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                        <Col md={1} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label*/}
                            {/*                                                    for="horasalida"*/}
                            {/*                                                    className="label-permiso"*/}
                            {/*                                                >*/}
                            {/*                                                    Hora Fin*/}
                            {/*                                                </Label>*/}
                            {/*                                        <Input*/}
                            {/*                                            value={*/}
                            {/*                                                solicitudesCambioHorario?.length > 0 && solicitudesCambioHorario[0]?.horaFin*/}
                            {/*                                                    ? solicitudesCambioHorario[0].horaFin*/}
                            {/*                                                    : props.permisosCRN?.length > 0 && props.permisosCRN[0]?.horaHasta*/}
                            {/*                                                        ? props.permisosCRN[0].horaHasta*/}
                            {/*                                                        : ''*/}
                            {/*                                            }*/}
                            {/*                                            disabled*/}
                            {/*                                        />*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                </Col>*/}
                            {/*                                {(permisosCambioRN[0].horaDesdeTarde && solicitudesCambioHorario.length == 0) && (*/}
                            {/*                                    <>*/}
                            {/*                                        <Col md={1} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label*/}
                            {/*                                                    for="horaentrada"*/}
                            {/*                                                    className="label-permiso"*/}
                            {/*                                                >*/}
                            {/*                                                    Hora Inicio*/}
                            {/*                                                </Label>*/}
                            {/*                                                <Input*/}
                            {/*                                                    value={props.permisosCRN[0].horaDesdeTarde}*/}
                            {/*                                                    disabled*/}
                            {/*                                                />*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                        <Col md={1} className="pr-0">*/}
                            {/*                                            <FormGroup>*/}
                            {/*                                                <Label*/}
                            {/*                                                    for="horasalida"*/}
                            {/*                                                    className="label-permiso"*/}
                            {/*                                                >*/}
                            {/*                                                    Hora Fin*/}
                            {/*                                                </Label>*/}
                            {/*                                                <Input*/}
                            {/*                                                    value={props.permisosCRN[0].horaHastaTarde}*/}
                            {/*                                                    disabled*/}
                            {/*                                                />*/}
                            {/*                                            </FormGroup>*/}
                            {/*                                        </Col>*/}
                            {/*                                    </>*/}
                            {/*                                )}*/}
                            {/*                                {(solicitudesCambioHorario.length > 0 && solicitudesCambioHorario[0].horaInicioTarde !== "") && (*/}
                            {/*                                        <>*/}
                            {/*                                            <Col md={1} className="pr-0">*/}
                            {/*                                                <FormGroup>*/}
                            {/*                                                    <Label for="horaentrada" className="label-permiso">*/}
                            {/*                                                        Hora Inicio*/}
                            {/*                                                    </Label>*/}
                            {/*                                                    <Input*/}
                            {/*                                                        value={solicitudesCambioHorario[0].horaInicioTarde}*/}
                            {/*                                                        disabled*/}
                            {/*                                                    />*/}
                            {/*                                                </FormGroup>*/}
                            {/*                                            </Col>*/}
                            {/*                                            <Col md={1} className="pr-0">*/}
                            {/*                                                <FormGroup>*/}
                            {/*                                                    <Label for="horasalida" className="label-permiso">*/}
                            {/*                                                        Hora Fin*/}
                            {/*                                                    </Label>*/}
                            {/*                                                    <Input*/}
                            {/*                                                    value={solicitudesCambioHorario[0].horaFinTarde}*/}
                            {/*                                                        disabled*/}
                            {/*                                                    />*/}
                            {/*                                                </FormGroup>*/}
                            {/*                                            </Col>*/}
                            {/*                                        </>*/}
                            {/*                                    )}*/}
                            {/*                                    </>*/}
                            {/*                                </Row>                                                            */}
                            {/*                                <Row>*/}
                            {/*                                    <Col*/}
                            {/*                                        md={12}*/}
                            {/*                                        className="align-self-start d-flex justify-content-center mt-3"*/}
                            {/*                                    >*/}
                            {/*                                        <Button*/}
                            {/*                                            onClick={toggleModal}*/}
                            {/*                                            className="btn-cambiarhorario"*/}
                            {/*                                        >*/}
                            {/*                                            CAMBIAR HORARIO{" "}*/}
                            {/*                                </Button>*/}

                            {/*                                {permisosCambioRN[0].archivo == "" && (*/}
                            {/*                                    <>*/}
                            {/*                                        <Button*/}
                            {/*                                            onClick={() => handleClickSolicitarCH()}*/}
                            {/*                                        >*/}
                            {/*                                            CONFIRMAR{" "}*/}
                            {/*                                        </Button>*/}
                            {/*                                    </>*/}
                            {/*                                ) }*/}
                            {/*                                    </Col>*/}
                            {/*                                </Row>*/}
                            {/*                            </>*/}
                            {/*                        )}*/}
                            {/*                    {SolicitudesPermisos}*/}
                            {/*                </Form>*/}
                            {/*            </Col>*/}
                            {/*        </Row>*/}
                            {/*    </TabPane>*/}
                            {/*</TabContent>*/}
                            <TabContent activeTab={tabActiva}>
                                <TabPane tabId={TabSolicitudActiva.LICENCIAS}>
                                    <Row className="ContentTabSolicitudes2">

                                        <Col sm="12" style={{ paddingLeft: 0, paddingRight: 0 }}>
                                            <Form autoComplete="off">
                                                {mensajePermisoNot !== "" && (
                                                    <Row className="mb-3">
                                                        <Col md={10}>
                                                            <AlertNewAction
                                                                cabeceraTitulo={"¡¡ADVERTENCIA!!"}
                                                                mensaje={mensajePermisoNot}
                                                                tipo={TiposAlerta.ADVERTENCIA}
                                                                oncloseElement={() => { ; }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}
                                                {mensajeLicenciaNot !== "" && (
                                                    <Row className="mb-3">
                                                        <Col md={10}>
                                                            <AlertNewAction
                                                                mensajeHTML={mensajeLicenciaNot}
                                                                tipo={TiposAlerta.ADVERTENCIA}
                                                                cabeceraTitulo={"¡¡ADVERTENCIA!!"}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}
                                                {mensajePermisoDev !== "" && (
                                                    <Row className="mb-3">
                                                        <Col md={10}>
                                                            <AlertNewAction
                                                                mensajeHTML={mensajePermisoDev}
                                                                tipo={TiposAlerta.PARA_CONOCIMIENTO}
                                                                cabeceraTitulo={"PARA SU CONOCIMIENTO"}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}
                                                {mensajeLicenciaDev !== "" && (
                                                    <Row className="mb-3">
                                                        <Col md={10}>
                                                            <AlertNewAction
                                                                mensajeHTML={mensajeLicenciaDev}
                                                                tipo={TiposAlerta.PARA_CONOCIMIENTO}
                                                                cabeceraTitulo={"PARA SU CONOCIMIENTO"}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}
                                                {mensajeLicenciaComision !== "" && (
                                                    <Row className="mb-3">
                                                        <Col md={10}>
                                                            <AlertNewAction
                                                                mensajeHTML={mensajeLicenciaComision}
                                                                tipo={TiposAlerta.PARA_CONOCIMIENTO}
                                                                cabeceraTitulo={"PARA SU CONOCIMIENTO"}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}
                                                {mensajeErrorLicencia !== "" && (
                                                    <Row className="mb-3">
                                                        <Col md={10}>
                                                            <AlertNewAction
                                                                mensajeHTML={mensajeErrorLicencia}
                                                                tipo={TiposAlerta.PARA_CONOCIMIENTO}
                                                                cabeceraTitulo={"PARA SU CONOCIMIENTO"}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}
                                                {mensajePermisoMedico !== "" && (
                                                    <Row className="mb-3">
                                                        <Col md={10}>
                                                            <AlertNewAction
                                                                mensajeHTML={mensajePermisoMedico}
                                                                tipo={TiposAlerta.PARA_CONOCIMIENTO}
                                                                cabeceraTitulo={"PARA SU CONOCIMIENTO"}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}
                                                {mensajeMarcacionAlmuerzo !== "" && (
                                                    <Row className="mb-3">
                                                        <Col md={10}>
                                                            <AlertNewAction
                                                                cabeceraTitulo={"¡¡ADVERTENCIA!!"}
                                                                mensajeHTML={mensajeMarcacionAlmuerzo}
                                                                tipo={TiposAlerta.MENSAJE_ALMUERZO}
                                                                onActionElement={() =>
                                                                    verificarInclusionAlmuerzo()
                                                                }
                                                                actionButton={true}
                                                            />
                                                        </Col>
                                                    </Row>
                                                )}
                                                <Row className="rowSolicitarPermisos">
                                                    <Col md={6} className="pr-0">
                                                        <FormGroup>
                                                            <Label
                                                                for="tipoPermiso"
                                                                className="label-permiso"
                                                            >
                                                                Tipo de licencia con remuneración:{" "}
                                                            </Label>
                                                            <SelectItem2
                                                                options={tiposLicencias.map((permiso) => ({
                                                                    value: permiso.idtipopermiso,
                                                                    label: permiso.descripcion,
                                                                }))}
                                                                placeholder=""
                                                                name="tipoPermiso"
                                                                id="tipoPermiso"
                                                                icon="fa-caret-down"
                                                                value={tipoLicenciaSeleccionado}
                                                                onChange={handleTipoLicenciaChange}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                {tipoLicenciaSeleccionado === 17 && (
                                                    <>
                                                        <Row>
                                                            <Col md={4} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="tipoCalamidad"
                                                                        className="label-permiso"
                                                                    >
                                                                        Tipo de calamidad*
                                                                    </Label>
                                                                    <SelectItem2
                                                                        options={tiposCalamidadDomestica.map(
                                                                            (tipo) => ({
                                                                                value: tipo.idprnsubtipopermisos,
                                                                                label: tipo.nombre,
                                                                            })
                                                                        )}
                                                                        placeholder=""
                                                                        name="tipoPermiso"
                                                                        id="tipoPermiso"
                                                                        icon="fa-caret-down"
                                                                        value={tipoCalamidadSeleccionado}
                                                                        onChange={handleTipoCalamidadChange}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaEvento"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Evento*
                                                                    </Label>
                                                                    {DatePickerLicenciaEvento(true)}
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaDesde"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Desde
                                                                    </Label>
                                                                    <Input
                                                                        value={
                                                                            stateCard.fechaDesde
                                                                                ? formatDateToString(
                                                                                    stateCard.fechaDesde
                                                                                )
                                                                                : ""
                                                                        }
                                                                        disabled
                                                                        style={{ minHeight: "30px" }}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaHasta"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Hasta*
                                                                    </Label>
                                                                    {DatePickerCalamidadFin(true)}
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="diasSolicitados"
                                                                        className="label-permiso"
                                                                    >
                                                                        Días solicitados
                                                                    </Label>
                                                                    <Input
                                                                        disabled={!habilitarIngresoHoras}
                                                                        type="text"
                                                                        value={diasSolicitados}
                                                                        readOnly
                                                                        id="horas_solicitadas"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Observación (Máximo 100 caracteres)
                                                                    </Label>
                                                                    <Input
                                                                        type="text"
                                                                        value={observacionPermiso}
                                                                        onChange={handleObservacionChange}
                                                                        maxLength={140}
                                                                        id="observacion"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                            {tipoCalamidadSeleccionado !== 0 &&
                                                                tipoCalamidadSeleccionado === 16 && (
                                                                    <Col md={2} className="pr-0">
                                                                        <FormGroup>
                                                                            <Label
                                                                                for="provincia"
                                                                                className="label-permiso"
                                                                            >
                                                                                Seleccione la provincia:
                                                                            </Label>
                                                                            <SelectItem2
                                                                                options={provincias.map((prov) => ({
                                                                                    value: prov.idProvincia,
                                                                                    label: prov.nombre,
                                                                                }))}
                                                                                placeholder=""
                                                                                name="provincia"
                                                                                id="provincia"
                                                                                icon="fa-caret-down"
                                                                                value={provinciaSeleccionado}
                                                                                onChange={handleProvinciaChange}
                                                                            />
                                                                        </FormGroup>
                                                                    </Col>
                                                                )}
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Subir evidencia
                                                                    </Label>
                                                                    <InputFileUpload2
                                                                        icon="upload"
                                                                        name="MEN"
                                                                        onChange={handleFileUpload}
                                                                        placeholder={""}
                                                                        fileArray={certMedico}
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col
                                                                md={2}
                                                                className="align-self-start d-flex justify-content-start mt-3"
                                                            >
                                                                <Button
                                                                    onClick={() => handleClickSolicitarLCD()}
                                                                    disabled={
                                                                        errorDias !== "" ||
                                                                        mensajeError !== "" ||
                                                                        !validarCamposLPCD()
                                                                    }
                                                                >
                                                                    SOLICITAR{" "}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                {tipoLicenciaSeleccionado === 3 && (
                                                    <>
                                                        <Row>
                                                            <Col md={4} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="tipoCalamidad"
                                                                        className="label-permiso"
                                                                    >
                                                                        Tipo de alumbramiento*
                                                                    </Label>
                                                                    <SelectItem2
                                                                        options={tiposNacMaternidad.map((tipo) => ({
                                                                            value: tipo.idprnsubtipopermisos,
                                                                            label: tipo.nombre,
                                                                        }))}
                                                                        placeholder=""
                                                                        name="tipoPermiso"
                                                                        id="tipoPermiso"
                                                                        icon="fa-caret-down"
                                                                        value={tipoNacMaternidadSeleccionado}
                                                                        onChange={handleTipoNacMaternidadChange}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaEvento"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Evento*
                                                                    </Label>
                                                                    {DatePickerLicenciaEvento(true)}
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaDesde"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Desde
                                                                    </Label>
                                                                    <Input
                                                                        value={
                                                                            stateCard.fechaDesde
                                                                                ? formatDateToString(
                                                                                    stateCard.fechaDesde
                                                                                )
                                                                                : ""
                                                                        }
                                                                        disabled
                                                                        style={{ minHeight: "30px" }}
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaHasta"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Hasta*
                                                                    </Label>
                                                                    <Input
                                                                        value={
                                                                            stateCard.fechaHasta
                                                                                ? formatDateToString(
                                                                                    stateCard.fechaHasta
                                                                                )
                                                                                : ""
                                                                        }
                                                                        disabled
                                                                        style={{ minHeight: "30px" }}
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="diasSolicitados"
                                                                        className="label-permiso"
                                                                    >
                                                                        Días solicitados
                                                                    </Label>
                                                                    <Input
                                                                        disabled={!habilitarIngresoHoras}
                                                                        type="text"
                                                                        value={diasSolicitados}
                                                                        readOnly
                                                                        id="horas_solicitadas"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Observación (Máximo 100 caracteres)
                                                                    </Label>
                                                                    <Input
                                                                        type="text"
                                                                        value={observacionPermiso}
                                                                        onChange={handleObservacionChange}
                                                                        maxLength={140}
                                                                        id="observacion"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Subir evidencia*
                                                                    </Label>
                                                                    <InputFileUpload2
                                                                        icon="upload"
                                                                        name="MEN"
                                                                        onChange={handleFileUpload}
                                                                        placeholder={""}
                                                                        fileArray={certMedico}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col
                                                                md={2}
                                                                className="align-self-start d-flex justify-content-start mt-3"
                                                            >
                                                                <Button
                                                                    onClick={() => handleClickSolicitarLCD()}
                                                                    disabled={
                                                                        errorDias !== "" ||
                                                                        mensajeError !== "" ||
                                                                        mensajeErrorCRN !== "" ||
                                                                        !validarCamposLPM()
                                                                    }
                                                                >
                                                                    SOLICITAR{" "}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                        <Row className="rowErroresHoras">
                                                            <Col md={{ size: 12 }}>
                                                                <small className="message-medium ">
                                                                    {mensajeTiempoLicMaternidad}
                                                                </small>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                {tipoLicenciaSeleccionado === 12 && (
                                                    <>
                                                        <Row>
                                                            <Col md={4} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="tipoCalamidad"
                                                                        className="label-permiso"
                                                                    >
                                                                        Tipo de alumbramiento*
                                                                    </Label>
                                                                    <SelectItem2
                                                                        options={tiposNacPaternidad.map((tipo) => ({
                                                                            value: tipo.idprnsubtipopermisos,
                                                                            label: tipo.nombre,
                                                                        }))}
                                                                        placeholder=""
                                                                        name="tipoPermiso"
                                                                        id="tipoPermiso"
                                                                        icon="fa-caret-down"
                                                                        value={tipoNacPaternidadSeleccionado}
                                                                        onChange={handleTipoNacPaternidadChange}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaEvento"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Evento*
                                                                    </Label>
                                                                    {DatePickerLicenciaEvento(true)}
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaDesde"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Desde
                                                                    </Label>
                                                                    <Input
                                                                        value={
                                                                            stateCard.fechaDesde
                                                                                ? formatDateToString(
                                                                                    stateCard.fechaDesde
                                                                                )
                                                                                : ""
                                                                        }
                                                                        disabled
                                                                        style={{ minHeight: "30px" }}
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaHasta"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Hasta*
                                                                    </Label>
                                                                    <Input
                                                                        value={
                                                                            stateCard.fechaHasta
                                                                                ? formatDateToString(
                                                                                    stateCard.fechaHasta
                                                                                )
                                                                                : ""
                                                                        }
                                                                        style={{ minHeight: "30px" }}
                                                                        disabled
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="diasSolicitados"
                                                                        className="label-permiso"
                                                                    >
                                                                        Días solicitados
                                                                    </Label>
                                                                    <Input
                                                                        disabled={!habilitarIngresoHoras}
                                                                        type="text"
                                                                        value={diasSolicitados}
                                                                        style={{ minHeight: "30px" }}
                                                                        readOnly
                                                                        id="horas_solicitadas"
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Observación (Máximo 100 caracteres)
                                                                    </Label>
                                                                    <Input
                                                                        type="text"
                                                                        value={observacionPermiso}
                                                                        onChange={handleObservacionChange}
                                                                        maxLength={140}
                                                                        id="observacion"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Subir evidencia*
                                                                    </Label>
                                                                    <InputFileUpload2
                                                                        icon="upload"
                                                                        name="MEN"
                                                                        onChange={handleFileUpload}
                                                                        placeholder={""}
                                                                        fileArray={certMedico}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col
                                                                md={2}
                                                                className="align-self-start d-flex justify-content-start mt-3"
                                                            >
                                                                <Button
                                                                    onClick={() => handleClickSolicitarLCD()}
                                                                    disabled={
                                                                        errorDias !== "" ||
                                                                        mensajeError !== "" ||
                                                                        !validarCamposLPP()
                                                                    }
                                                                >
                                                                    SOLICITAR{" "}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                        <Row className="rowErroresHoras">
                                                            <Col md={{ size: 12 }}>
                                                                <small className="message-medium ">
                                                                    {mensajeTiempoLicMaternidad}
                                                                </small>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                {tipoLicenciaSeleccionado === 11 && (
                                                    <>
                                                        <Row>
                                                            <Col md={4} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="tipoCalamidad"
                                                                        className="label-permiso"
                                                                    >
                                                                        Tipo de certificado*
                                                                    </Label>
                                                                    <SelectItem2
                                                                        options={tiposCertificados.map((tipo) => ({
                                                                            value: tipo.idprnsubtipopermisos,
                                                                            label: tipo.nombre,
                                                                        }))}
                                                                        placeholder=""
                                                                        name="tipoPermiso"
                                                                        id="tipoPermiso"
                                                                        icon="fa-caret-down"
                                                                        value={tipoCertificadoSeleccionado}
                                                                        onChange={handleTipoCertificadoChange}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaEvento"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Evento*
                                                                    </Label>
                                                                    {DatePickerLicenciaEvento(true)}
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaDesde"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Desde
                                                                    </Label>
                                                                    <Input
                                                                        value={
                                                                            stateCard.fechaDesde
                                                                                ? formatDateToString(
                                                                                    stateCard.fechaDesde
                                                                                )
                                                                                : ""
                                                                        }
                                                                        disabled
                                                                        style={{ minHeight: "30px" }}
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaHasta"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Hasta*
                                                                    </Label>
                                                                    {DatePickerLicenciaFin(true)}
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="diasSolicitados"
                                                                        className="label-permiso"
                                                                    >
                                                                        Días solicitados
                                                                    </Label>
                                                                    <Input
                                                                        disabled={!habilitarIngresoHoras}
                                                                        type="text"
                                                                        value={diasSolicitados}
                                                                        style={{ minHeight: "30px" }}
                                                                        readOnly
                                                                        id="horas_solicitadas"
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Observación (Máximo 100 caracteres)
                                                                    </Label>
                                                                    <Input
                                                                        type="text"
                                                                        value={observacionPermiso}
                                                                        onChange={handleObservacionChange}
                                                                        maxLength={140}
                                                                        id="observacion"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Subir evidencia*
                                                                    </Label>
                                                                    <InputFileUpload2
                                                                        icon="upload"
                                                                        name="MEN"
                                                                        onChange={handleFileUpload}
                                                                        placeholder={""}
                                                                        fileArray={certMedico}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col
                                                                md={2}
                                                                className="align-self-start d-flex justify-content-start mt-3"
                                                            >
                                                                <Button
                                                                    onClick={() => handleClickSolicitarLCD()}
                                                                    disabled={
                                                                        errorDias !== "" ||
                                                                        mensajeError !== "" ||
                                                                        !validarCamposLPEFP()
                                                                    }
                                                                >
                                                                    SOLICITAR{" "}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                {tipoLicenciaSeleccionado === 25 && (
                                                    <>                                                        
                                                        <Row>
                                                            <Col md={3} className="pr-0">
                                                            <FormGroup>
                                                                <Label for="tipoMatrimonio" className="label-permiso">Modalidad de Solicitud*</Label>
                                                                <Input
                                                                    type="select"
                                                                    value={tipoMatrimonio}
                                                                    onChange={handleTipoMatrimonioChange}
                                                                    id="tipoMatrimonio"
                                                                >
                                                                    <option value="">SELECCIONE LA MODALIDAD</option>
                                                                    {(props.estadoCivil === "C" || props.estadoCivil === "U") ? (
                                                                        <option value="D">DESPUES DEL EVENTO</option>
                                                                    ) : (
                                                                        <>
                                                                            <option value="A">ANTES DEL EVENTO</option>
                                                                            <option value="D">DESPUES DEL EVENTO</option>
                                                                        </>
                                                                    )}
                                                                </Input>
                                                            </FormGroup>
                                                            </Col>
                                                            <Col md={1} className="pr-0">
                                                            <FormGroup>
                                                                <Label for="tipoIdentificacion" className="label-permiso">Tipo ID*</Label>
                                                                <Input
                                                                type="select"
                                                                value={tipoIdentificacion}
                                                                onChange={handleTipoIdentificacionChange}
                                                                        id="tipoIdentificacion"
                                                                >
                                                                    <option value="CED">CED</option>
                                                                    <option value="PAS">PAS</option>
                                                                </Input>
                                                            </FormGroup>
                                                            </Col>
                                                            {tipoIdentificacion === "CED" ? (
                                                                <>
                                                                    <Col md={3} sm={12} xs={12}>
                                                                        <FormGroup>
                                                                            <Label for="numeroidentificacion">Cédula del Cónyuge o Conviviente*</Label>
                                                                            <Input type="text" maxLength="10" name="numeroidentificacion" id="numeroidentificacion" value={cedulaConyugue} onChange={handleCedulaConyugue} required />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <FormGroup>
                                                                            <Label for="nombres">Cónyuge o Conviviente</Label>
                                                                            <Input type="text" maxLength="100" name="nombrecompleto" id="nombrecompleto" value={informacionConyugue?.nombrecompleto} required readOnly={true} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                </>
                                                            ) : (
                                                                    <>
                                                                        <Col md={3} sm={12} xs={12}>
                                                                            <FormGroup>
                                                                                <Label for="numeroidentificacion">Cédula del Cónyuge o Conviviente*</Label>
                                                                                <Input type="text" maxLength="10" name="numeroidentificacion" id="numeroidentificacion" value={cedulaConyugue} onChange={handlePasaporteConyugeChange} required />
                                                                            </FormGroup>
                                                                        </Col>
                                                                        <Col md={4}>
                                                                            <FormGroup>
                                                                                <Label for="nombres">Cónyuge o Conviviente*</Label>
                                                                                <Input type="text" value={nombreCompletoConyuge} onChange={handleConyugeChange} maxLength={100} id="observacion" required/>
                                                                            </FormGroup>
                                                                        </Col>
                                                                    </>
                                                            )}
                                                        </Row>
                                                        {tipoMatrimonio === "A" && (
                                                            <>
                                                                <Row>
                                                                    <Col md={3} className="pr-0">
                                                                        <FormGroup>
                                                                            <Label for="tipoEventoMatrimonio" className="label-permiso">Tipo de Evento*</Label>
                                                                            <Input
                                                                                type="select"
                                                                                value={tipoEventoMatrimonio}
                                                                                onChange={handleTipoEventoMatrimonioChange}
                                                                                id="tipoEventoMatrimonio"
                                                                            >
                                                                                <option value=""></option>
                                                                                <option value="C">MATRIMONIO</option>
                                                                                <option value="U">UNIÓN DE HECHO</option>
                                                                            </Input>
                                                                        </FormGroup>
                                                                    </Col>
                                                                <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaEvento"
                                                                        className="label-permiso"
                                                                    >Fecha Evento*
                                                                    </Label>
                                                                    {DatePickerLicenciaEvento(true)}
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaDesde"
                                                                        className="label-permiso"
                                                                    >
                                                                    Fecha Desde*
                                                                    </Label>
                                                                    {DatePickerMatrimonioDesde(true)}
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaHasta"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Hasta
                                                                    </Label>
                                                                    <Input
                                                                        value={stateCard.fechaHasta? formatDateToString(stateCard.fechaHasta): ""}
                                                                        disabled
                                                                        style={{ minHeight: "30px" }}
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="diasSolicitados"
                                                                        className="label-permiso"
                                                                    >
                                                                        Días solicitados
                                                                    </Label>
                                                                    <Input
                                                                        disabled={!habilitarIngresoHoras}
                                                                        type="text"
                                                                        value={diasSolicitados}
                                                                        readOnly
                                                                        id="horas_solicitadas"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                        <Row>
                                                            <Col md={6} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Observación (Máximo 100 caracteres)
                                                                    </Label>
                                                                    <Input
                                                                        type="text"
                                                                        value={observacionPermiso}
                                                                        onChange={handleObservacionChange}
                                                                        maxLength={140}
                                                                        id="observacion"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                                    </Col>
                                                                    {fechaEventoMenor === false && (
                                                                        <>                                                                        
                                                            <Col
                                                                md={2}
                                                                className="align-self-start d-flex justify-content-start mt-3"
                                                            >
                                                                <Button
                                                                    onClick={() => handleClickSolicitarLCD()}
                                                                    disabled={
                                                                        errorDias !== "" ||
                                                                        mensajeError !== "" ||
                                                                        mensajeErrorCRN !== "" ||
                                                                        !validarCamposLPMtAntes()
                                                                    }
                                                                >
                                                                    SOLICITAR{" "}
                                                                </Button>
                                                                            </Col></>
                                                                    )}
                                                                    {fechaEventoMenor === true && (
                                                                        <>
                                                                            <Col md={2} className="pr-0">
                                                                                <FormGroup>
                                                                                    <Label
                                                                                        for="archivo"
                                                                                        className="label-permiso"
                                                                                    >
                                                                                        Subir evidencia*
                                                                                    </Label>
                                                                                    <InputFileUpload2
                                                                                        icon="upload"
                                                                                        name="MEN"
                                                                                        onChange={handleFileUpload}
                                                                                        placeholder={""}
                                                                                        fileArray={certMedico}
                                                                                    />
                                                                                </FormGroup>
                                                                            </Col>
                                                                            <Col
                                                                                md={2}
                                                                                className="align-self-start d-flex justify-content-start mt-3"
                                                                            >
                                                                                <Button
                                                                                    onClick={() => handleClickSolicitarLCD()}
                                                                                    disabled={
                                                                                        errorDias !== "" ||
                                                                                        mensajeError !== "" ||
                                                                                        mensajeErrorCRN !== "" ||
                                                                                        !validarCamposLPMtAntesMenor()
                                                                                    }
                                                                                >
                                                                                    SOLICITAR{" "}
                                                                                </Button>
                                                                            </Col></>
                                                                    )}
                                                            
                                                        </Row>
                                                        <Row className="rowErroresHoras">
                                                            <Col md={{ size: 12 }}>
                                                                <small className="message-medium ">
                                                                    {mensajeTiempoPermiso}
                                                                </small>
                                                            </Col>
                                                        </Row>    
                                                            </>
                                                        )}
                                                        {tipoMatrimonio === "D" && (
                                                            <>
                                                                <Row>
                                                                    <Col md={3} className="pr-0">
                                                                        <FormGroup>
                                                                            <Label for="tipoEventoMatrimonio" className="label-permiso">Tipo de Evento*</Label>
                                                                            <Input
                                                                                type="select"
                                                                                value={tipoEventoMatrimonio}
                                                                                onChange={handleTipoEventoMatrimonioChange}
                                                                                id="tipoEventoMatrimonio"
                                                                            >
                                                                                <option value=""></option>
                                                                                <option value="C">MATRIMONIO</option>
                                                                                <option value="U">UNIÓN DE HECHO</option>
                                                                            </Input>
                                                                        </FormGroup>
                                                                    </Col>
                                                                <Col md={2} className="pr-0">
                                                                    <FormGroup>
                                                                        <Label
                                                                            for="fechaEvento"
                                                                            className="label-permiso"
                                                                        >Fecha Evento*
                                                                        </Label>
                                                                        {DatePickerLicenciaEvento(true)}
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col md={2} className="pr-0">
                                                                    <FormGroup>
                                                                        <Label
                                                                            for="fechaDesde"
                                                                            className="label-permiso"
                                                                        >
                                                                            Fecha Desde*
                                                                        </Label>
                                                                            {DatePickerMatrimonioDesde(true)}
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col md={2} className="pr-0">
                                                                    <FormGroup>
                                                                        <Label
                                                                            for="fechaHasta"
                                                                            className="label-permiso"
                                                                        >
                                                                            Fecha Hasta
                                                                        </Label>
                                                                        <Input
                                                                            value={stateCard.fechaHasta ? formatDateToString(stateCard.fechaHasta) : ""}
                                                                            disabled
                                                                            style={{ minHeight: "30px" }}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col md={2} className="pr-0">
                                                                    <FormGroup>
                                                                        <Label
                                                                            for="diasSolicitados"
                                                                            className="label-permiso"
                                                                        >
                                                                            Días solicitados
                                                                        </Label>
                                                                        <Input
                                                                            disabled={!habilitarIngresoHoras}
                                                                            type="text"
                                                                            value={diasSolicitados}
                                                                            readOnly
                                                                            id="horas_solicitadas"
                                                                            style={{ minHeight: "30px" }}
                                                                        ></Input>
                                                                    </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={6} className="pr-0">
                                                                        <FormGroup>
                                                                            <Label
                                                                                for="archivo"
                                                                                className="label-permiso"
                                                                            >
                                                                                Observación (Máximo 100 caracteres)
                                                                            </Label>
                                                                            <Input
                                                                                type="text"
                                                                                value={observacionPermiso}
                                                                                onChange={handleObservacionChange}
                                                                                maxLength={140}
                                                                                id="observacion"
                                                                                style={{ minHeight: "30px" }}
                                                                            ></Input>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    {fechaEventoMenor === false && (
                                                                        <>
                                                                            <Col
                                                                                md={2}
                                                                                className="align-self-start d-flex justify-content-start mt-3"
                                                                            >
                                                                                <Button
                                                                                    onClick={() => handleClickSolicitarLCD()}
                                                                                    disabled={
                                                                                        errorDias !== "" ||
                                                                                        mensajeError !== "" ||
                                                                                        mensajeErrorCRN !== "" ||
                                                                                        !validarCamposLPMtDespues()
                                                                                    }
                                                                                >
                                                                                    SOLICITAR{" "}
                                                                                </Button>
                                                                            </Col>
                                                                        </>
                                                                    )}
                                                                    {fechaEventoMenor === true && (
                                                                        <>
                                                                            <Col md={2} className="pr-0">
                                                                                <FormGroup>
                                                                                    <Label
                                                                                        for="archivo"
                                                                                        className="label-permiso"
                                                                                    >
                                                                                        Subir evidencia*
                                                                                    </Label>
                                                                                    <InputFileUpload2
                                                                                        icon="upload"
                                                                                        name="MEN"
                                                                                        onChange={handleFileUpload}
                                                                                        placeholder={""}
                                                                                        fileArray={certMedico}
                                                                                    />
                                                                                </FormGroup>
                                                                            </Col>
                                                                            <Col
                                                                                md={2}
                                                                                className="align-self-start d-flex justify-content-start mt-3"
                                                                            >
                                                                                <Button
                                                                                    onClick={() => handleClickSolicitarLCD()}
                                                                                    disabled={
                                                                                        errorDias !== "" ||
                                                                                        mensajeError !== "" ||
                                                                                        mensajeErrorCRN !== "" ||
                                                                                        !validarCamposLPMtDespuesMenor()
                                                                                    }
                                                                                >
                                                                                    SOLICITAR{" "}
                                                                                </Button>
                                                                            </Col></>
                                                                    )}                                                                    
                                                                </Row>
                                                                <Row className="rowErroresHoras">
                                                                    <Col md={{ size: 12 }}>
                                                                        <small className="message-medium ">
                                                                            {mensajeTiempoPermiso}
                                                                        </small>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                                {tipoLicenciaSeleccionado === 16 && (
                                                    <>
                                                        <Row>
                                                            <Col md={4} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="tipoCalamidad"
                                                                        className="label-permiso"
                                                                    >
                                                                        Tipo de certificado*
                                                                    </Label>
                                                                    <SelectItem2
                                                                        options={tiposCertificadosEG.map(
                                                                            (tipo) => ({
                                                                                value: tipo.idprnsubtipopermisos,
                                                                                label: tipo.nombre,
                                                                            })
                                                                        )}
                                                                        placeholder=""
                                                                        name="tipoPermiso"
                                                                        id="tipoPermiso"
                                                                        icon="fa-caret-down"
                                                                        value={tipoCertificadoEGSeleccionado}
                                                                        onChange={handleTipoCertificadoEGChange}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaEvento"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Evento*
                                                                    </Label>
                                                                    {DatePickerLicenciaEvento(true)}
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaDesde"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Desde
                                                                    </Label>
                                                                    <Input
                                                                        value={
                                                                            stateCard.fechaDesde
                                                                                ? formatDateToString(
                                                                                    stateCard.fechaDesde
                                                                                )
                                                                                : ""
                                                                        }
                                                                        disabled
                                                                        style={{ minHeight: "30px" }}
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaHasta"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Hasta*
                                                                    </Label>
                                                                    {DatePickerLicenciaFin(true)}
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="diasSolicitados"
                                                                        className="label-permiso"
                                                                    >
                                                                        Días solicitados
                                                                    </Label>
                                                                    <Input
                                                                        disabled={!habilitarIngresoHoras}
                                                                        type="text"
                                                                        value={diasSolicitados}
                                                                        style={{ minHeight: "30px" }}
                                                                        readOnly
                                                                        id="horas_solicitadas"
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Observación (Máximo 100 caracteres)
                                                                    </Label>
                                                                    <Input
                                                                        type="text"
                                                                        value={observacionPermiso}
                                                                        onChange={handleObservacionChange}
                                                                        maxLength={140}
                                                                        id="observacion"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Subir evidencia*
                                                                    </Label>
                                                                    <InputFileUpload2
                                                                        icon="upload"
                                                                        name="MEN"
                                                                        onChange={handleFileUpload}
                                                                        placeholder={""}
                                                                        fileArray={certMedico}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col
                                                                md={2}
                                                                className="align-self-start d-flex justify-content-start mt-3"
                                                            >
                                                                <Button
                                                                    onClick={() => handleClickSolicitarLCD()}
                                                                    disabled={
                                                                        errorDias !== "" ||
                                                                        mensajeError !== "" ||
                                                                        !validarCamposLPEG()
                                                                    }
                                                                >
                                                                    SOLICITAR{" "}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                {(tipoLicenciaSeleccionado === 36 || tipoLicenciaSeleccionado === 37) && (
                                                    <>
                                                        <Row>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaEvento"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Desde*
                                                                    </Label>
                                                                    {DatePickerLicenciaEvento(true)}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="fechaHasta"
                                                                        className="label-permiso"
                                                                    >
                                                                        Fecha Hasta*
                                                                    </Label>
                                                                    {DatePickerLicenciaFin(true)}
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="diasSolicitados"
                                                                        className="label-permiso"
                                                                    >
                                                                        Días solicitados
                                                                    </Label>
                                                                    <Input
                                                                        disabled={!habilitarIngresoHoras}
                                                                        type="text"
                                                                        value={diasSolicitados}
                                                                        readOnly
                                                                        id="horas_solicitadas"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>

                                                            <Col md={1} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="horaInicio"
                                                                        className="label-permiso"
                                                                    >
                                                                        Hora inicio*
                                                                    </Label>
                                                                    {inputHoraDesde()}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={1} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="horaInicio"
                                                                        className="label-permiso"
                                                                    >
                                                                        Hora fin*
                                                                    </Label>
                                                                    {inputHoraHasta()}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={1} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="diasSolicitados"
                                                                        className="label-permiso"
                                                                    >
                                                                        Horas solicitadas
                                                                    </Label>
                                                                    <Input
                                                                        disabled={!habilitarIngresoHoras}
                                                                        type="text"
                                                                        value={
                                                                            horasSolicitadas === undefined
                                                                                ? ""
                                                                                : horasSolicitadas
                                                                        }
                                                                        readOnly
                                                                        id="horas_solicitadas"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Observación (Máximo 100 caracteres)
                                                                    </Label>
                                                                    <Input
                                                                        type="text"
                                                                        value={observacionPermiso}
                                                                        onChange={handleObservacionChange}
                                                                        maxLength={140}
                                                                        id="observacion"
                                                                        style={{ minHeight: "30px" }}
                                                                    ></Input>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2} className="pr-0">
                                                                <FormGroup>
                                                                    <Label
                                                                        for="archivo"
                                                                        className="label-permiso"
                                                                    >
                                                                        Subir evidencia*
                                                                    </Label>
                                                                    <InputFileUpload2
                                                                        icon="upload"
                                                                        name="MEN"
                                                                        onChange={handleFileUpload}
                                                                        placeholder={""}
                                                                        fileArray={certMedico}
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col
                                                                md={2}
                                                                className="align-self-start d-flex justify-content-start mt-3"
                                                            >
                                                                <Button
                                                                    onClick={() => handleClickSolicitarLCD()}
                                                                    disabled={
                                                                        errorDias !== "" ||
                                                                        mensajeError !== "" ||
                                                                        errorHoras !== "" ||
                                                                        !validarCamposLR()
                                                                    }
                                                                >
                                                                    SOLICITAR{" "}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                {SolicitudesPermisos}
                                            </Form>
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>
                        </div>
                    </CardBody>
                </Card>
                {ModalEliminarSolicitudesPermisos}

                {ModalEditarSolicitudesPermisos}
                {ModalEliminarSolicitudesCambioHorario}

                <ModalVistaPreviaDocumentos
                    cargandoDatos={stateModalVP.loading}
                    onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                    show={stateModalVP.loading || stateModalVP.url !== ""}
                    size="xl"
                    tituloModal="Documento solicitud"
                    urlArchivo={stateModalVP.url}
                    botonCerrar={true}
                />

                <ModalVistaPreviaDocumentosAccion
                    show={
                        stateModalFormulario.url !== "" ||
                        stateModalFormulario.loadingFormulario
                    }
                    accionOnAccept={true}
                    cargandoDatos={stateModalFormulario.loadingFormulario}
                    onClose={() => limpiarFechasCardYModal()}
                    size="xl"
                    tituloModal={stateModalFormulario.tituloModal}
                    urlArchivo={stateModalFormulario.url}
                    disabledbuttonCondition={stateModalFormulario.loadingFormulario}
                    onAccion={() =>
                        handleClickConfirmar(stateModalFormulario.solicitudNueva)
                    }
                    modalContent={stateModalFormulario.content}
                />

                <ModalVistaPreviaDocumentosAccion
                    show={
                        stateModalFormularioCH.url !== "" ||
                        stateModalFormularioCH.loadingFormulario
                    }
                    accionOnAccept={true}
                    cargandoDatos={stateModalFormularioCH.loadingFormulario}
                    onClose={() => limpiarFechasCardYModal()}
                    size="xl"
                    tituloModal={stateModalFormularioCH.tituloModal}
                    urlArchivo={stateModalFormularioCH.url}
                    disabledbuttonCondition={stateModalFormularioCH.loadingFormulario}
                    onAccion={() =>
                        handleClickConfirmarCH(stateModalFormularioCH.solicitudNueva, props.idRegimenLaboralS)
                    }
                    modalContent={stateModalFormularioCH.content}
                />
                <ModalCambiarHorarioCRN
                isOpen={modalOpenCH}
                toggle={toggleModal}
                onSave={handleSave}
                feriados={props.feriados}
                empHorario={empHorario ? empHorario : []}
                horarioLaboralRegimen={props.horarioLaboralRegimen}
                fechaDesdeActual={resolvedData.fechaDesde}
                fechaHastaActual={resolvedData.fechaHasta}
                horaDesdeActual={resolvedData.horaDesde}
                horaHastaActual={resolvedData.horaHasta}
                horaDesdeTardeActual={resolvedData.horaDesdeTarde}
                horaHastaTardeActual={resolvedData.horaHastaTarde}
                idRegimenLaboral={props.idRegimenLaboralS}
                listadoHorarios={horariosCambioRN}
                archivo={permisosCambioRN[0]?.archivo ?? ""}
                />
                <ModalRegistrarInfante
                    isOpenRegistrarInfante={modalOpenRI}
                    toggleRegistrarInfante={() => setModalOpenRI(!modalOpenRI)}
                    onClose={handleModalClose}
                subtipoMaternidad={licenciasTipo3[0]?.subtipo || 'ValorPorDefecto'}
                />

            </>
        );
    }

    function addDays(fechaInicio: string | Date, arg1: number) {
        throw new Error('Function not implemented.');
    }
